// // // "use client";

// // // import { useState, useEffect, useRef } from "react";
// // // import {
// // //   Grid,
// // //   Card,
// // //   Typography,
// // //   Button,
// // //   Box,
// // //   Chip,
// // //   TextField,
// // //   FormControl,
// // //   Select,
// // //   MenuItem,
// // //   Paper,
// // //   Avatar,
// // //   IconButton,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   List,
// // //   ListItem,
// // //   ListItemText,
// // //   ListItemIcon,
// // //   Tabs,
// // //   Tab,
// // //   Alert,
// // //   CircularProgress,
// // //   Stack,
// // //   Skeleton,
// // //   alpha,
// // //   InputAdornment,
// // //   Divider,
// // // } from "@mui/material";
// // // import {
// // //   Work,
// // //   LocationOn,
// // //   AttachMoney,
// // //   Bookmark,
// // //   BookmarkBorder,
// // //   Share,
// // //   Search,
// // //   Business,
// // //   CheckCircle,
// // //   CalendarToday,
// // //   TrendingUp,
// // //   Undo as UndoIcon,
// // //   Description,
// // //   PlaylistAddCheck,
// // //   Category,
// // //   Stars,
// // //   Replay as ReplayIcon,
// // // } from "@mui/icons-material";
// // // import Layout from "../common/Layout";
// // // import { useNotification } from "../../context/NotificationContext";
// // // import apiClient from "../../context/apiClient";
// // // import { useTheme } from "@mui/material/styles";
// // // import { useInView } from "react-intersection-observer";

// // // const AnimatedMatchScore = ({ score }) => {
// // //   const theme = useTheme();
// // //   const [progress, setProgress] = useState(0);
// // //   useEffect(() => {
// // //     const timer = setTimeout(() => {
// // //       setProgress(score);
// // //     }, 500);
// // //     return () => clearTimeout(timer);
// // //   }, [score]);
// // //   const getScoreColor = () => {
// // //     if (score >= 70) return theme.palette.success.main;
// // //     if (score >= 40) return theme.palette.warning.main;
// // //     return theme.palette.error.main;
// // //   };
// // //   return (
// // //     <Box sx={{ position: "relative", display: "inline-flex" }}>
// // //       <CircularProgress
// // //         variant="determinate"
// // //         sx={{ color: (theme) => theme.palette.divider }}
// // //         size={56}
// // //         thickness={4}
// // //         value={100}
// // //       />
// // //       <CircularProgress
// // //         variant="determinate"
// // //         value={progress}
// // //         size={56}
// // //         thickness={4}
// // //         sx={{
// // //           color: getScoreColor(),
// // //           position: "absolute",
// // //           left: 0,
// // //           transition: "transform 1s ease-out",
// // //           transform: "rotate(-90deg) !important",
// // //         }}
// // //       />
// // //       <Box
// // //         sx={{
// // //           top: 0,
// // //           left: 0,
// // //           bottom: 0,
// // //           right: 0,
// // //           position: "absolute",
// // //           display: "flex",
// // //           alignItems: "center",
// // //           justifyContent: "center",
// // //           flexDirection: "column",
// // //         }}
// // //       >
// // //         <Typography
// // //           variant="subtitle1"
// // //           component="div"
// // //           color="text.primary"
// // //           fontWeight="bold"
// // //           sx={{ fontSize: "14px" }}
// // //         >{`${Math.round(score)}%`}</Typography>
// // //       </Box>
// // //     </Box>
// // //   );
// // // };

// // // const AnimatedJobCard = ({
// // //   job,
// // //   handleViewJob,
// // //   handleSaveJob,
// // //   handleApplyJob,
// // //   handleUndoApplication,
// // //   handleReapplyJob,
// // //   isSaving,
// // //   isApplying,
// // //   showUndoButton,
// // //   showReapplyButton,
// // //   hideSaveButton,
// // //   isSavedTab,
// // // }) => {
// // //   const theme = useTheme();
// // //   const { ref, inView } = useInView({
// // //     triggerOnce: true,
// // //     threshold: 0.1,
// // //     rootMargin: "0px 0px -50px 0px",
// // //   });

// // //   // This is the new, clean mobile layout.
// // //   const MobileLayout = () => (
// // //     <Stack sx={{ p: 2, gap: 2 }}>
// // //       {/* SECTION 1: HEADER (Logo, Title, Company) */}
// // //       <Stack direction="row" spacing={2} alignItems="center">
// // //         <Avatar
// // //           src={job.logo}
// // //           sx={{ width: 48, height: 48 }}
// // //           alt={`${job.company} logo`}
// // //         />
// // //         <Box sx={{ minWidth: 0 }}>
// // //           <Typography
// // //             variant="h6"
// // //             sx={{
// // //               fontWeight: 600,
// // //               fontSize: "1rem",
// // //               overflow: "hidden",
// // //               textOverflow: "ellipsis",
// // //               whiteSpace: "nowrap",
// // //             }}
// // //           >
// // //             {job.title}
// // //           </Typography>
// // //           <Typography variant="body2" color="text.secondary">
// // //             {job.company}
// // //           </Typography>
// // //         </Box>
// // //       </Stack>

// // //       {/* SECTION 2: BODY (Key Details as Chips) */}
// // //       <Stack direction="row" flexWrap="wrap" gap={1}>
// // //         <Chip
// // //           icon={<LocationOn />}
// // //           label={job.location}
// // //           size="small"
// // //           variant="outlined"
// // //         />
// // //         <Chip
// // //           icon={<Work />}
// // //           label={job.experience}
// // //           size="small"
// // //           variant="outlined"
// // //         />
// // //         <Chip
// // //           icon={<AttachMoney />}
// // //           label={job.salary}
// // //           size="small"
// // //           variant="outlined"
// // //         />
// // //         {job.visaSponsorship && (
// // //           <Chip label="Visa Sponsored" size="small" color="primary" />
// // //         )}
// // //       </Stack>

// // //       <Typography variant="caption" color="text.secondary">
// // //         <CalendarToday
// // //           sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
// // //         />
// // //         Posted {job.posted}
// // //       </Typography>

// // //       {/* SEPARATOR */}
// // //       <Divider sx={{ my: 1 }} />

// // //       {/* SECTION 3: FOOTER (AI Score and Actions) */}
// // //       <Box
// // //         sx={{
// // //           display: "flex",
// // //           justifyContent: "space-between",
// // //           alignItems: "center",
// // //         }}
// // //       >
// // //         <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
// // //           <AnimatedMatchScore score={job.matchScore} />
// // //           <Typography
// // //             variant="caption"
// // //             sx={{
// // //               fontWeight: "bold",
// // //               display: "block",
// // //               mt: 0.5,
// // //               color: "primary.main",
// // //             }}
// // //           >
// // //             AI Match
// // //           </Typography>
// // //         </Box>

// // //         {/* Re-using the same button logic */}
// // //         <Stack direction="row" spacing={1} alignItems="center">
// // //           {job.applied ? (
// // //             job.applicationStatus === "Withdrawn" && showReapplyButton ? (
// // //               <Button
// // //                 variant="contained"
// // //                 color="secondary"
// // //                 size="small"
// // //                 onClick={(e) => {
// // //                   e.stopPropagation();
// // //                   handleReapplyJob(job.applicationId, job.id);
// // //                 }}
// // //                 disabled={isApplying === job.id}
// // //                 sx={{ textTransform: "none" }}
// // //               >
// // //                 Re-apply
// // //               </Button>
// // //             ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
// // //               <Button
// // //                 variant="outlined"
// // //                 color="error"
// // //                 size="small"
// // //                 onClick={(e) => {
// // //                   e.stopPropagation();
// // //                   handleUndoApplication(job.applicationId, job.id);
// // //                 }}
// // //                 disabled={isApplying === job.id}
// // //                 sx={{ textTransform: "none" }}
// // //               >
// // //                 Withdraw
// // //               </Button>
// // //             ) : (
// // //               <Button
// // //                 disabled
// // //                 variant="contained"
// // //                 startIcon={<CheckCircle />}
// // //                 size="small"
// // //                 sx={{
// // //                   textTransform: "none",
// // //                   "&.Mui-disabled": {
// // //                     backgroundColor: alpha(theme.palette.success.main, 0.2),
// // //                     color: "success.dark",
// // //                   },
// // //                 }}
// // //               >
// // //                 {job.applicationStatus || "Applied"}
// // //               </Button>
// // //             )
// // //           ) : (
// // //             <Button
// // //               variant="contained"
// // //               size="small"
// // //               color="primary"
// // //               disabled={isApplying === job.id}
// // //               onClick={(e) => {
// // //                 e.stopPropagation();
// // //                 handleApplyJob(job.id);
// // //               }}
// // //               sx={{
// // //                 textTransform: "none",
// // //               }}
// // //             >
// // //               {isApplying === job.id ? (
// // //                 <CircularProgress size={16} color="inherit" />
// // //               ) : (
// // //                 "Apply"
// // //               )}
// // //             </Button>
// // //           )}
// // //           {!hideSaveButton && (
// // //             <IconButton
// // //               size="small"
// // //               disabled={isSaving === job.id}
// // //               onClick={(e) => {
// // //                 e.stopPropagation();
// // //                 handleSaveJob(job.id);
// // //               }}
// // //               sx={{
// // //                 border: (theme) => `1px solid ${theme.palette.divider}`,
// // //                 color: job.saved ? "primary.main" : "text.secondary",
// // //               }}
// // //             >
// // //               {isSaving === job.id ? (
// // //                 <CircularProgress size={20} />
// // //               ) : job.saved ? (
// // //                 <Bookmark fontSize="small" />
// // //               ) : (
// // //                 <BookmarkBorder fontSize="small" />
// // //               )}
// // //             </IconButton>
// // //           )}
// // //         </Stack>
// // //       </Box>
// // //     </Stack>
// // //   );

// // //   // This is your original, excellent desktop layout.
// // //   const DesktopLayout = () => (
// // //     <>
// // //       <Box sx={{ display: "flex", flex: 1, gap: 2 }}>
// // //         <Avatar
// // //           src={job.logo}
// // //           sx={{ width: 48, height: 48, mt: 0.5 }}
// // //           alt={`${job.company} logo`}
// // //         />
// // //         <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
// // //           <Typography
// // //             variant="h6"
// // //             sx={{
// // //               fontWeight: 600,
// // //               fontSize: "16px",
// // //               color: "text.primary",
// // //               overflow: "hidden",
// // //               textOverflow: "ellipsis",
// // //               whiteSpace: "nowrap",
// // //             }}
// // //           >
// // //             {job.title}
// // //           </Typography>
// // //           <Typography
// // //             variant="body2"
// // //             sx={{ fontSize: "14px", color: "text.secondary", fontWeight: 500 }}
// // //           >
// // //             {job.company}
// // //           </Typography>
// // //           <Stack direction="row" spacing={2} alignItems="center">
// // //             <Typography
// // //               variant="body2"
// // //               sx={{ fontSize: "13px", color: "text.secondary" }}
// // //             >
// // //               <LocationOn
// // //                 sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
// // //               />
// // //               {job.location}
// // //             </Typography>
// // //             <Typography
// // //               variant="body2"
// // //               sx={{ fontSize: "13px", color: "text.secondary" }}
// // //             >
// // //               <Work sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }} />
// // //               {job.experience}
// // //             </Typography>
// // //           </Stack>
// // //           <Typography
// // //             variant="body2"
// // //             sx={{ fontSize: "13px", color: "text.secondary" }}
// // //           >
// // //             <AttachMoney
// // //               sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
// // //             />
// // //             {job.salary}
// // //           </Typography>
// // //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
// // //             {job.visaSponsorship && (
// // //               <Chip
// // //                 label="Visa Sponsored"
// // //                 size="small"
// // //                 color="primary"
// // //                 sx={{
// // //                   fontSize: "11px",
// // //                   height: "auto",
// // //                   p: "4px 8px",
// // //                 }}
// // //               />
// // //             )}
// // //             {job.requirements.slice(0, 5).map((skill, index) => (
// // //               <Chip
// // //                 key={index}
// // //                 label={skill}
// // //                 size="small"
// // //                 sx={{
// // //                   bgcolor: "action.selected",
// // //                   color: "primary.main",
// // //                   borderRadius: "6px",
// // //                   fontSize: "12px",
// // //                   height: "auto",
// // //                   p: "4px 8px",
// // //                 }}
// // //               />
// // //             ))}
// // //           </Box>
// // //           <Typography
// // //             variant="caption"
// // //             sx={{ color: "text.secondary", fontSize: "12px", mt: 1 }}
// // //           >
// // //             <CalendarToday
// // //               sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
// // //             />
// // //             Posted {job.posted}
// // //           </Typography>
// // //         </Stack>
// // //       </Box>
// // //       <Stack
// // //         spacing={2}
// // //         alignItems="center"
// // //         justifyContent="center"
// // //         sx={{ width: "120px", flexShrink: 0, pl: 2 }}
// // //       >
// // //         <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
// // //           <AnimatedMatchScore score={job.matchScore} />
// // //           <Chip
// // //             label="AI Match"
// // //             size="small"
// // //             color="primary"
// // //             icon={<TrendingUp />}
// // //             onClick={(e) => e.stopPropagation()}
// // //             sx={{
// // //               fontSize: "11px",
// // //               mt: 1,
// // //               height: "auto",
// // //               p: "4px 8px",
// // //               "& .MuiChip-icon": {
// // //                 color: "primary.contrastText",
// // //                 fontSize: "14px",
// // //               },
// // //             }}
// // //           />
// // //         </Box>
// // //         <Stack direction="row" spacing={1} alignItems="center">
// // //           {job.applied ? (
// // //             job.applicationStatus === "Withdrawn" && showReapplyButton ? (
// // //               <Button
// // //                 variant="contained"
// // //                 color="secondary"
// // //                 startIcon={
// // //                   isApplying === job.id ? (
// // //                     <CircularProgress size={16} color="inherit" />
// // //                   ) : (
// // //                     <ReplayIcon />
// // //                   )
// // //                 }
// // //                 size="small"
// // //                 disabled={isApplying === job.id}
// // //                 onClick={(e) => {
// // //                   e.stopPropagation();
// // //                   handleReapplyJob(job.applicationId, job.id);
// // //                 }}
// // //                 sx={{
// // //                   fontSize: "0.75rem",
// // //                   borderRadius: 2,
// // //                   px: 2,
// // //                   py: 1,
// // //                   textTransform: "none",
// // //                 }}
// // //               >
// // //                 Re-apply
// // //               </Button>
// // //             ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
// // //               <Button
// // //                 variant="outlined"
// // //                 color="error"
// // //                 startIcon={
// // //                   isApplying === job.id ? (
// // //                     <CircularProgress size={16} color="inherit" />
// // //                   ) : (
// // //                     <UndoIcon />
// // //                   )
// // //                 }
// // //                 size="small"
// // //                 disabled={isApplying === job.id}
// // //                 onClick={(e) => {
// // //                   e.stopPropagation();
// // //                   handleUndoApplication(job.applicationId, job.id);
// // //                 }}
// // //                 sx={{
// // //                   fontSize: "0.75rem",
// // //                   borderRadius: 2,
// // //                   px: 2,
// // //                   py: 1,
// // //                   borderColor: alpha(theme.palette.error.main, 0.5),
// // //                   "&:hover": {
// // //                     backgroundColor: alpha(theme.palette.error.main, 0.08),
// // //                     borderColor: "error.main",
// // //                   },
// // //                 }}
// // //               >
// // //                 Withdraw
// // //               </Button>
// // //             ) : (
// // //               <Button
// // //                 disabled
// // //                 variant="contained"
// // //                 startIcon={<CheckCircle />}
// // //                 size="small"
// // //                 sx={{
// // //                   fontSize: "0.75rem",
// // //                   borderRadius: 2,
// // //                   textTransform: "none",
// // //                   "&.Mui-disabled": {
// // //                     backgroundColor: alpha(theme.palette.success.main, 0.2),
// // //                     color: "success.dark",
// // //                   },
// // //                 }}
// // //               >
// // //                 {job.applicationStatus || "Applied"}
// // //               </Button>
// // //             )
// // //           ) : (
// // //             <Button
// // //               variant="contained"
// // //               color="primary"
// // //               size="small"
// // //               disabled={isApplying === job.id}
// // //               onClick={(e) => {
// // //                 e.stopPropagation();
// // //                 handleApplyJob(job.id);
// // //               }}
// // //               sx={{
// // //                 width: "72px",
// // //                 height: "32px",
// // //                 fontSize: "13px",
// // //                 fontWeight: "600",
// // //                 borderRadius: "6px",
// // //                 textTransform: "none",
// // //                 boxShadow: "none",
// // //                 "&:hover": {
// // //                   boxShadow: "none",
// // //                 },
// // //               }}
// // //             >
// // //               {isApplying === job.id ? (
// // //                 <CircularProgress size={16} color="inherit" />
// // //               ) : (
// // //                 "Apply"
// // //               )}
// // //             </Button>
// // //           )}
// // //           {!hideSaveButton && (
// // //             <IconButton
// // //               size="small"
// // //               disabled={isSaving === job.id}
// // //               onClick={(e) => {
// // //                 e.stopPropagation();
// // //                 handleSaveJob(job.id);
// // //               }}
// // //               sx={{
// // //                 border: (theme) => `1px solid ${theme.palette.divider}`,
// // //                 color: job.saved ? "primary.main" : "text.secondary",
// // //                 mr: isSavedTab ? 1 : 0,
// // //               }}
// // //             >
// // //               {isSaving === job.id ? (
// // //                 <CircularProgress size={20} />
// // //               ) : job.saved ? (
// // //                 <Bookmark fontSize="small" />
// // //               ) : (
// // //                 <BookmarkBorder fontSize="small" />
// // //               )}
// // //             </IconButton>
// // //           )}
// // //         </Stack>
// // //       </Stack>
// // //     </>
// // //   );

// // //   return (
// // //     <Card
// // //       ref={ref}
// // //       variant="outlined"
// // //       sx={{
// // //         borderRadius: "12px",
// // //         backgroundColor: "mint.main",
// // //         boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
// // //         transition: "all 0.3s ease-in-out",
// // //         opacity: inView ? 1 : 0,
// // //         transform: inView ? "translateY(0)" : "translateY(20px)",
// // //         "&:hover": {
// // //           boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
// // //           transform: "translateY(-4px)",
// // //         },
// // //         cursor: "pointer",
// // //       }}
// // //       onClick={() => handleViewJob(job)}
// // //     >
// // //       {/* Conditionally render layouts based on screen size */}
// // //       <Box sx={{ display: { xs: "block", sm: "none" } }}>
// // //         <MobileLayout />
// // //       </Box>
// // //       <Box sx={{ display: { xs: "none", sm: "flex" }, p: 2, width: "100%" }}>
// // //         <DesktopLayout />
// // //       </Box>
// // //     </Card>
// // //   );
// // // };

// // // const JobCardSkeleton = () => {
// // //   return (
// // //     <Card variant="outlined" sx={{ backgroundColor: "background.paper", p: 3 }}>
// // //       <Box sx={{ display: "flex", height: "100%", gap: 3 }}>
// // //         <Box sx={{ flex: 1 }}>
// // //           <Stack spacing={2}>
// // //             <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
// // //               <Skeleton variant="circular" width={56} height={56} />
// // //               <Box sx={{ flex: 1 }}>
// // //                 <Skeleton
// // //                   variant="text"
// // //                   width="80%"
// // //                   height={28}
// // //                   sx={{ mb: 0.5 }}
// // //                 />
// // //                 <Skeleton variant="text" width="60%" height={24} />
// // //               </Box>
// // //             </Box>
// // //             <Skeleton variant="text" width="40%" height={20} sx={{ ml: 9 }} />
// // //             <Box sx={{ display: "flex", gap: 2, ml: 9 }}>
// // //               <Skeleton variant="text" width={80} height={20} />
// // //               <Skeleton variant="text" width={120} height={20} />
// // //             </Box>
// // //             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", ml: 9 }}>
// // //               {[...Array(4)].map((_, index) => (
// // //                 <Skeleton
// // //                   key={index}
// // //                   variant="rectangular"
// // //                   width={Math.random() * 40 + 50}
// // //                   height={24}
// // //                   sx={{ borderRadius: 1 }}
// // //                 />
// // //               ))}
// // //             </Box>
// // //             <Skeleton variant="text" width="30%" height={20} sx={{ ml: 9 }} />
// // //           </Stack>
// // //         </Box>
// // //         <Box
// // //           sx={{
// // //             display: "flex",
// // //             flexDirection: "column",
// // //             alignItems: "center",
// // //             justifyContent: "space-between",
// // //             width: "120px",
// // //             flexShrink: 0,
// // //             py: 1,
// // //           }}
// // //         >
// // //           <Box
// // //             sx={{
// // //               display: "flex",
// // //               flexDirection: "column",
// // //               alignItems: "center",
// // //             }}
// // //           >
// // //             <Skeleton variant="circular" width={80} height={80} />
// // //             <Skeleton
// // //               variant="rectangular"
// // //               width={70}
// // //               height={24}
// // //               sx={{ mt: 1, borderRadius: 2 }}
// // //             />
// // //           </Box>
// // //           <Box sx={{ display: "flex", gap: 1 }}>
// // //             <Skeleton
// // //               variant="rectangular"
// // //               width={60}
// // //               height={36}
// // //               sx={{ borderRadius: 2 }}
// // //             />
// // //             <Skeleton variant="circular" width={36} height={36} />
// // //           </Box>
// // //         </Box>
// // //       </Box>
// // //     </Card>
// // //   );
// // // };

// // // const FilterSkeleton = () => {
// // //   return (
// // //     <Paper
// // //       variant="outlined"
// // //       sx={{ p: 2, backgroundColor: "background.paper" }}
// // //     >
// // //       <Stack spacing={3}>
// // //         <Box
// // //           sx={{
// // //             display: "flex",
// // //             justifyContent: "space-between",
// // //             alignItems: "center",
// // //           }}
// // //         >
// // //           <Skeleton variant="text" width={80} height={28} />
// // //           <Skeleton variant="text" width={60} height={24} />
// // //         </Box>
// // //         <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 2 }} />
// // //         {[...Array(3)].map((_, index) => (
// // //           <Skeleton
// // //             key={index}
// // //             variant="rectangular"
// // //             height={40}
// // //             sx={{ borderRadius: 2 }}
// // //           />
// // //         ))}
// // //         <Box>
// // //           <Stack spacing={1}>
// // //             {[...Array(2)].map((_, index) => (
// // //               <Box
// // //                 key={index}
// // //                 sx={{ display: "flex", alignItems: "center", gap: 1 }}
// // //               >
// // //                 <Skeleton variant="rectangular" width={20} height={20} />
// // //                 <Skeleton variant="text" width={120} height={20} />
// // //               </Box>
// // //             ))}
// // //           </Stack>
// // //         </Box>
// // //       </Stack>
// // //     </Paper>
// // //   );
// // // };

// // // const TabsSkeleton = () => {
// // //   return (
// // //     <Paper
// // //       square
// // //       elevation={2}
// // //       sx={{ flexShrink: 0, bgcolor: "background.paper" }}
// // //     >
// // //       <Box sx={{ display: "flex", height: 48 }}>
// // //         {[...Array(3)].map((_, index) => (
// // //           <Box
// // //             key={index}
// // //             sx={{
// // //               flex: 1,
// // //               display: "flex",
// // //               alignItems: "center",
// // //               justifyContent: "center",
// // //               p: 2,
// // //             }}
// // //           >
// // //             <Skeleton variant="text" width={80} height={24} />
// // //           </Box>
// // //         ))}
// // //       </Box>
// // //     </Paper>
// // //   );
// // // };

// // // const JobDialogSkeleton = () => {
// // //   return (
// // //     <>
// // //       <DialogTitle>
// // //         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
// // //           <Skeleton
// // //             variant="circular"
// // //             width={{ xs: 40, sm: 60 }}
// // //             height={{ xs: 40, sm: 60 }}
// // //           />
// // //           <Box sx={{ flexGrow: 1 }}>
// // //             <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
// // //             <Skeleton variant="text" width="40%" height={28} />
// // //           </Box>
// // //           <Skeleton variant="circular" width={40} height={40} />
// // //           <Skeleton variant="circular" width={40} height={40} />
// // //         </Box>
// // //       </DialogTitle>
// // //       <DialogContent dividers>
// // //         <Stack spacing={3}>
// // //           <Skeleton variant="rectangular" width="100%" height={120} />
// // //           <Skeleton variant="rectangular" width="100%" height={200} />
// // //           <Skeleton variant="rectangular" width="100%" height={150} />
// // //         </Stack>
// // //       </DialogContent>
// // //       <DialogActions
// // //         sx={{ p: { xs: 2, sm: 3 }, justifyContent: "flex-end", gap: 1 }}
// // //       >
// // //         <Skeleton
// // //           variant="rectangular"
// // //           width={80}
// // //           height={36}
// // //           sx={{ borderRadius: 1 }}
// // //         />
// // //         <Skeleton
// // //           variant="rectangular"
// // //           width={120}
// // //           height={36}
// // //           sx={{ borderRadius: 1 }}
// // //         />
// // //       </DialogActions>
// // //     </>
// // //   );
// // // };

// // // const TabLabel = ({ count, label, color }) => (
// // //   <Stack direction="row" spacing={1} alignItems="center">
// // //     <Box
// // //       component="span"
// // //       sx={{
// // //         bgcolor: `${color}.main`,
// // //         color: `${color}.contrastText`,
// // //         borderRadius: "10px",
// // //         px: 0.8,
// // //         py: 0.1,
// // //         minWidth: 20,
// // //         fontSize: "0.75rem",
// // //         fontWeight: "bold",
// // //         display: "flex",
// // //         alignItems: "center",
// // //         justifyContent: "center",
// // //       }}
// // //     >
// // //       {count}
// // //     </Box>
// // //     <Typography
// // //       component="span"
// // //       sx={{ textTransform: "none", fontWeight: 500 }}
// // //     >
// // //       {label}
// // //     </Typography>
// // //   </Stack>
// // // );

// // // const SectionCard = ({ children, ...props }) => (
// // //   <Paper
// // //     variant="outlined"
// // //     sx={{
// // //       p: { xs: 2, md: 3 },
// // //       borderRadius: 3,
// // //       BoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
// // //       borderColor: (theme) => alpha(theme.palette.divider, 0.5),
// // //       bgcolor: "background.paper",
// // //     }}
// // //     {...props}
// // //   >
// // //     {children}
// // //   </Paper>
// // // );

// // // const SectionHeader = ({ icon, title }) => (
// // //   <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
// // //     <Avatar
// // //       sx={{
// // //         bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
// // //         color: "primary.main",
// // //         width: 32,
// // //         height: 32,
// // //       }}
// // //     >
// // //       {icon}
// // //     </Avatar>
// // //     <Typography variant="h6" fontWeight="bold" color="text.primary">
// // //       {title}
// // //     </Typography>
// // //   </Box>
// // // );

// // // const KeyDetail = ({ icon, label, value }) => (
// // //   <Grid item xs={12} sm={6} md={4}>
// // //     <Stack direction="row" spacing={1.5} alignItems="center">
// // //       <Box color="text.secondary">{icon}</Box>
// // //       <Box>
// // //         <Typography
// // //           variant="caption"
// // //           color="text.secondary"
// // //           sx={{ display: "block", lineHeight: 1.2 }}
// // //         >
// // //           {label}
// // //         </Typography>
// // //         <Typography variant="body2" fontWeight="bold" color="text.primary">
// // //           {value}
// // //         </Typography>
// // //       </Box>
// // //     </Stack>
// // //   </Grid>
// // // );

// // // function JobBrowser() {
// // //   const { showNotification } = useNotification();
// // //   const theme = useTheme();
// // //   const [jobs, setJobs] = useState([]);
// // //   const [filteredJobs, setFilteredJobs] = useState([]);
// // //   const [selectedJob, setSelectedJob] = useState(null);
// // //   const [openJobDialog, setOpenJobDialog] = useState(false);
// // //   const [tabValue, setTabValue] = useState(0);
// // //   const [searchTerm, setSearchTerm] = useState("");
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [isSaving, setIsSaving] = useState(null);
// // //   const [isApplying, setIsApplying] = useState(null);
// // //   const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
// // //   const [jobDialogLoading, setJobDialogLoading] = useState(false);
// // //   const [filters, setFilters] = useState({
// // //     location: "",
// // //     experience: "",
// // //     education: "",
// // //   });
// // //   const hasFetchedRef = useRef(false);
// // //   const getErrorMessage = (err, fallback) => {
// // //     if (err && err.response && err.response.data) {
// // //       const d = err.response.data;
// // //       if (typeof d === "string") return d;
// // //       return d.detail || d.message || fallback;
// // //     }
// // //     if (
// // //       typeof err?.message === "string" &&
// // //       err.message.toLowerCase().includes("network")
// // //     ) {
// // //       return "Network error. Please check your connection.";
// // //     }
// // //     return fallback;
// // //   };
// // //   const transformJobData = (apiJob) => ({
// // //     id: apiJob.id,
// // //     title: apiJob.title,
// // //     company: apiJob.company_details?.company_name || "Unknown Company",
// // //     location: apiJob.location,
// // //     salary:
// // //       apiJob.salary_min && apiJob.salary_max
// // //         ? `${apiJob.salary_currency} ${Number.parseFloat(
// // //             apiJob.salary_min
// // //           ).toLocaleString()} - ${Number.parseFloat(
// // //             apiJob.salary_max
// // //           ).toLocaleString()}`
// // //         : "Not Disclosed",
// // //     type: apiJob.job_type_display || apiJob.job_type,
// // //     experience: apiJob.experience_level_display || apiJob.experience_level,
// // //     posted: new Date(apiJob.created_at).toLocaleDateString(),
// // //     logo: apiJob.company_details?.logo || "/placeholder.svg?height=60&width=60",
// // //     description: apiJob.description,
// // //     requirements: apiJob.required_skills || [],
// // //     benefits: apiJob.benefits || [],
// // //     matchScore: 0,
// // //     saved: false,
// // //     applied: false,
// // //     applicationId: null,
// // //     applicationStatus: null,
// // //     urgent: apiJob.status === "URGENT",
// // //     remote: apiJob.remote_work,
// // //     visaSponsorship: apiJob.visa_sponsorship,
// // //     responsibilities: apiJob.responsibilities,
// // //     applicationDeadline: apiJob.application_deadline,
// // //   });
// // //   useEffect(() => {
// // //     if (hasFetchedRef.current) return;
// // //     hasFetchedRef.current = true;
// // //     const loadData = async () => {
// // //       setLoading(true);
// // //       setError(null);
// // //       try {
// // //         const [
// // //           jobsResponse,
// // //           aiScoresResponse,
// // //           savedJobsResponse,
// // //           applicationsResponse,
// // //         ] = await Promise.all([
// // //           apiClient.get("/job-postings/"),
// // //           apiClient.get("/job-postings/ai-score/"),
// // //           apiClient.get("/saved-jobs/"),
// // //           apiClient.get("/applications/"),
// // //         ]);
// // //         const jobsData = jobsResponse.data
// // //           .filter((j) => j.status === "PUBLISHED")
// // //           .map(transformJobData);
// // //         const aiScoresData = aiScoresResponse.data;
// // //         const savedJobIds = new Set(
// // //           savedJobsResponse.data.map((sj) => sj.job_posting.id)
// // //         );
// // //         const applicationsData = applicationsResponse.data;
// // //         const applicationsMap = new Map(
// // //           applicationsData.map((app) => {
// // //             const appStatus = app.status_display || app.status;
// // //             return [
// // //               app.job_posting,
// // //               {
// // //                 id: app.id,
// // //                 status: appStatus === "Deleted" ? "Withdrawn" : appStatus,
// // //               },
// // //             ];
// // //           })
// // //         );
// // //         const finalJobs = jobsData.map((job) => {
// // //           const aiScore = aiScoresData.find((score) => score.id === job.id);
// // //           const applicationDetails = applicationsMap.get(job.id);
// // //           return {
// // //             ...job,
// // //             matchScore: aiScore ? Math.round(aiScore.matching_percentage) : 0,
// // //             saved: savedJobIds.has(job.id),
// // //             applied: !!applicationDetails,
// // //             applicationId: applicationDetails?.id || null,
// // //             applicationStatus: applicationDetails?.status || null,
// // //           };
// // //         });
// // //         finalJobs.sort((a, b) => b.matchScore - a.matchScore);
// // //         setJobs(finalJobs);
// // //         setFilteredJobs(finalJobs);
// // //       } catch (err) {
// // //         const errorMessage = getErrorMessage(
// // //           err,
// // //           "Failed to load data. Please try again."
// // //         );
// // //         setError(errorMessage);
// // //         showNotification(errorMessage, "error");
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };
// // //     loadData();
// // //   }, [showNotification]);
// // //   const filterJobs = (search, currentFilters, currentTab, baseJobs = jobs) => {
// // //     let sourceJobs = [...baseJobs];
// // //     if (currentTab === 1) {
// // //       sourceJobs = baseJobs.filter((job) => job.saved);
// // //     } else if (currentTab === 2) {
// // //       sourceJobs = baseJobs.filter(
// // //         (job) => job.applied && job.applicationStatus !== "Withdrawn"
// // //       );
// // //     } else if (currentTab === 3) {
// // //       sourceJobs = baseJobs.filter(
// // //         (job) => job.applied && job.applicationStatus === "Withdrawn"
// // //       );
// // //     }
// // //     const filtered = sourceJobs.filter((job) => {
// // //       const searchTermLower = search.toLowerCase();
// // //       const matchesSearch =
// // //         search === "" ||
// // //         job.title.toLowerCase().includes(searchTermLower) ||
// // //         job.company.toLowerCase().includes(searchTermLower);
// // //       const matchesLocation =
// // //         !currentFilters.location ||
// // //         job.location
// // //           .toLowerCase()
// // //           .includes(currentFilters.location.toLowerCase());
// // //       const matchesExperience =
// // //         !currentFilters.experience ||
// // //         job.experience === currentFilters.experience;
// // //       const matchesEducation =
// // //         !currentFilters.education || job.education === currentFilters.education;
// // //       return (
// // //         matchesSearch &&
// // //         matchesLocation &&
// // //         matchesExperience &&
// // //         matchesEducation
// // //       );
// // //     });
// // //     setFilteredJobs(filtered);
// // //   };
// // //   const handleTabChange = (event, newValue) => {
// // //     setTabValue(newValue);
// // //     filterJobs(searchTerm, filters, newValue);
// // //   };
// // //   const handleSearch = (event) => {
// // //     const term = event.target.value;
// // //     setSearchTerm(term);
// // //     filterJobs(term, filters, tabValue);
// // //   };
// // //   const handleFilterChange = (event) => {
// // //     const { name, value } = event.target;
// // //     const newFilters = { ...filters, [name]: value };
// // //     setFilters(newFilters);
// // //     filterJobs(searchTerm, newFilters, tabValue);
// // //   };
// // //   const clearAllFilters = () => {
// // //     const newFilters = {
// // //       location: "",
// // //       experience: "",
// // //       education: "",
// // //     };
// // //     setFilters(newFilters);
// // //     setSearchTerm("");
// // //     filterJobs("", newFilters, tabValue);
// // //   };
// // //   const handleSaveJob = async (jobId) => {
// // //     setIsSaving(jobId);
// // //     const jobToUpdate = jobs.find((j) => j.id === jobId);
// // //     const isCurrentlySaved = jobToUpdate.saved;
// // //     try {
// // //       if (isCurrentlySaved) {
// // //         await apiClient.delete(`/saved-jobs/unsave/`, {
// // //           data: { job_posting_id: jobId },
// // //         });
// // //       } else {
// // //         await apiClient.post(`/saved-jobs/save/`, { job_posting_id: jobId });
// // //       }
// // //       const updatedJobs = jobs.map((j) =>
// // //         j.id === jobId ? { ...j, saved: !isCurrentlySaved } : j
// // //       );
// // //       setJobs(updatedJobs);
// // //       showNotification(
// // //         isCurrentlySaved
// // //           ? "Job removed from saved list"
// // //           : "Job saved successfully!",
// // //         "success"
// // //       );
// // //       filterJobs(searchTerm, filters, tabValue, updatedJobs);
// // //     } catch (error) {
// // //       showNotification(
// // //         getErrorMessage(error, "Failed to update job status."),
// // //         "error"
// // //       );
// // //     } finally {
// // //       setIsSaving(null);
// // //     }
// // //   };
// // //   const handleApplyJob = async (jobId) => {
// // //     setIsApplying(jobId);
// // //     try {
// // //       const response = await apiClient.post("/applications/", {
// // //         job_posting: jobId,
// // //       });
// // //       const newApplication = response.data;
// // //       const updatedJobs = jobs.map((job) =>
// // //         job.id === jobId
// // //           ? {
// // //               ...job,
// // //               applied: true,
// // //               applicationId: newApplication.id,
// // //               applicationStatus:
// // //                 newApplication.status_display || newApplication.status,
// // //             }
// // //           : job
// // //       );
// // //       setJobs(updatedJobs);
// // //       showNotification("Application submitted successfully!", "success");
// // //       filterJobs(searchTerm, filters, tabValue, updatedJobs);
// // //       if (openJobDialog) {
// // //         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
// // //       }
// // //     } catch (error) {
// // //       showNotification(
// // //         getErrorMessage(error, "Failed to submit application."),
// // //         "error"
// // //       );
// // //     } finally {
// // //       setIsApplying(null);
// // //     }
// // //   };
// // //   const handleReapplyJob = async (applicationId, jobId) => {
// // //     setIsApplying(jobId);
// // //     try {
// // //       const response = await apiClient.patch(
// // //         `/applications/${applicationId}/`,
// // //         {
// // //           status: "SUBMITTED",
// // //         }
// // //       );
// // //       const updatedApplication = response.data;
// // //       const updatedJobs = jobs.map((job) =>
// // //         job.id === jobId
// // //           ? {
// // //               ...job,
// // //               applicationStatus:
// // //                 updatedApplication.status_display || updatedApplication.status,
// // //             }
// // //           : job
// // //       );
// // //       setJobs(updatedJobs);
// // //       showNotification("Re-applied to job successfully!", "success");
// // //       setTabValue(0);
// // //       filterJobs(searchTerm, filters, 0, updatedJobs);
// // //       if (openJobDialog) {
// // //         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
// // //       }
// // //     } catch (error) {
// // //       showNotification(getErrorMessage(error, "Failed to re-apply."), "error");
// // //     } finally {
// // //       setIsApplying(null);
// // //     }
// // //   };
// // //   const handleUndoApplication = async (applicationId, jobId) => {
// // //     setIsApplying(jobId);
// // //     try {
// // //       await apiClient.delete(`/applications/${applicationId}/delete/`);
// // //       const updatedJobs = jobs.map((job) =>
// // //         job.id === jobId
// // //           ? {
// // //               ...job,
// // //               applied: true,
// // //               applicationStatus: "Withdrawn",
// // //             }
// // //           : job
// // //       );
// // //       setJobs(updatedJobs);
// // //       showNotification("Application successfully withdrawn!", "success");
// // //       setTabValue(3);
// // //       filterJobs(searchTerm, filters, 3, updatedJobs);
// // //       if (openJobDialog) {
// // //         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
// // //       }
// // //     } catch (error) {
// // //       showNotification(
// // //         getErrorMessage(error, "Failed to withdraw application."),
// // //         "error"
// // //       );
// // //     } finally {
// // //       setIsApplying(null);
// // //     }
// // //   };
// // //   const handleViewJob = (job) => {
// // //     setSelectedJob(job);
// // //     setOpenJobDialog(true);
// // //     setJobDialogLoading(true);
// // //     setTimeout(() => {
// // //       setJobDialogLoading(false);
// // //     }, 800);
// // //   };
// // //   if (loading) {
// // //     return (
// // //       <Layout title="Global Job Opportunities">
// // //         <Box
// // //           sx={{
// // //             display: "flex",
// // //             flexDirection: "column",
// // //             height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
// // //             p: { xs: 1, sm: 2, md: 3 },
// // //             bgcolor: "background.default",
// // //           }}
// // //         >
// // //           <Box sx={{ flexShrink: 0, mb: 2 }}>
// // //             <TabsSkeleton />
// // //           </Box>
// // //           <Box sx={{ mb: 3 }}>
// // //             <FilterSkeleton />
// // //           </Box>
// // //           <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
// // //             <Stack spacing={2.5}>
// // //               {[...Array(4)].map((_, index) => (
// // //                 <JobCardSkeleton key={index} />
// // //               ))}
// // //             </Stack>
// // //           </Box>
// // //         </Box>
// // //       </Layout>
// // //     );
// // //   }
// // //   if (error) {
// // //     return (
// // //       <Layout title="Global Job Opportunities">
// // //         <Box sx={{ p: 3 }}>
// // //           <Alert severity="error">{error}</Alert>
// // //         </Box>
// // //       </Layout>
// // //     );
// // //   }
// // //   const allJobsCount = jobs.length;
// // //   const savedJobsCount = jobs.filter((j) => j.saved).length;
// // //   const appliedJobsCount = jobs.filter(
// // //     (j) => j.applied && j.applicationStatus !== "Withdrawn"
// // //   ).length;
// // //   const withdrawnJobsCount = jobs.filter(
// // //     (j) => j.applied && j.applicationStatus === "Withdrawn"
// // //   ).length;
// // //   const renderFilterBar = () => (
// // //     <Paper
// // //       elevation={0}
// // //       variant="outlined"
// // //       sx={{
// // //         p: "12px",
// // //         borderRadius: "12px",
// // //         bgcolor: "mint.main",
// // //         BoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
// // //         mb: 3,
// // //       }}
// // //     >
// // //       <Grid container spacing={2} alignItems="center">
// // //         <Grid item xs={12} md={4} lg={5}>
// // //           <TextField
// // //             fullWidth
// // //             variant="outlined"
// // //             placeholder="Search Jobs, Companies"
// // //             value={searchTerm}
// // //             onChange={handleSearch}
// // //             InputProps={{
// // //               startAdornment: (
// // //                 <InputAdornment position="start">
// // //                   <Search />
// // //                 </InputAdornment>
// // //               ),
// // //               sx: { borderRadius: "8px", fontSize: "14px" },
// // //             }}
// // //           />
// // //         </Grid>
// // //         <Grid item xs={12} sm={4} md={2} lg={2}>
// // //           <FormControl fullWidth>
// // //             <Select
// // //               displayEmpty
// // //               value={filters.location}
// // //               name="location"
// // //               onChange={handleFilterChange}
// // //               sx={{
// // //                 borderRadius: "8px",
// // //                 fontSize: "13px",
// // //                 color: filters.location ? "inherit" : "text.secondary",
// // //               }}
// // //             >
// // //               <MenuItem value="">Location</MenuItem>
// // //               {[...new Set(jobs.map((job) => job.location))]
// // //                 .sort()
// // //                 .map((loc) => (
// // //                   <MenuItem key={loc} value={loc}>
// // //                     {loc}
// // //                   </MenuItem>
// // //                 ))}
// // //             </Select>
// // //           </FormControl>
// // //         </Grid>
// // //         <Grid item xs={12} sm={4} md={2} lg={2}>
// // //           <FormControl fullWidth>
// // //             <Select
// // //               displayEmpty
// // //               value={filters.education}
// // //               name="education"
// // //               onChange={handleFilterChange}
// // //               sx={{
// // //                 borderRadius: "8px",
// // //                 fontSize: "13px",
// // //                 color: filters.education ? "inherit" : "text.secondary",
// // //               }}
// // //             >
// // //               <MenuItem value="">Education</MenuItem>
// // //               <MenuItem value="bachelor">Bachelor's</MenuItem>
// // //               <MenuItem value="master">Master's</MenuItem>
// // //               <MenuItem value="phd">PhD</MenuItem>
// // //             </Select>
// // //           </FormControl>
// // //         </Grid>
// // //         <Grid item xs={12} sm={4} md={2} lg={2}>
// // //           <FormControl fullWidth>
// // //             <Select
// // //               displayEmpty
// // //               value={filters.experience}
// // //               name="experience"
// // //               onChange={handleFilterChange}
// // //               sx={{
// // //                 borderRadius: "8px",
// // //                 fontSize: "13px",
// // //                 color: filters.experience ? "inherit" : "text.secondary",
// // //               }}
// // //             >
// // //               <MenuItem value="">Experience</MenuItem>
// // //               {[...new Set(jobs.map((job) => job.experience))]
// // //                 .sort()
// // //                 .map((exp) => (
// // //                   <MenuItem key={exp} value={exp}>
// // //                     {exp}
// // //                   </MenuItem>
// // //                 ))}
// // //             </Select>
// // //           </FormControl>
// // //         </Grid>
// // //         <Grid item xs={12} md="auto">
// // //           <Button
// // //             onClick={clearAllFilters}
// // //             sx={{
// // //               textTransform: "none",
// // //               color: "primary.main",
// // //               fontWeight: "bold",
// // //             }}
// // //           >
// // //             Clear Filter
// // //           </Button>
// // //         </Grid>
// // //       </Grid>
// // //     </Paper>
// // //   );
// // //   return (
// // //     <Layout title="Global Job Opportunities">
// // //       <Box
// // //         sx={{
// // //           display: "flex",
// // //           flexDirection: "column",
// // //           height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
// // //           p: { xs: 1, sm: 2, md: 3 },
// // //           bgcolor: "background.default",
// // //         }}
// // //       >
// // //         <Paper
// // //           square
// // //           elevation={0}
// // //           sx={{
// // //             flexShrink: 0,
// // //             mb: 2,
// // //             backgroundColor: "transparent",
// // //           }}
// // //         >
// // //           <Tabs
// // //             value={tabValue}
// // //             onChange={handleTabChange}
// // //             centered
// // //             sx={{ "& .MuiTab-root": { fontSize: "1rem" } }}
// // //           >
// // //             <Tab
// // //               label={
// // //                 <TabLabel
// // //                   count={allJobsCount}
// // //                   label="All Jobs"
// // //                   color="primary"
// // //                 />
// // //               }
// // //             />
// // //             <Tab
// // //               label={
// // //                 <TabLabel
// // //                   count={savedJobsCount}
// // //                   label="Saved"
// // //                   color="secondary"
// // //                 />
// // //               }
// // //             />
// // //             <Tab
// // //               label={
// // //                 <TabLabel
// // //                   count={appliedJobsCount}
// // //                   label="Applied"
// // //                   color="success"
// // //                 />
// // //               }
// // //             />
// // //           </Tabs>
// // //         </Paper>
// // //         {renderFilterBar()}
// // //         <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
// // //           <Stack spacing={2.5}>
// // //             {filteredJobs.length > 0 ? (
// // //               filteredJobs.map((job) => (
// // //                 <AnimatedJobCard
// // //                   key={job.id}
// // //                   job={job}
// // //                   handleViewJob={handleViewJob}
// // //                   handleSaveJob={handleSaveJob}
// // //                   handleApplyJob={handleApplyJob}
// // //                   handleUndoApplication={handleUndoApplication}
// // //                   handleReapplyJob={handleReapplyJob}
// // //                   isSaving={isSaving}
// // //                   isApplying={isApplying}
// // //                   showUndoButton={tabValue === 2}
// // //                   showReapplyButton={tabValue === 3}
// // //                   hideSaveButton={tabValue === 2}
// // //                   isSavedTab={tabValue === 1}
// // //                 />
// // //               ))
// // //             ) : (
// // //               <Paper
// // //                 sx={{
// // //                   p: 6,
// // //                   textAlign: "center",
// // //                   backgroundColor: "background.paper",
// // //                 }}
// // //               >
// // //                 <Work sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
// // //                 <Typography
// // //                   variant="h5"
// // //                   color="text.primary"
// // //                   gutterBottom
// // //                   fontWeight={600}
// // //                 >
// // //                   No jobs found
// // //                 </Typography>
// // //                 <Typography variant="body1" color="text.secondary">
// // //                   Try adjusting your filters or search terms
// // //                 </Typography>
// // //               </Paper>
// // //             )}
// // //           </Stack>
// // //         </Box>
// // //       </Box>
// // //       <Dialog
// // //         open={openJobDialog}
// // //         onClose={() => setOpenJobDialog(false)}
// // //         maxWidth="md"
// // //         fullWidth
// // //         PaperProps={{ sx: { maxHeight: "90vh", borderRadius: 4 } }}
// // //       >
// // //         {jobDialogLoading ? (
// // //           <JobDialogSkeleton />
// // //         ) : (
// // //           selectedJob &&
// // //           (() => {
// // //             const currentJobState =
// // //               jobs.find((j) => j.id === selectedJob.id) || selectedJob;
// // //             return (
// // //               <>
// // //                 <DialogTitle
// // //                   sx={{
// // //                     bgcolor: "background.paper",
// // //                     borderBottom: `1px solid ${theme.palette.divider}`,
// // //                   }}
// // //                 >
// // //                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
// // //                     <Avatar
// // //                       src={currentJobState.logo}
// // //                       sx={{
// // //                         width: 60,
// // //                         height: 60,
// // //                         border: `2px solid ${theme.palette.divider}`,
// // //                         boxShadow: 1,
// // //                       }}
// // //                     />
// // //                     <Box sx={{ flexGrow: 1 }}>
// // //                       <Typography
// // //                         variant="h5"
// // //                         fontWeight="bold"
// // //                         color="text.primary"
// // //                       >
// // //                         {currentJobState.title}
// // //                       </Typography>
// // //                       <Typography variant="body1" color="text.secondary">
// // //                         {currentJobState.company}
// // //                       </Typography>
// // //                     </Box>
// // //                     <Box sx={{ display: { xs: "none", sm: "flex" } }}>
// // //                       <IconButton
// // //                         disabled={isSaving === currentJobState.id}
// // //                         onClick={() => handleSaveJob(currentJobState.id)}
// // //                       >
// // //                         {isSaving === currentJobState.id ? (
// // //                           <CircularProgress size={24} />
// // //                         ) : currentJobState.saved ? (
// // //                           <Bookmark color="primary" />
// // //                         ) : (
// // //                           <BookmarkBorder />
// // //                         )}
// // //                       </IconButton>
// // //                       <IconButton>
// // //                         <Share />
// // //                       </IconButton>
// // //                     </Box>
// // //                   </Box>
// // //                 </DialogTitle>
// // //                 <DialogContent
// // //                   sx={{ bgcolor: "background.default", p: { xs: 2, md: 3 } }}
// // //                 >
// // //                   <Stack spacing={3}>
// // //                     <SectionCard>
// // //                       <Grid container spacing={2} rowSpacing={3}>
// // //                         <Grid item xs={12} sm={6} md={8}>
// // //                           <Stack spacing={2}>
// // //                             <KeyDetail
// // //                               icon={<AttachMoney />}
// // //                               label="Salary"
// // //                               value={currentJobState.salary}
// // //                             />
// // //                             <KeyDetail
// // //                               icon={<LocationOn />}
// // //                               label="Location"
// // //                               value={currentJobState.location}
// // //                             />
// // //                             <KeyDetail
// // //                               icon={<Business />}
// // //                               label="Experience"
// // //                               value={currentJobState.experience}
// // //                             />
// // //                             <KeyDetail
// // //                               icon={<Work />}
// // //                               label="Job Type"
// // //                               value={currentJobState.type}
// // //                             />
// // //                           </Stack>
// // //                         </Grid>
// // //                         <Grid
// // //                           item
// // //                           xs={12}
// // //                           sm={6}
// // //                           md={4}
// // //                           sx={{
// // //                             display: "flex",
// // //                             alignItems: "center",
// // //                             justifyContent: "center",
// // //                           }}
// // //                         >
// // //                           <Box sx={{ textAlign: "center" }}>
// // //                             <AnimatedMatchScore
// // //                               score={currentJobState.matchScore}
// // //                             />
// // //                             <Typography
// // //                               variant="caption"
// // //                               fontWeight="bold"
// // //                               color="primary.main"
// // //                               sx={{ mt: 1, display: "block" }}
// // //                             >
// // //                               AI MATCH SCORE
// // //                             </Typography>
// // //                           </Box>
// // //                         </Grid>
// // //                       </Grid>
// // //                     </SectionCard>
// // //                     <SectionCard>
// // //                       <SectionHeader
// // //                         icon={<Description fontSize="small" />}
// // //                         title="Job Description"
// // //                       />
// // //                       <Typography
// // //                         variant="body2"
// // //                         sx={{
// // //                           whiteSpace: "pre-wrap",
// // //                           lineHeight: 1.7,
// // //                           color: "text.secondary",
// // //                         }}
// // //                       >
// // //                         {currentJobState.description}
// // //                       </Typography>
// // //                     </SectionCard>
// // //                     {currentJobState.responsibilities && (
// // //                       <SectionCard>
// // //                         <SectionHeader
// // //                           icon={<PlaylistAddCheck fontSize="small" />}
// // //                           title="Responsibilities"
// // //                         />
// // //                         <Typography
// // //                           variant="body2"
// // //                           sx={{
// // //                             whiteSpace: "pre-wrap",
// // //                             lineHeight: 1.7,
// // //                             color: "text.secondary",
// // //                           }}
// // //                         >
// // //                           {currentJobState.responsibilities}
// // //                         </Typography>
// // //                       </SectionCard>
// // //                     )}
// // //                     <SectionCard>
// // //                       <SectionHeader
// // //                         icon={<Category fontSize="small" />}
// // //                         title="Required Skills"
// // //                       />
// // //                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
// // //                         {currentJobState.requirements.map((skill, index) => (
// // //                           <Chip
// // //                             key={index}
// // //                             label={skill}
// // //                             variant="outlined"
// // //                             color="primary"
// // //                           />
// // //                         ))}
// // //                       </Box>
// // //                     </SectionCard>
// // //                     <SectionCard>
// // //                       <SectionHeader
// // //                         icon={<Stars fontSize="small" />}
// // //                         title="Benefits & Perks"
// // //                       />
// // //                       <List
// // //                         dense
// // //                         sx={{ p: 0, "&& .Mui-ListItem-root": { py: 0.5 } }}
// // //                       >
// // //                         {currentJobState.benefits.map((benefit, index) => (
// // //                           <ListItem key={index} disableGutters>
// // //                             <ListItemIcon sx={{ minWidth: 32 }}>
// // //                               <CheckCircle
// // //                                 color="success"
// // //                                 sx={{ fontSize: 20 }}
// // //                               />
// // //                             </ListItemIcon>
// // //                             <ListItemText
// // //                               primary={benefit}
// // //                               primaryTypographyProps={{
// // //                                 color: "text.secondary",
// // //                                 fontWeight: 500,
// // //                               }}
// // //                             />
// // //                           </ListItem>
// // //                         ))}
// // //                       </List>
// // //                     </SectionCard>
// // //                   </Stack>
// // //                 </DialogContent>
// // //                 <DialogActions
// // //                   sx={{
// // //                     p: { xs: 2, sm: 3 },
// // //                     justifyContent: "flex-end",
// // //                     gap: 2,
// // //                     bgcolor: "background.paper",
// // //                     borderTop: `1px solid ${theme.palette.divider}`,
// // //                   }}
// // //                 >
// // //                   <Button
// // //                     onClick={() => setOpenJobDialog(false)}
// // //                     variant="outlined"
// // //                     color="secondary"
// // //                   >
// // //                     Close
// // //                   </Button>
// // //                   {tabValue === 3 &&
// // //                   currentJobState.applied &&
// // //                   currentJobState.applicationStatus === "Withdrawn" ? (
// // //                     <Button
// // //                       variant="contained"
// // //                       color="secondary"
// // //                       startIcon={
// // //                         isApplying === currentJobState.id ? (
// // //                           <CircularProgress size={16} color="inherit" />
// // //                         ) : (
// // //                           <ReplayIcon />
// // //                         )
// // //                       }
// // //                       size="small"
// // //                       disabled={isApplying === currentJobState.id}
// // //                       onClick={() =>
// // //                         handleReapplyJob(
// // //                           currentJobState.applicationId,
// // //                           currentJobState.id
// // //                         )
// // //                       }
// // //                       sx={{
// // //                         px: 4,
// // //                         background: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
// // //                         "&:hover": {
// // //                           background: `linear-gradient(45deg, ${theme.palette.secondary.dark}, ${theme.palette.primary.dark})`,
// // //                           transform: "translateY(-1px)",
// // //                           boxShadow: `0 6px 20px ${alpha(
// // //                             theme.palette.secondary.main,
// // //                             0.3
// // //                           )}`,
// // //                         },
// // //                       }}
// // //                     >
// // //                       {isApplying === currentJobState.id ? (
// // //                         <CircularProgress size={24} color="inherit" />
// // //                       ) : (
// // //                         "Re-apply Now"
// // //                       )}
// // //                     </Button>
// // //                   ) : tabValue === 2 &&
// // //                     currentJobState.applied &&
// // //                     currentJobState.applicationStatus !== "Withdrawn" ? (
// // //                     <Button
// // //                       variant="outlined"
// // //                       color="error"
// // //                       startIcon={
// // //                         isApplying === currentJobState.id ? (
// // //                           <CircularProgress size={10} color="inherit" />
// // //                         ) : (
// // //                           <UndoIcon />
// // //                         )
// // //                       }
// // //                       size="small"
// // //                       disabled={isApplying === currentJobState.id}
// // //                       onClick={() =>
// // //                         handleUndoApplication(
// // //                           currentJobState.applicationId,
// // //                           currentJobState.id
// // //                         )
// // //                       }
// // //                       sx={{
// // //                         fontSize: "0.65rem",
// // //                         borderRadius: 1,
// // //                         borderColor: alpha(theme.palette.error.main, 0.2),
// // //                         "&:hover": {
// // //                           backgroundColor: alpha(
// // //                             theme.palette.error.main,
// // //                             0.08
// // //                           ),
// // //                           borderColor: "error.main",
// // //                         },
// // //                       }}
// // //                     >
// // //                       Withdraw
// // //                     </Button>
// // //                   ) : currentJobState.applied ? (
// // //                     <Button
// // //                       disabled
// // //                       variant="contained"
// // //                       startIcon={<CheckCircle />}
// // //                       sx={{
// // //                         "&.Mui-disabled": {
// // //                           backgroundColor: alpha(
// // //                             theme.palette.success.main,
// // //                             0.2
// // //                           ),
// // //                           color: "success.dark",
// // //                         },
// // //                       }}
// // //                     >
// // //                       Status: {currentJobState.applicationStatus || "Applied"}
// // //                     </Button>
// // //                   ) : (
// // //                     <Button
// // //                       variant="contained"
// // //                       disabled={isApplying === currentJobState.id}
// // //                       onClick={() => handleApplyJob(currentJobState.id)}
// // //                       sx={{
// // //                         px: 4,
// // //                         py: 1.5,
// // //                         background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
// // //                         "&:hover": {
// // //                           background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
// // //                           transform: "translateY(-1px)",
// // //                           boxShadow: `0 6px 20px ${alpha(
// // //                             theme.palette.primary.main,
// // //                             0.3
// // //                           )}`,
// // //                         },
// // //                       }}
// // //                     >
// // //                       {isApplying === currentJobState.id ? (
// // //                         <CircularProgress size={24} color="inherit" />
// // //                       ) : (
// // //                         "Apply Now"
// // //                       )}
// // //                     </Button>
// // //                   )}
// // //                 </DialogActions>
// // //               </>
// // //             );
// // //           })()
// // //         )}
// // //       </Dialog>
// // //     </Layout>
// // //   );
// // // }

// // // export default JobBrowser;
// // "use client";

// // import { useState, useEffect, useRef } from "react";
// // import {
// //   Grid,
// //   Card,
// //   Typography,
// //   Button,
// //   Box,
// //   Chip,
// //   TextField,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   Paper,
// //   Avatar,
// //   IconButton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemIcon,
// //   Tabs,
// //   Tab,
// //   Alert,
// //   CircularProgress,
// //   Stack,
// //   Skeleton,
// //   alpha,
// //   InputAdornment,
// //   Divider,
// // } from "@mui/material";
// // import {
// //   Work,
// //   LocationOn,
// //   AttachMoney,
// //   Bookmark,
// //   BookmarkBorder,
// //   Share,
// //   Search,
// //   Business,
// //   CheckCircle,
// //   CalendarToday,
// //   TrendingUp,
// //   Undo as UndoIcon,
// //   Description,
// //   PlaylistAddCheck,
// //   Category,
// //   Stars,
// //   Replay as ReplayIcon,
// //   HighlightOff,
// //   PriorityHigh,
// // } from "@mui/icons-material";
// // import Layout from "../common/Layout";
// // import { useNotification } from "../../context/NotificationContext";
// // import apiClient from "../../context/apiClient";
// // import { useTheme } from "@mui/material/styles";
// // import { useInView } from "react-intersection-observer";

// // const AnimatedMatchScore = ({ score }) => {
// //   const theme = useTheme();
// //   const [progress, setProgress] = useState(0);
// //   useEffect(() => {
// //     const timer = setTimeout(() => {
// //       setProgress(score);
// //     }, 500);
// //     return () => clearTimeout(timer);
// //   }, [score]);
// //   const getScoreColor = () => {
// //     if (score >= 70) return theme.palette.success.main;
// //     if (score >= 40) return theme.palette.warning.main;
// //     return theme.palette.error.main;
// //   };
// //   return (
// //     <Box sx={{ position: "relative", display: "inline-flex" }}>
// //       <CircularProgress
// //         variant="determinate"
// //         sx={{ color: (theme) => theme.palette.divider }}
// //         size={56}
// //         thickness={4}
// //         value={100}
// //       />
// //       <CircularProgress
// //         variant="determinate"
// //         value={progress}
// //         size={56}
// //         thickness={4}
// //         sx={{
// //           color: getScoreColor(),
// //           position: "absolute",
// //           left: 0,
// //           transition: "transform 1s ease-out",
// //           transform: "rotate(-90deg) !important",
// //         }}
// //       />
// //       <Box
// //         sx={{
// //           top: 0,
// //           left: 0,
// //           bottom: 0,
// //           right: 0,
// //           position: "absolute",
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "center",
// //           flexDirection: "column",
// //         }}
// //       >
// //         <Typography
// //           variant="subtitle1"
// //           component="div"
// //           color="text.primary"
// //           fontWeight="bold"
// //           sx={{ fontSize: "14px" }}
// //         >{`${Math.round(score)}%`}</Typography>
// //       </Box>
// //     </Box>
// //   );
// // };

// // const AnimatedJobCard = ({
// //   job,
// //   handleViewJob,
// //   handleSaveJob,
// //   handleApplyJob,
// //   handleUndoApplication,
// //   handleReapplyJob,
// //   isSaving,
// //   isApplying,
// //   showUndoButton,
// //   showReapplyButton,
// //   hideSaveButton,
// //   isSavedTab,
// // }) => {
// //   const theme = useTheme();
// //   const { ref, inView } = useInView({
// //     triggerOnce: true,
// //     threshold: 0.1,
// //     rootMargin: "0px 0px -50px 0px",
// //   });

// //   const renderStatusDisplay = (forDesktop) => {
// //     const commonButtonProps = {
// //       disabled: true,
// //       size: "small",
// //       sx: forDesktop
// //         ? {
// //             fontSize: "0.75rem",
// //             borderRadius: 2,
// //             px: 2,
// //             py: 1,
// //             textTransform: "none",
// //           }
// //         : {
// //             textTransform: "none",
// //           },
// //     };

// //     switch (job.applicationStatus) {
// //       case "Hired":
// //         return (
// //           <Button
// //             {...commonButtonProps}
// //             variant="contained"
// //             startIcon={<CheckCircle />}
// //             color="success"
// //             sx={{
// //               ...commonButtonProps.sx,
// //               "&.Mui-disabled": {
// //                 backgroundColor: theme.palette.success.main,
// //                 color: theme.palette.success.contrastText,
// //                 opacity: 0.9,
// //               },
// //             }}
// //           >
// //             Hired
// //           </Button>
// //         );

// //       case "Offer Rejected":
// //         return (
// //           <Button
// //             {...commonButtonProps}
// //             variant="outlined"
// //             startIcon={<HighlightOff />}
// //             color="error"
// //             sx={{
// //               ...commonButtonProps.sx,
// //               "&.Mui-disabled": {
// //                 backgroundColor: alpha(theme.palette.error.main, 0.1),
// //                 borderColor: theme.palette.error.main,
// //                 color: theme.palette.error.main,
// //               },
// //             }}
// //           >
// //             Offer Rejected
// //           </Button>
// //         );

// //       case "Offer Extended":
// //         return (
// //           <Button
// //             {...commonButtonProps}
// //             variant="outlined"
// //             startIcon={<PriorityHigh />}
// //             sx={{
// //               ...commonButtonProps.sx,
// //               "&.Mui-disabled": {
// //                 backgroundColor: alpha(theme.palette.warning.main, 0.2),
// //                 borderColor: theme.palette.warning.main,
// //                 color:
// //                   theme.palette.mode === "light"
// //                     ? "#997400"
// //                     : theme.palette.warning.main,
// //               },
// //             }}
// //           >
// //             Offer Extended
// //           </Button>
// //         );

// //       default: // Default applied button for "Applied", "Under Review", etc.
// //         return (
// //           <Button
// //             {...commonButtonProps}
// //             variant="contained"
// //             startIcon={<CheckCircle />}
// //             sx={{
// //               ...commonButtonProps.sx,
// //               "&.Mui-disabled": {
// //                 backgroundColor: alpha(theme.palette.success.main, 0.2),
// //                 color: "success.dark",
// //               },
// //             }}
// //           >
// //             {job.applicationStatus || "Applied"}
// //           </Button>
// //         );
// //     }
// //   };

// //   // This is the new, clean mobile layout.
// //   const MobileLayout = () => (
// //     <Stack sx={{ p: 2, gap: 2 }}>
// //       {/* SECTION 1: HEADER (Logo, Title, Company) */}
// //       <Stack direction="row" spacing={2} alignItems="center">
// //         <Avatar
// //           src={job.logo}
// //           sx={{ width: 48, height: 48 }}
// //           alt={`${job.company} logo`}
// //         />
// //         <Box sx={{ minWidth: 0 }}>
// //           <Typography
// //             variant="h6"
// //             sx={{
// //               fontWeight: 600,
// //               fontSize: "1rem",
// //               overflow: "hidden",
// //               textOverflow: "ellipsis",
// //               whiteSpace: "nowrap",
// //             }}
// //           >
// //             {job.title}
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary">
// //             {job.company}
// //           </Typography>
// //         </Box>
// //       </Stack>

// //       {/* SECTION 2: BODY (Key Details as Chips) */}
// //       <Stack direction="row" flexWrap="wrap" gap={1}>
// //         <Chip
// //           icon={<LocationOn />}
// //           label={job.location}
// //           size="small"
// //           variant="outlined"
// //         />
// //         <Chip
// //           icon={<Work />}
// //           label={job.experience}
// //           size="small"
// //           variant="outlined"
// //         />
// //         <Chip
// //           icon={<AttachMoney />}
// //           label={job.salary}
// //           size="small"
// //           variant="outlined"
// //         />
// //         {job.visaSponsorship && (
// //           <Chip label="Visa Sponsored" size="small" color="primary" />
// //         )}
// //       </Stack>

// //       <Typography variant="caption" color="text.secondary">
// //         <CalendarToday
// //           sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
// //         />
// //         Posted {job.posted}
// //       </Typography>

// //       {/* SEPARATOR */}
// //       <Divider sx={{ my: 1 }} />

// //       {/* SECTION 3: FOOTER (AI Score and Actions) */}
// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //         }}
// //       >
// //         <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
// //           <AnimatedMatchScore score={job.matchScore} />
// //           <Typography
// //             variant="caption"
// //             sx={{
// //               fontWeight: "bold",
// //               display: "block",
// //               mt: 0.5,
// //               color: "primary.main",
// //             }}
// //           >
// //             AI Match
// //           </Typography>
// //         </Box>

// //         {/* Re-using the same button logic */}
// //         <Stack direction="row" spacing={1} alignItems="center">
// //           {job.applied ? (
// //             job.applicationStatus === "Withdrawn" && showReapplyButton ? (
// //               <Button
// //                 variant="contained"
// //                 color="secondary"
// //                 size="small"
// //                 onClick={(e) => {
// //                   e.stopPropagation();
// //                   handleReapplyJob(job.applicationId, job.id);
// //                 }}
// //                 disabled={isApplying === job.id}
// //                 sx={{ textTransform: "none" }}
// //               >
// //                 Re-apply
// //               </Button>
// //             ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
// //               <Button
// //                 variant="outlined"
// //                 color="error"
// //                 size="small"
// //                 onClick={(e) => {
// //                   e.stopPropagation();
// //                   handleUndoApplication(job.applicationId, job.id);
// //                 }}
// //                 disabled={isApplying === job.id}
// //                 sx={{ textTransform: "none" }}
// //               >
// //                 Withdraw
// //               </Button>
// //             ) : (
// //               renderStatusDisplay(false)
// //             )
// //           ) : (
// //             <Button
// //               variant="contained"
// //               size="small"
// //               color="primary"
// //               disabled={isApplying === job.id}
// //               onClick={(e) => {
// //                 e.stopPropagation();
// //                 handleApplyJob(job.id);
// //               }}
// //               sx={{
// //                 textTransform: "none",
// //               }}
// //             >
// //               {isApplying === job.id ? (
// //                 <CircularProgress size={16} color="inherit" />
// //               ) : (
// //                 "Apply"
// //               )}
// //             </Button>
// //           )}
// //           {!hideSaveButton && (
// //             <IconButton
// //               size="small"
// //               disabled={isSaving === job.id}
// //               onClick={(e) => {
// //                 e.stopPropagation();
// //                 handleSaveJob(job.id);
// //               }}
// //               sx={{
// //                 border: (theme) => `1px solid ${theme.palette.divider}`,
// //                 color: job.saved ? "primary.main" : "text.secondary",
// //               }}
// //             >
// //               {isSaving === job.id ? (
// //                 <CircularProgress size={20} />
// //               ) : job.saved ? (
// //                 <Bookmark fontSize="small" />
// //               ) : (
// //                 <BookmarkBorder fontSize="small" />
// //               )}
// //             </IconButton>
// //           )}
// //         </Stack>
// //       </Box>
// //     </Stack>
// //   );

// //   // This is your original, excellent desktop layout.
// //   const DesktopLayout = () => (
// //     <>
// //       <Box sx={{ display: "flex", flex: 1, gap: 2 }}>
// //         <Avatar
// //           src={job.logo}
// //           sx={{ width: 48, height: 48, mt: 0.5 }}
// //           alt={`${job.company} logo`}
// //         />
// //         <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
// //           <Typography
// //             variant="h6"
// //             sx={{
// //               fontWeight: 600,
// //               fontSize: "16px",
// //               color: "text.primary",
// //               overflow: "hidden",
// //               textOverflow: "ellipsis",
// //               whiteSpace: "nowrap",
// //             }}
// //           >
// //             {job.title}
// //           </Typography>
// //           <Typography
// //             variant="body2"
// //             sx={{ fontSize: "14px", color: "text.secondary", fontWeight: 500 }}
// //           >
// //             {job.company}
// //           </Typography>
// //           <Stack direction="row" spacing={2} alignItems="center">
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "13px", color: "text.secondary" }}
// //             >
// //               <LocationOn
// //                 sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
// //               />
// //               {job.location}
// //             </Typography>
// //             <Typography
// //               variant="body2"
// //               sx={{ fontSize: "13px", color: "text.secondary" }}
// //             >
// //               <Work sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }} />
// //               {job.experience}
// //             </Typography>
// //           </Stack>
// //           <Typography
// //             variant="body2"
// //             sx={{ fontSize: "13px", color: "text.secondary" }}
// //           >
// //             <AttachMoney
// //               sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
// //             />
// //             {job.salary}
// //           </Typography>
// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
// //             {job.visaSponsorship && (
// //               <Chip
// //                 label="Visa Sponsored"
// //                 size="small"
// //                 color="primary"
// //                 sx={{
// //                   fontSize: "11px",
// //                   height: "auto",
// //                   p: "4px 8px",
// //                 }}
// //               />
// //             )}
// //             {job.requirements.slice(0, 5).map((skill, index) => (
// //               <Chip
// //                 key={index}
// //                 label={skill}
// //                 size="small"
// //                 sx={{
// //                   bgcolor: "action.selected",
// //                   color: "primary.main",
// //                   borderRadius: "6px",
// //                   fontSize: "12px",
// //                   height: "auto",
// //                   p: "4px 8px",
// //                 }}
// //               />
// //             ))}
// //           </Box>
// //           <Typography
// //             variant="caption"
// //             sx={{ color: "text.secondary", fontSize: "12px", mt: 1 }}
// //           >
// //             <CalendarToday
// //               sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
// //             />
// //             Posted {job.posted}
// //           </Typography>
// //         </Stack>
// //       </Box>
// //       <Stack
// //         spacing={2}
// //         alignItems="center"
// //         justifyContent="center"
// //         sx={{ width: "120px", flexShrink: 0, pl: 2 }}
// //       >
// //         <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
// //           <AnimatedMatchScore score={job.matchScore} />
// //           <Chip
// //             label="AI Match"
// //             size="small"
// //             color="primary"
// //             icon={<TrendingUp />}
// //             onClick={(e) => e.stopPropagation()}
// //             sx={{
// //               fontSize: "11px",
// //               mt: 1,
// //               height: "auto",
// //               p: "4px 8px",
// //               "& .MuiChip-icon": {
// //                 color: "primary.contrastText",
// //                 fontSize: "14px",
// //               },
// //             }}
// //           />
// //         </Box>
// //         <Stack direction="row" spacing={1} alignItems="center">
// //           {job.applied ? (
// //             job.applicationStatus === "Withdrawn" && showReapplyButton ? (
// //               <Button
// //                 variant="contained"
// //                 color="secondary"
// //                 startIcon={
// //                   isApplying === job.id ? (
// //                     <CircularProgress size={16} color="inherit" />
// //                   ) : (
// //                     <ReplayIcon />
// //                   )
// //                 }
// //                 size="small"
// //                 disabled={isApplying === job.id}
// //                 onClick={(e) => {
// //                   e.stopPropagation();
// //                   handleReapplyJob(job.applicationId, job.id);
// //                 }}
// //                 sx={{
// //                   fontSize: "0.75rem",
// //                   borderRadius: 2,
// //                   px: 2,
// //                   py: 1,
// //                   textTransform: "none",
// //                 }}
// //               >
// //                 Re-apply
// //               </Button>
// //             ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
// //               <Button
// //                 variant="outlined"
// //                 color="error"
// //                 startIcon={
// //                   isApplying === job.id ? (
// //                     <CircularProgress size={16} color="inherit" />
// //                   ) : (
// //                     <UndoIcon />
// //                   )
// //                 }
// //                 size="small"
// //                 disabled={isApplying === job.id}
// //                 onClick={(e) => {
// //                   e.stopPropagation();
// //                   handleUndoApplication(job.applicationId, job.id);
// //                 }}
// //                 sx={{
// //                   fontSize: "0.75rem",
// //                   borderRadius: 2,
// //                   px: 2,
// //                   py: 1,
// //                   borderColor: alpha(theme.palette.error.main, 0.5),
// //                   "&:hover": {
// //                     backgroundColor: alpha(theme.palette.error.main, 0.08),
// //                     borderColor: "error.main",
// //                   },
// //                 }}
// //               >
// //                 Withdraw
// //               </Button>
// //             ) : (
// //               renderStatusDisplay(true)
// //             )
// //           ) : (
// //             <Button
// //               variant="contained"
// //               color="primary"
// //               size="small"
// //               disabled={isApplying === job.id}
// //               onClick={(e) => {
// //                 e.stopPropagation();
// //                 handleApplyJob(job.id);
// //               }}
// //               sx={{
// //                 width: "72px",
// //                 height: "32px",
// //                 fontSize: "13px",
// //                 fontWeight: "600",
// //                 borderRadius: "6px",
// //                 textTransform: "none",
// //                 boxShadow: "none",
// //                 "&:hover": {
// //                   boxShadow: "none",
// //                 },
// //               }}
// //             >
// //               {isApplying === job.id ? (
// //                 <CircularProgress size={16} color="inherit" />
// //               ) : (
// //                 "Apply"
// //               )}
// //             </Button>
// //           )}
// //           {!hideSaveButton && (
// //             <IconButton
// //               size="small"
// //               disabled={isSaving === job.id}
// //               onClick={(e) => {
// //                 e.stopPropagation();
// //                 handleSaveJob(job.id);
// //               }}
// //               sx={{
// //                 border: (theme) => `1px solid ${theme.palette.divider}`,
// //                 color: job.saved ? "primary.main" : "text.secondary",
// //                 mr: isSavedTab ? 1 : 0,
// //               }}
// //             >
// //               {isSaving === job.id ? (
// //                 <CircularProgress size={20} />
// //               ) : job.saved ? (
// //                 <Bookmark fontSize="small" />
// //               ) : (
// //                 <BookmarkBorder fontSize="small" />
// //               )}
// //             </IconButton>
// //           )}
// //         </Stack>
// //       </Stack>
// //     </>
// //   );

// //   return (
// //     <Card
// //       ref={ref}
// //       variant="outlined"
// //       sx={{
// //         borderRadius: "12px",
// //         backgroundColor: "mint.main",
// //         boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
// //         transition: "all 0.3s ease-in-out",
// //         opacity: inView ? 1 : 0,
// //         transform: inView ? "translateY(0)" : "translateY(20px)",
// //         "&:hover": {
// //           boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
// //           transform: "translateY(-4px)",
// //         },
// //         cursor: "pointer",
// //       }}
// //       onClick={() => handleViewJob(job)}
// //     >
// //       {/* Conditionally render layouts based on screen size */}
// //       <Box sx={{ display: { xs: "block", sm: "none" } }}>
// //         <MobileLayout />
// //       </Box>
// //       <Box sx={{ display: { xs: "none", sm: "flex" }, p: 2, width: "100%" }}>
// //         <DesktopLayout />
// //       </Box>
// //     </Card>
// //   );
// // };

// // const JobCardSkeleton = () => {
// //   return (
// //     <Card variant="outlined" sx={{ backgroundColor: "background.paper", p: 3 }}>
// //       <Box sx={{ display: "flex", height: "100%", gap: 3 }}>
// //         <Box sx={{ flex: 1 }}>
// //           <Stack spacing={2}>
// //             <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
// //               <Skeleton variant="circular" width={56} height={56} />
// //               <Box sx={{ flex: 1 }}>
// //                 <Skeleton
// //                   variant="text"
// //                   width="80%"
// //                   height={28}
// //                   sx={{ mb: 0.5 }}
// //                 />
// //                 <Skeleton variant="text" width="60%" height={24} />
// //               </Box>
// //             </Box>
// //             <Skeleton variant="text" width="40%" height={20} sx={{ ml: 9 }} />
// //             <Box sx={{ display: "flex", gap: 2, ml: 9 }}>
// //               <Skeleton variant="text" width={80} height={20} />
// //               <Skeleton variant="text" width={120} height={20} />
// //             </Box>
// //             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", ml: 9 }}>
// //               {[...Array(4)].map((_, index) => (
// //                 <Skeleton
// //                   key={index}
// //                   variant="rectangular"
// //                   width={Math.random() * 40 + 50}
// //                   height={24}
// //                   sx={{ borderRadius: 1 }}
// //                 />
// //               ))}
// //             </Box>
// //             <Skeleton variant="text" width="30%" height={20} sx={{ ml: 9 }} />
// //           </Stack>
// //         </Box>
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             alignItems: "center",
// //             justifyContent: "space-between",
// //             width: "120px",
// //             flexShrink: 0,
// //             py: 1,
// //           }}
// //         >
// //           <Box
// //             sx={{
// //               display: "flex",
// //               flexDirection: "column",
// //               alignItems: "center",
// //             }}
// //           >
// //             <Skeleton variant="circular" width={80} height={80} />
// //             <Skeleton
// //               variant="rectangular"
// //               width={70}
// //               height={24}
// //               sx={{ mt: 1, borderRadius: 2 }}
// //             />
// //           </Box>
// //           <Box sx={{ display: "flex", gap: 1 }}>
// //             <Skeleton
// //               variant="rectangular"
// //               width={60}
// //               height={36}
// //               sx={{ borderRadius: 2 }}
// //             />
// //             <Skeleton variant="circular" width={36} height={36} />
// //           </Box>
// //         </Box>
// //       </Box>
// //     </Card>
// //   );
// // };

// // const FilterSkeleton = () => {
// //   return (
// //     <Paper
// //       variant="outlined"
// //       sx={{ p: 2, backgroundColor: "background.paper" }}
// //     >
// //       <Stack spacing={3}>
// //         <Box
// //           sx={{
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //           }}
// //         >
// //           <Skeleton variant="text" width={80} height={28} />
// //           <Skeleton variant="text" width={60} height={24} />
// //         </Box>
// //         <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 2 }} />
// //         {[...Array(3)].map((_, index) => (
// //           <Skeleton
// //             key={index}
// //             variant="rectangular"
// //             height={40}
// //             sx={{ borderRadius: 2 }}
// //           />
// //         ))}
// //         <Box>
// //           <Stack spacing={1}>
// //             {[...Array(2)].map((_, index) => (
// //               <Box
// //                 key={index}
// //                 sx={{ display: "flex", alignItems: "center", gap: 1 }}
// //               >
// //                 <Skeleton variant="rectangular" width={20} height={20} />
// //                 <Skeleton variant="text" width={120} height={20} />
// //               </Box>
// //             ))}
// //           </Stack>
// //         </Box>
// //       </Stack>
// //     </Paper>
// //   );
// // };

// // const TabsSkeleton = () => {
// //   return (
// //     <Paper
// //       square
// //       elevation={2}
// //       sx={{ flexShrink: 0, bgcolor: "background.paper" }}
// //     >
// //       <Box sx={{ display: "flex", height: 48 }}>
// //         {[...Array(3)].map((_, index) => (
// //           <Box
// //             key={index}
// //             sx={{
// //               flex: 1,
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               p: 2,
// //             }}
// //           >
// //             <Skeleton variant="text" width={80} height={24} />
// //           </Box>
// //         ))}
// //       </Box>
// //     </Paper>
// //   );
// // };

// // const JobDialogSkeleton = () => {
// //   return (
// //     <>
// //       <DialogTitle>
// //         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
// //           <Skeleton
// //             variant="circular"
// //             width={{ xs: 40, sm: 60 }}
// //             height={{ xs: 40, sm: 60 }}
// //           />
// //           <Box sx={{ flexGrow: 1 }}>
// //             <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
// //             <Skeleton variant="text" width="40%" height={28} />
// //           </Box>
// //           <Skeleton variant="circular" width={40} height={40} />
// //           <Skeleton variant="circular" width={40} height={40} />
// //         </Box>
// //       </DialogTitle>
// //       <DialogContent dividers>
// //         <Stack spacing={3}>
// //           <Skeleton variant="rectangular" width="100%" height={120} />
// //           <Skeleton variant="rectangular" width="100%" height={200} />
// //           <Skeleton variant="rectangular" width="100%" height={150} />
// //         </Stack>
// //       </DialogContent>
// //       <DialogActions
// //         sx={{ p: { xs: 2, sm: 3 }, justifyContent: "flex-end", gap: 1 }}
// //       >
// //         <Skeleton
// //           variant="rectangular"
// //           width={80}
// //           height={36}
// //           sx={{ borderRadius: 1 }}
// //         />
// //         <Skeleton
// //           variant="rectangular"
// //           width={120}
// //           height={36}
// //           sx={{ borderRadius: 1 }}
// //         />
// //       </DialogActions>
// //     </>
// //   );
// // };

// // const TabLabel = ({ count, label, color }) => (
// //   <Stack direction="row" spacing={1} alignItems="center">
// //     <Box
// //       component="span"
// //       sx={{
// //         bgcolor: `${color}.main`,
// //         color: `${color}.contrastText`,
// //         borderRadius: "10px",
// //         px: 0.8,
// //         py: 0.1,
// //         minWidth: 20,
// //         fontSize: "0.75rem",
// //         fontWeight: "bold",
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //       }}
// //     >
// //       {count}
// //     </Box>
// //     <Typography
// //       component="span"
// //       sx={{ textTransform: "none", fontWeight: 500 }}
// //     >
// //       {label}
// //     </Typography>
// //   </Stack>
// // );

// // const SectionCard = ({ children, ...props }) => (
// //   <Paper
// //     variant="outlined"
// //     sx={{
// //       p: { xs: 2, md: 3 },
// //       borderRadius: 3,
// //       BoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
// //       borderColor: (theme) => alpha(theme.palette.divider, 0.5),
// //       bgcolor: "background.paper",
// //     }}
// //     {...props}
// //   >
// //     {children}
// //   </Paper>
// // );

// // const SectionHeader = ({ icon, title }) => (
// //   <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
// //     <Avatar
// //       sx={{
// //         bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
// //         color: "primary.main",
// //         width: 32,
// //         height: 32,
// //       }}
// //     >
// //       {icon}
// //     </Avatar>
// //     <Typography variant="h6" fontWeight="bold" color="text.primary">
// //       {title}
// //     </Typography>
// //   </Box>
// // );

// // const KeyDetail = ({ icon, label, value }) => (
// //   <Grid item xs={12} sm={6} md={4}>
// //     <Stack direction="row" spacing={1.5} alignItems="center">
// //       <Box color="text.secondary">{icon}</Box>
// //       <Box>
// //         <Typography
// //           variant="caption"
// //           color="text.secondary"
// //           sx={{ display: "block", lineHeight: 1.2 }}
// //         >
// //           {label}
// //         </Typography>
// //         <Typography variant="body2" fontWeight="bold" color="text.primary">
// //           {value}
// //         </Typography>
// //       </Box>
// //     </Stack>
// //   </Grid>
// // );

// // function JobBrowser() {
// //   const { showNotification } = useNotification();
// //   const theme = useTheme();
// //   const [jobs, setJobs] = useState([]);
// //   const [filteredJobs, setFilteredJobs] = useState([]);
// //   const [selectedJob, setSelectedJob] = useState(null);
// //   const [openJobDialog, setOpenJobDialog] = useState(false);
// //   const [tabValue, setTabValue] = useState(0);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [isSaving, setIsSaving] = useState(null);
// //   const [isApplying, setIsApplying] = useState(null);
// //   const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
// //   const [jobDialogLoading, setJobDialogLoading] = useState(false);
// //   const [filters, setFilters] = useState({
// //     location: "",
// //     experience: "",
// //     education: "",
// //   });
// //   const hasFetchedRef = useRef(false);
// //   const getErrorMessage = (err, fallback) => {
// //     if (err && err.response && err.response.data) {
// //       const d = err.response.data;
// //       if (typeof d === "string") return d;
// //       return d.detail || d.message || fallback;
// //     }
// //     if (
// //       typeof err?.message === "string" &&
// //       err.message.toLowerCase().includes("network")
// //     ) {
// //       return "Network error. Please check your connection.";
// //     }
// //     return fallback;
// //   };
// //   const transformJobData = (apiJob) => ({
// //     id: apiJob.id,
// //     title: apiJob.title,
// //     company: apiJob.company_details?.company_name || "Unknown Company",
// //     location: apiJob.location,
// //     salary:
// //       apiJob.salary_min && apiJob.salary_max
// //         ? `${apiJob.salary_currency} ${Number.parseFloat(
// //             apiJob.salary_min
// //           ).toLocaleString()} - ${Number.parseFloat(
// //             apiJob.salary_max
// //           ).toLocaleString()}`
// //         : "Not Disclosed",
// //     type: apiJob.job_type_display || apiJob.job_type,
// //     experience: apiJob.experience_level_display || apiJob.experience_level,
// //     posted: new Date(apiJob.created_at).toLocaleDateString(),
// //     logo: apiJob.company_details?.logo || "/placeholder.svg?height=60&width=60",
// //     description: apiJob.description,
// //     requirements: apiJob.required_skills || [],
// //     benefits: apiJob.benefits || [],
// //     matchScore: 0,
// //     saved: false,
// //     applied: false,
// //     applicationId: null,
// //     applicationStatus: null,
// //     urgent: apiJob.status === "URGENT",
// //     remote: apiJob.remote_work,
// //     visaSponsorship: apiJob.visa_sponsorship,
// //     responsibilities: apiJob.responsibilities,
// //     applicationDeadline: apiJob.application_deadline,
// //   });
// //   useEffect(() => {
// //     if (hasFetchedRef.current) return;
// //     hasFetchedRef.current = true;
// //     const loadData = async () => {
// //       setLoading(true);
// //       setError(null);
// //       try {
// //         const [
// //           jobsResponse,
// //           aiScoresResponse,
// //           savedJobsResponse,
// //           applicationsResponse,
// //         ] = await Promise.all([
// //           apiClient.get("/job-postings/"),
// //           apiClient.get("/job-postings/ai-score/"),
// //           apiClient.get("/saved-jobs/"),
// //           apiClient.get("/applications/"),
// //         ]);
// //         const jobsData = jobsResponse.data
// //           .filter((j) => j.status === "PUBLISHED")
// //           .map(transformJobData);
// //         const aiScoresData = aiScoresResponse.data;
// //         const savedJobIds = new Set(
// //           savedJobsResponse.data.map((sj) => sj.job_posting.id)
// //         );
// //         const applicationsData = applicationsResponse.data;
// //         const applicationsMap = new Map(
// //           applicationsData.map((app) => {
// //             const appStatus = app.status_display || app.status;
// //             return [
// //               app.job_posting,
// //               {
// //                 id: app.id,
// //                 status: appStatus === "Deleted" ? "Withdrawn" : appStatus,
// //               },
// //             ];
// //           })
// //         );
// //         const finalJobs = jobsData.map((job) => {
// //           const aiScore = aiScoresData.find((score) => score.id === job.id);
// //           const applicationDetails = applicationsMap.get(job.id);
// //           return {
// //             ...job,
// //             matchScore: aiScore ? Math.round(aiScore.matching_percentage) : 0,
// //             saved: savedJobIds.has(job.id),
// //             applied: !!applicationDetails,
// //             applicationId: applicationDetails?.id || null,
// //             applicationStatus: applicationDetails?.status || null,
// //           };
// //         });
// //         finalJobs.sort((a, b) => b.matchScore - a.matchScore);
// //         setJobs(finalJobs);
// //         setFilteredJobs(finalJobs);
// //       } catch (err) {
// //         const errorMessage = getErrorMessage(
// //           err,
// //           "Failed to load data. Please try again."
// //         );
// //         setError(errorMessage);
// //         showNotification(errorMessage, "error");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     loadData();
// //   }, [showNotification]);
// //   const filterJobs = (search, currentFilters, currentTab, baseJobs = jobs) => {
// //     let sourceJobs = [...baseJobs];
// //     if (currentTab === 1) {
// //       sourceJobs = baseJobs.filter((job) => job.saved);
// //     } else if (currentTab === 2) {
// //       sourceJobs = baseJobs.filter(
// //         (job) => job.applied && job.applicationStatus !== "Withdrawn"
// //       );
// //     } else if (currentTab === 3) {
// //       sourceJobs = baseJobs.filter(
// //         (job) => job.applied && job.applicationStatus === "Withdrawn"
// //       );
// //     }
// //     const filtered = sourceJobs.filter((job) => {
// //       const searchTermLower = search.toLowerCase();
// //       const matchesSearch =
// //         search === "" ||
// //         job.title.toLowerCase().includes(searchTermLower) ||
// //         job.company.toLowerCase().includes(searchTermLower);
// //       const matchesLocation =
// //         !currentFilters.location ||
// //         job.location
// //           .toLowerCase()
// //           .includes(currentFilters.location.toLowerCase());
// //       const matchesExperience =
// //         !currentFilters.experience ||
// //         job.experience === currentFilters.experience;
// //       const matchesEducation =
// //         !currentFilters.education || job.education === currentFilters.education;
// //       return (
// //         matchesSearch &&
// //         matchesLocation &&
// //         matchesExperience &&
// //         matchesEducation
// //       );
// //     });
// //     setFilteredJobs(filtered);
// //   };
// //   const handleTabChange = (event, newValue) => {
// //     setTabValue(newValue);
// //     filterJobs(searchTerm, filters, newValue);
// //   };
// //   const handleSearch = (event) => {
// //     const term = event.target.value;
// //     setSearchTerm(term);
// //     filterJobs(term, filters, tabValue);
// //   };
// //   const handleFilterChange = (event) => {
// //     const { name, value } = event.target;
// //     const newFilters = { ...filters, [name]: value };
// //     setFilters(newFilters);
// //     filterJobs(searchTerm, newFilters, tabValue);
// //   };
// //   const clearAllFilters = () => {
// //     const newFilters = {
// //       location: "",
// //       experience: "",
// //       education: "",
// //     };
// //     setFilters(newFilters);
// //     setSearchTerm("");
// //     filterJobs("", newFilters, tabValue);
// //   };
// //   const handleSaveJob = async (jobId) => {
// //     setIsSaving(jobId);
// //     const jobToUpdate = jobs.find((j) => j.id === jobId);
// //     const isCurrentlySaved = jobToUpdate.saved;
// //     try {
// //       if (isCurrentlySaved) {
// //         await apiClient.delete(`/saved-jobs/unsave/`, {
// //           data: { job_posting_id: jobId },
// //         });
// //       } else {
// //         await apiClient.post(`/saved-jobs/save/`, { job_posting_id: jobId });
// //       }
// //       const updatedJobs = jobs.map((j) =>
// //         j.id === jobId ? { ...j, saved: !isCurrentlySaved } : j
// //       );
// //       setJobs(updatedJobs);
// //       showNotification(
// //         isCurrentlySaved
// //           ? "Job removed from saved list"
// //           : "Job saved successfully!",
// //         "success"
// //       );
// //       filterJobs(searchTerm, filters, tabValue, updatedJobs);
// //     } catch (error) {
// //       showNotification(
// //         getErrorMessage(error, "Failed to update job status."),
// //         "error"
// //       );
// //     } finally {
// //       setIsSaving(null);
// //     }
// //   };
// //   const handleApplyJob = async (jobId) => {
// //     setIsApplying(jobId);
// //     try {
// //       const response = await apiClient.post("/applications/", {
// //         job_posting: jobId,
// //       });
// //       const newApplication = response.data;
// //       const updatedJobs = jobs.map((job) =>
// //         job.id === jobId
// //           ? {
// //               ...job,
// //               applied: true,
// //               applicationId: newApplication.id,
// //               applicationStatus:
// //                 newApplication.status_display || newApplication.status,
// //             }
// //           : job
// //       );
// //       setJobs(updatedJobs);
// //       showNotification("Application submitted successfully!", "success");
// //       filterJobs(searchTerm, filters, tabValue, updatedJobs);
// //       if (openJobDialog) {
// //         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
// //       }
// //     } catch (error) {
// //       showNotification(
// //         getErrorMessage(error, "Failed to submit application."),
// //         "error"
// //       );
// //     } finally {
// //       setIsApplying(null);
// //     }
// //   };
// //   const handleReapplyJob = async (applicationId, jobId) => {
// //     setIsApplying(jobId);
// //     try {
// //       const response = await apiClient.patch(
// //         `/applications/${applicationId}/`,
// //         {
// //           status: "SUBMITTED",
// //         }
// //       );
// //       const updatedApplication = response.data;
// //       const updatedJobs = jobs.map((job) =>
// //         job.id === jobId
// //           ? {
// //               ...job,
// //               applicationStatus:
// //                 updatedApplication.status_display || updatedApplication.status,
// //             }
// //           : job
// //       );
// //       setJobs(updatedJobs);
// //       showNotification("Re-applied to job successfully!", "success");
// //       setTabValue(0);
// //       filterJobs(searchTerm, filters, 0, updatedJobs);
// //       if (openJobDialog) {
// //         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
// //       }
// //     } catch (error) {
// //       showNotification(getErrorMessage(error, "Failed to re-apply."), "error");
// //     } finally {
// //       setIsApplying(null);
// //     }
// //   };
// //   const handleUndoApplication = async (applicationId, jobId) => {
// //     setIsApplying(jobId);
// //     try {
// //       await apiClient.delete(`/applications/${applicationId}/delete/`);
// //       const updatedJobs = jobs.map((job) =>
// //         job.id === jobId
// //           ? {
// //               ...job,
// //               applied: true,
// //               applicationStatus: "Withdrawn",
// //             }
// //           : job
// //       );
// //       setJobs(updatedJobs);
// //       showNotification("Application successfully withdrawn!", "success");
// //       setTabValue(3);
// //       filterJobs(searchTerm, filters, 3, updatedJobs);
// //       if (openJobDialog) {
// //         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
// //       }
// //     } catch (error) {
// //       showNotification(
// //         getErrorMessage(error, "Failed to withdraw application."),
// //         "error"
// //       );
// //     } finally {
// //       setIsApplying(null);
// //     }
// //   };
// //   const handleViewJob = (job) => {
// //     setSelectedJob(job);
// //     setOpenJobDialog(true);
// //     setJobDialogLoading(true);
// //     setTimeout(() => {
// //       setJobDialogLoading(false);
// //     }, 800);
// //   };
// //   if (loading) {
// //     return (
// //       <Layout title="Global Job Opportunities">
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
// //             p: { xs: 1, sm: 2, md: 3 },
// //             bgcolor: "background.default",
// //           }}
// //         >
// //           <Box sx={{ flexShrink: 0, mb: 2 }}>
// //             <TabsSkeleton />
// //           </Box>
// //           <Box sx={{ mb: 3 }}>
// //             <FilterSkeleton />
// //           </Box>
// //           <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
// //             <Stack spacing={2.5}>
// //               {[...Array(4)].map((_, index) => (
// //                 <JobCardSkeleton key={index} />
// //               ))}
// //             </Stack>
// //           </Box>
// //         </Box>
// //       </Layout>
// //     );
// //   }
// //   if (error) {
// //     return (
// //       <Layout title="Global Job Opportunities">
// //         <Box sx={{ p: 3 }}>
// //           <Alert severity="error">{error}</Alert>
// //         </Box>
// //       </Layout>
// //     );
// //   }
// //   const allJobsCount = jobs.length;
// //   const savedJobsCount = jobs.filter((j) => j.saved).length;
// //   const appliedJobsCount = jobs.filter(
// //     (j) => j.applied && j.applicationStatus !== "Withdrawn"
// //   ).length;
// //   const withdrawnJobsCount = jobs.filter(
// //     (j) => j.applied && j.applicationStatus === "Withdrawn"
// //   ).length;
// //   const renderFilterBar = () => (
// //     <Paper
// //       elevation={0}
// //       variant="outlined"
// //       sx={{
// //         p: "12px",
// //         borderRadius: "12px",
// //         bgcolor: "mint.main",
// //         BoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
// //         mb: 3,
// //       }}
// //     >
// //       <Grid container spacing={2} alignItems="center">
// //         <Grid item xs={12} md={4} lg={5}>
// //           <TextField
// //             fullWidth
// //             variant="outlined"
// //             placeholder="Search Jobs, Companies"
// //             value={searchTerm}
// //             onChange={handleSearch}
// //             InputProps={{
// //               startAdornment: (
// //                 <InputAdornment position="start">
// //                   <Search />
// //                 </InputAdornment>
// //               ),
// //               sx: { borderRadius: "8px", fontSize: "14px" },
// //             }}
// //           />
// //         </Grid>
// //         <Grid item xs={12} sm={4} md={2} lg={2}>
// //           <FormControl fullWidth>
// //             <Select
// //               displayEmpty
// //               value={filters.location}
// //               name="location"
// //               onChange={handleFilterChange}
// //               sx={{
// //                 borderRadius: "8px",
// //                 fontSize: "13px",
// //                 color: filters.location ? "inherit" : "text.secondary",
// //               }}
// //             >
// //               <MenuItem value="">Location</MenuItem>
// //               {[...new Set(jobs.map((job) => job.location))]
// //                 .sort()
// //                 .map((loc) => (
// //                   <MenuItem key={loc} value={loc}>
// //                     {loc}
// //                   </MenuItem>
// //                 ))}
// //             </Select>
// //           </FormControl>
// //         </Grid>
// //         <Grid item xs={12} sm={4} md={2} lg={2}>
// //           <FormControl fullWidth>
// //             <Select
// //               displayEmpty
// //               value={filters.education}
// //               name="education"
// //               onChange={handleFilterChange}
// //               sx={{
// //                 borderRadius: "8px",
// //                 fontSize: "13px",
// //                 color: filters.education ? "inherit" : "text.secondary",
// //               }}
// //             >
// //               <MenuItem value="">Education</MenuItem>
// //               <MenuItem value="bachelor">Bachelor's</MenuItem>
// //               <MenuItem value="master">Master's</MenuItem>
// //               <MenuItem value="phd">PhD</MenuItem>
// //             </Select>
// //           </FormControl>
// //         </Grid>
// //         <Grid item xs={12} sm={4} md={2} lg={2}>
// //           <FormControl fullWidth>
// //             <Select
// //               displayEmpty
// //               value={filters.experience}
// //               name="experience"
// //               onChange={handleFilterChange}
// //               sx={{
// //                 borderRadius: "8px",
// //                 fontSize: "13px",
// //                 color: filters.experience ? "inherit" : "text.secondary",
// //               }}
// //             >
// //               <MenuItem value="">Experience</MenuItem>
// //               {[...new Set(jobs.map((job) => job.experience))]
// //                 .sort()
// //                 .map((exp) => (
// //                   <MenuItem key={exp} value={exp}>
// //                     {exp}
// //                   </MenuItem>
// //                 ))}
// //             </Select>
// //           </FormControl>
// //         </Grid>
// //         <Grid item xs={12} md="auto">
// //           <Button
// //             onClick={clearAllFilters}
// //             sx={{
// //               textTransform: "none",
// //               color: "primary.main",
// //               fontWeight: "bold",
// //             }}
// //           >
// //             Clear Filter
// //           </Button>
// //         </Grid>
// //       </Grid>
// //     </Paper>
// //   );
// //   return (
// //     <Layout title="Global Job Opportunities">
// //       <Box
// //         sx={{
// //           display: "flex",
// //           flexDirection: "column",
// //           height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
// //           p: { xs: 1, sm: 2, md: 3 },
// //           bgcolor: "background.default",
// //         }}
// //       >
// //         <Paper
// //           square
// //           elevation={0}
// //           sx={{
// //             flexShrink: 0,
// //             mb: 2,
// //             backgroundColor: "transparent",
// //           }}
// //         >
// //           <Tabs
// //             value={tabValue}
// //             onChange={handleTabChange}
// //             centered
// //             sx={{ "& .MuiTab-root": { fontSize: "1rem" } }}
// //           >
// //             <Tab
// //               label={
// //                 <TabLabel
// //                   count={allJobsCount}
// //                   label="All Jobs"
// //                   color="primary"
// //                 />
// //               }
// //             />
// //             <Tab
// //               label={
// //                 <TabLabel
// //                   count={savedJobsCount}
// //                   label="Saved"
// //                   color="secondary"
// //                 />
// //               }
// //             />
// //             <Tab
// //               label={
// //                 <TabLabel
// //                   count={appliedJobsCount}
// //                   label="Applied"
// //                   color="success"
// //                 />
// //               }
// //             />
// //           </Tabs>
// //         </Paper>
// //         {renderFilterBar()}
// //         <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
// //           <Stack spacing={2.5}>
// //             {filteredJobs.length > 0 ? (
// //               filteredJobs.map((job) => (
// //                 <AnimatedJobCard
// //                   key={job.id}
// //                   job={job}
// //                   handleViewJob={handleViewJob}
// //                   handleSaveJob={handleSaveJob}
// //                   handleApplyJob={handleApplyJob}
// //                   handleUndoApplication={handleUndoApplication}
// //                   handleReapplyJob={handleReapplyJob}
// //                   isSaving={isSaving}
// //                   isApplying={isApplying}
// //                   showUndoButton={tabValue === 2}
// //                   showReapplyButton={tabValue === 3}
// //                   hideSaveButton={tabValue === 2}
// //                   isSavedTab={tabValue === 1}
// //                 />
// //               ))
// //             ) : (
// //               <Paper
// //                 sx={{
// //                   p: 6,
// //                   textAlign: "center",
// //                   backgroundColor: "background.paper",
// //                 }}
// //               >
// //                 <Work sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
// //                 <Typography
// //                   variant="h5"
// //                   color="text.primary"
// //                   gutterBottom
// //                   fontWeight={600}
// //                 >
// //                   No jobs found
// //                 </Typography>
// //                 <Typography variant="body1" color="text.secondary">
// //                   Try adjusting your filters or search terms
// //                 </Typography>
// //               </Paper>
// //             )}
// //           </Stack>
// //         </Box>
// //       </Box>
// //       <Dialog
// //         open={openJobDialog}
// //         onClose={() => setOpenJobDialog(false)}
// //         maxWidth="md"
// //         fullWidth
// //         PaperProps={{ sx: { maxHeight: "90vh", borderRadius: 4 } }}
// //       >
// //         {jobDialogLoading ? (
// //           <JobDialogSkeleton />
// //         ) : (
// //           selectedJob &&
// //           (() => {
// //             const currentJobState =
// //               jobs.find((j) => j.id === selectedJob.id) || selectedJob;
// //             return (
// //               <>
// //                 <DialogTitle
// //                   sx={{
// //                     bgcolor: "background.paper",
// //                     borderBottom: `1px solid ${theme.palette.divider}`,
// //                   }}
// //                 >
// //                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
// //                     <Avatar
// //                       src={currentJobState.logo}
// //                       sx={{
// //                         width: 60,
// //                         height: 60,
// //                         border: `2px solid ${theme.palette.divider}`,
// //                         boxShadow: 1,
// //                       }}
// //                     />
// //                     <Box sx={{ flexGrow: 1 }}>
// //                       <Typography
// //                         variant="h5"
// //                         fontWeight="bold"
// //                         color="text.primary"
// //                       >
// //                         {currentJobState.title}
// //                       </Typography>
// //                       <Typography variant="body1" color="text.secondary">
// //                         {currentJobState.company}
// //                       </Typography>
// //                     </Box>
// //                     <Box sx={{ display: { xs: "none", sm: "flex" } }}>
// //                       <IconButton
// //                         disabled={isSaving === currentJobState.id}
// //                         onClick={() => handleSaveJob(currentJobState.id)}
// //                       >
// //                         {isSaving === currentJobState.id ? (
// //                           <CircularProgress size={24} />
// //                         ) : currentJobState.saved ? (
// //                           <Bookmark color="primary" />
// //                         ) : (
// //                           <BookmarkBorder />
// //                         )}
// //                       </IconButton>
// //                       <IconButton>
// //                         <Share />
// //                       </IconButton>
// //                     </Box>
// //                   </Box>
// //                 </DialogTitle>
// //                 <DialogContent
// //                   sx={{ bgcolor: "background.default", p: { xs: 2, md: 3 } }}
// //                 >
// //                   <Stack spacing={3}>
// //                     <SectionCard>
// //                       <Grid container spacing={2} rowSpacing={3}>
// //                         <Grid item xs={12} sm={6} md={8}>
// //                           <Stack spacing={2}>
// //                             <KeyDetail
// //                               icon={<AttachMoney />}
// //                               label="Salary"
// //                               value={currentJobState.salary}
// //                             />
// //                             <KeyDetail
// //                               icon={<LocationOn />}
// //                               label="Location"
// //                               value={currentJobState.location}
// //                             />
// //                             <KeyDetail
// //                               icon={<Business />}
// //                               label="Experience"
// //                               value={currentJobState.experience}
// //                             />
// //                             <KeyDetail
// //                               icon={<Work />}
// //                               label="Job Type"
// //                               value={currentJobState.type}
// //                             />
// //                           </Stack>
// //                         </Grid>
// //                         <Grid
// //                           item
// //                           xs={12}
// //                           sm={6}
// //                           md={4}
// //                           sx={{
// //                             display: "flex",
// //                             alignItems: "center",
// //                             justifyContent: "center",
// //                           }}
// //                         >
// //                           <Box sx={{ textAlign: "center" }}>
// //                             <AnimatedMatchScore
// //                               score={currentJobState.matchScore}
// //                             />
// //                             <Typography
// //                               variant="caption"
// //                               fontWeight="bold"
// //                               color="primary.main"
// //                               sx={{ mt: 1, display: "block" }}
// //                             >
// //                               AI MATCH SCORE
// //                             </Typography>
// //                           </Box>
// //                         </Grid>
// //                       </Grid>
// //                     </SectionCard>
// //                     <SectionCard>
// //                       <SectionHeader
// //                         icon={<Description fontSize="small" />}
// //                         title="Job Description"
// //                       />
// //                       <Typography
// //                         variant="body2"
// //                         sx={{
// //                           whiteSpace: "pre-wrap",
// //                           lineHeight: 1.7,
// //                           color: "text.secondary",
// //                         }}
// //                       >
// //                         {currentJobState.description}
// //                       </Typography>
// //                     </SectionCard>
// //                     {currentJobState.responsibilities && (
// //                       <SectionCard>
// //                         <SectionHeader
// //                           icon={<PlaylistAddCheck fontSize="small" />}
// //                           title="Responsibilities"
// //                         />
// //                         <Typography
// //                           variant="body2"
// //                           sx={{
// //                             whiteSpace: "pre-wrap",
// //                             lineHeight: 1.7,
// //                             color: "text.secondary",
// //                           }}
// //                         >
// //                           {currentJobState.responsibilities}
// //                         </Typography>
// //                       </SectionCard>
// //                     )}
// //                     <SectionCard>
// //                       <SectionHeader
// //                         icon={<Category fontSize="small" />}
// //                         title="Required Skills"
// //                       />
// //                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
// //                         {currentJobState.requirements.map((skill, index) => (
// //                           <Chip
// //                             key={index}
// //                             label={skill}
// //                             variant="outlined"
// //                             color="primary"
// //                           />
// //                         ))}
// //                       </Box>
// //                     </SectionCard>
// //                     <SectionCard>
// //                       <SectionHeader
// //                         icon={<Stars fontSize="small" />}
// //                         title="Benefits & Perks"
// //                       />
// //                       <List
// //                         dense
// //                         sx={{ p: 0, "&& .Mui-ListItem-root": { py: 0.5 } }}
// //                       >
// //                         {currentJobState.benefits.map((benefit, index) => (
// //                           <ListItem key={index} disableGutters>
// //                             <ListItemIcon sx={{ minWidth: 32 }}>
// //                               <CheckCircle
// //                                 color="success"
// //                                 sx={{ fontSize: 20 }}
// //                               />
// //                             </ListItemIcon>
// //                             <ListItemText
// //                               primary={benefit}
// //                               primaryTypographyProps={{
// //                                 color: "text.secondary",
// //                                 fontWeight: 500,
// //                               }}
// //                             />
// //                           </ListItem>
// //                         ))}
// //                       </List>
// //                     </SectionCard>
// //                   </Stack>
// //                 </DialogContent>
// //                 <DialogActions
// //                   sx={{
// //                     p: { xs: 2, sm: 3 },
// //                     justifyContent: "flex-end",
// //                     gap: 2,
// //                     bgcolor: "background.paper",
// //                     borderTop: `1px solid ${theme.palette.divider}`,
// //                   }}
// //                 >
// //                   <Button
// //                     onClick={() => setOpenJobDialog(false)}
// //                     variant="outlined"
// //                     color="secondary"
// //                   >
// //                     Close
// //                   </Button>
// //                   {tabValue === 3 &&
// //                   currentJobState.applied &&
// //                   currentJobState.applicationStatus === "Withdrawn" ? (
// //                     <Button
// //                       variant="contained"
// //                       color="secondary"
// //                       startIcon={
// //                         isApplying === currentJobState.id ? (
// //                           <CircularProgress size={16} color="inherit" />
// //                         ) : (
// //                           <ReplayIcon />
// //                         )
// //                       }
// //                       size="small"
// //                       disabled={isApplying === currentJobState.id}
// //                       onClick={() =>
// //                         handleReapplyJob(
// //                           currentJobState.applicationId,
// //                           currentJobState.id
// //                         )
// //                       }
// //                       sx={{
// //                         px: 4,
// //                         background: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
// //                         "&:hover": {
// //                           background: `linear-gradient(45deg, ${theme.palette.secondary.dark}, ${theme.palette.primary.dark})`,
// //                           transform: "translateY(-1px)",
// //                           boxShadow: `0 6px 20px ${alpha(
// //                             theme.palette.secondary.main,
// //                             0.3
// //                           )}`,
// //                         },
// //                       }}
// //                     >
// //                       {isApplying === currentJobState.id ? (
// //                         <CircularProgress size={24} color="inherit" />
// //                       ) : (
// //                         "Re-apply Now"
// //                       )}
// //                     </Button>
// //                   ) : tabValue === 2 &&
// //                     currentJobState.applied &&
// //                     currentJobState.applicationStatus !== "Withdrawn" ? (
// //                     <Button
// //                       variant="outlined"
// //                       color="error"
// //                       startIcon={
// //                         isApplying === currentJobState.id ? (
// //                           <CircularProgress size={10} color="inherit" />
// //                         ) : (
// //                           <UndoIcon />
// //                         )
// //                       }
// //                       size="small"
// //                       disabled={isApplying === currentJobState.id}
// //                       onClick={() =>
// //                         handleUndoApplication(
// //                           currentJobState.applicationId,
// //                           currentJobState.id
// //                         )
// //                       }
// //                       sx={{
// //                         fontSize: "0.65rem",
// //                         borderRadius: 1,
// //                         borderColor: alpha(theme.palette.error.main, 0.2),
// //                         "&:hover": {
// //                           backgroundColor: alpha(
// //                             theme.palette.error.main,
// //                             0.08
// //                           ),
// //                           borderColor: "error.main",
// //                         },
// //                       }}
// //                     >
// //                       Withdraw
// //                     </Button>
// //                   ) : currentJobState.applied ? (
// //                     (() => {
// //                       const status = currentJobState.applicationStatus;
// //                       const commonProps = {
// //                         disabled: true,
// //                         variant: "contained",
// //                       };

// //                       switch (status) {
// //                         case "Hired":
// //                           return (
// //                             <Button
// //                               {...commonProps}
// //                               startIcon={<CheckCircle />}
// //                               color="success"
// //                               sx={{
// //                                 "&.Mui-disabled": {
// //                                   backgroundColor: theme.palette.success.main,
// //                                   color: theme.palette.success.contrastText,
// //                                   opacity: 0.9,
// //                                 },
// //                               }}
// //                             >
// //                               Status: Hired
// //                             </Button>
// //                           );
// //                         case "Offer Rejected":
// //                           return (
// //                             <Button
// //                               {...commonProps}
// //                               variant="outlined"
// //                               startIcon={<HighlightOff />}
// //                               color="error"
// //                               sx={{
// //                                 "&.Mui-disabled": {
// //                                   backgroundColor: alpha(
// //                                     theme.palette.error.main,
// //                                     0.1
// //                                   ),
// //                                   borderColor: theme.palette.error.main,
// //                                   color: theme.palette.error.main,
// //                                 },
// //                               }}
// //                             >
// //                               Status: Offer Rejected
// //                             </Button>
// //                           );
// //                         case "Offer Extended":
// //                           return (
// //                             <Button
// //                               {...commonProps}
// //                               variant="outlined"
// //                               startIcon={<PriorityHigh />}
// //                               sx={{
// //                                 "&.Mui-disabled": {
// //                                   backgroundColor: alpha(
// //                                     theme.palette.warning.main,
// //                                     0.2
// //                                   ),
// //                                   borderColor: theme.palette.warning.main,
// //                                   color:
// //                                     theme.palette.mode === "light"
// //                                       ? "#997400"
// //                                       : theme.palette.warning.main,
// //                                 },
// //                               }}
// //                             >
// //                               Status: Offer Extended
// //                             </Button>
// //                           );
// //                         default:
// //                           return (
// //                             <Button
// //                               {...commonProps}
// //                               startIcon={<CheckCircle />}
// //                               sx={{
// //                                 "&.Mui-disabled": {
// //                                   backgroundColor: alpha(
// //                                     theme.palette.success.main,
// //                                     0.2
// //                                   ),
// //                                   color: "success.dark",
// //                                 },
// //                               }}
// //                             >
// //                               Status: {status || "Applied"}
// //                             </Button>
// //                           );
// //                       }
// //                     })()
// //                   ) : (
// //                     <Button
// //                       variant="contained"
// //                       disabled={isApplying === currentJobState.id}
// //                       onClick={() => handleApplyJob(currentJobState.id)}
// //                       sx={{
// //                         px: 4,
// //                         py: 1.5,
// //                         background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
// //                         "&:hover": {
// //                           background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
// //                           transform: "translateY(-1px)",
// //                           boxShadow: `0 6px 20px ${alpha(
// //                             theme.palette.primary.main,
// //                             0.3
// //                           )}`,
// //                         },
// //                       }}
// //                     >
// //                       {isApplying === currentJobState.id ? (
// //                         <CircularProgress size={24} color="inherit" />
// //                       ) : (
// //                         "Apply Now"
// //                       )}
// //                     </Button>
// //                   )}
// //                 </DialogActions>
// //               </>
// //             );
// //           })()
// //         )}
// //       </Dialog>
// //     </Layout>
// //   );
// // }

// // export default JobBrowser;
// "use client";

// import { useState, useEffect, useRef } from "react";
// import {
//   Grid,
//   Card,
//   Typography,
//   Button,
//   Box,
//   Chip,
//   TextField,
//   FormControl,
//   Select,
//   MenuItem,
//   Paper,
//   Avatar,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Tabs,
//   Tab,
//   Alert,
//   CircularProgress,
//   Stack,
//   Skeleton,
//   alpha,
//   InputAdornment,
//   Divider,
// } from "@mui/material";
// import {
//   Work,
//   LocationOn,
//   AttachMoney,
//   Bookmark,
//   BookmarkBorder,
//   Share,
//   Search,
//   Business,
//   CheckCircle,
//   CalendarToday,
//   TrendingUp,
//   Undo as UndoIcon,
//   Description,
//   PlaylistAddCheck,
//   Category,
//   Stars,
//   Replay as ReplayIcon,
//   HighlightOff,
//   PriorityHigh,
// } from "@mui/icons-material";
// import Layout from "../common/Layout";
// import { useNotification } from "../../context/NotificationContext";
// import apiClient from "../../context/apiClient";
// import { useTheme } from "@mui/material/styles";
// import { useInView } from "react-intersection-observer";

// const AnimatedMatchScore = ({ score }) => {
//   const theme = useTheme();
//   const [progress, setProgress] = useState(0);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setProgress(score);
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [score]);
//   const getScoreColor = () => {
//     if (score >= 70) return theme.palette.success.main;
//     if (score >= 40) return theme.palette.warning.main;
//     return theme.palette.error.main;
//   };
//   return (
//     <Box sx={{ position: "relative", display: "inline-flex" }}>
//       <CircularProgress
//         variant="determinate"
//         sx={{ color: (theme) => theme.palette.divider }}
//         size={56}
//         thickness={4}
//         value={100}
//       />
//       <CircularProgress
//         variant="determinate"
//         value={progress}
//         size={56}
//         thickness={4}
//         sx={{
//           color: getScoreColor(),
//           position: "absolute",
//           left: 0,
//           transition: "transform 1s ease-out",
//           transform: "rotate(-90deg) !important",
//         }}
//       />
//       <Box
//         sx={{
//           top: 0,
//           left: 0,
//           bottom: 0,
//           right: 0,
//           position: "absolute",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//         }}
//       >
//         <Typography
//           variant="subtitle1"
//           component="div"
//           color="text.primary"
//           fontWeight="bold"
//           sx={{ fontSize: "14px" }}
//         >{`${Math.round(score)}%`}</Typography>
//       </Box>
//     </Box>
//   );
// };

// const AnimatedJobCard = ({
//   job,
//   handleViewJob,
//   handleSaveJob,
//   handleApplyJob,
//   handleUndoApplication,
//   handleReapplyJob,
//   isSaving,
//   isApplying,
//   showUndoButton,
//   showReapplyButton,
//   hideSaveButton,
//   isSavedTab,
// }) => {
//   const theme = useTheme();
//   const { ref, inView } = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//     rootMargin: "0px 0px -50px 0px",
//   });

//   const renderStatusDisplay = (forDesktop) => {
//     const commonButtonProps = {
//       disabled: true,
//       size: "small",
//       sx: forDesktop
//         ? {
//             fontSize: "0.75rem",
//             borderRadius: 2,
//             px: 2,
//             py: 1,
//             textTransform: "none",
//           }
//         : {
//             textTransform: "none",
//           },
//     };

//     switch (job.applicationStatus) {
//       case "Hired":
//         return (
//           <Button
//             {...commonButtonProps}
//             variant="contained"
//             startIcon={<CheckCircle />}
//             color="success"
//             sx={{
//               ...commonButtonProps.sx,
//               "&.Mui-disabled": {
//                 backgroundColor: theme.palette.success.main,
//                 color: theme.palette.success.contrastText,
//                 opacity: 0.9,
//               },
//             }}
//           >
//             Hired
//           </Button>
//         );

//       case "Offer Rejected":
//         return (
//           <Button
//             {...commonButtonProps}
//             variant="outlined"
//             startIcon={<HighlightOff />}
//             color="error"
//             sx={{
//               ...commonButtonProps.sx,
//               "&.Mui-disabled": {
//                 backgroundColor: alpha(theme.palette.error.main, 0.1),
//                 borderColor: theme.palette.error.main,
//                 color: theme.palette.error.main,
//               },
//             }}
//           >
//             Offer Rejected
//           </Button>
//         );

//       case "Offer Extended":
//         return (
//           <Button
//             {...commonButtonProps}
//             variant="outlined"
//             startIcon={<PriorityHigh />}
//             sx={{
//               ...commonButtonProps.sx,
//               "&.Mui-disabled": {
//                 backgroundColor: alpha(theme.palette.warning.main, 0.2),
//                 borderColor: theme.palette.warning.main,
//                 color:
//                   theme.palette.mode === "light"
//                     ? "#997400"
//                     : theme.palette.warning.main,
//               },
//             }}
//           >
//             Offer Extended
//           </Button>
//         );

//       default: // Default applied button for "Applied", "Under Review", etc.
//         return (
//           <Button
//             {...commonButtonProps}
//             variant="contained"
//             startIcon={<CheckCircle />}
//             sx={{
//               ...commonButtonProps.sx,
//               "&.Mui-disabled": {
//                 backgroundColor: alpha(theme.palette.success.main, 0.2),
//                 color: "success.dark",
//               },
//             }}
//           >
//             {job.applicationStatus || "Applied"}
//           </Button>
//         );
//     }
//   };

//   // This is the new, clean mobile layout.
//   const MobileLayout = () => (
//     <Stack sx={{ p: 2, gap: 2 }}>
//       {/* SECTION 1: HEADER (Logo, Title, Company) */}
//       <Stack direction="row" spacing={2} alignItems="center">
//         <Avatar
//           src={job.logo}
//           sx={{ width: 48, height: 48 }}
//           alt={`${job.company} logo`}
//         />
//         <Box sx={{ minWidth: 0 }}>
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: "1rem",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {job.title}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {job.company}
//           </Typography>
//         </Box>
//       </Stack>

//       {/* SECTION 2: BODY (Key Details as Chips) */}
//       <Stack direction="row" flexWrap="wrap" gap={1}>
//         <Chip
//           icon={<LocationOn />}
//           label={job.location}
//           size="small"
//           variant="outlined"
//         />
//         <Chip
//           icon={<Work />}
//           label={job.experience}
//           size="small"
//           variant="outlined"
//         />
//         <Chip
//           icon={<AttachMoney />}
//           label={job.salary}
//           size="small"
//           variant="outlined"
//         />
//         {job.visaSponsorship && (
//           <Chip label="Visa Sponsored" size="small" color="primary" />
//         )}
//       </Stack>

//       <Typography variant="caption" color="text.secondary">
//         <CalendarToday
//           sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
//         />
//         Posted {job.posted}
//       </Typography>

//       {/* SEPARATOR */}
//       <Divider sx={{ my: 1 }} />

//       {/* SECTION 3: FOOTER (AI Score and Actions) */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
//           <AnimatedMatchScore score={job.matchScore} />
//           <Typography
//             variant="caption"
//             sx={{
//               fontWeight: "bold",
//               display: "block",
//               mt: 0.5,
//               color: "primary.main",
//             }}
//           >
//             AI Match
//           </Typography>
//         </Box>

//         {/* Re-using the same button logic */}
//         <Stack direction="row" spacing={1} alignItems="center">
//           {job.applied ? (
//             job.applicationStatus === "Withdrawn" && showReapplyButton ? (
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleReapplyJob(job.applicationId, job.id);
//                 }}
//                 disabled={isApplying === job.id}
//                 sx={{ textTransform: "none" }}
//               >
//                 Re-apply
//               </Button>
//             ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
//               <Button
//                 variant="outlined"
//                 color="error"
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleUndoApplication(job.applicationId, job.id);
//                 }}
//                 disabled={isApplying === job.id}
//                 sx={{ textTransform: "none" }}
//               >
//                 Withdraw
//               </Button>
//             ) : (
//               renderStatusDisplay(false)
//             )
//           ) : (
//             <Button
//               variant="contained"
//               size="small"
//               color="primary"
//               disabled={isApplying === job.id}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleApplyJob(job.id);
//               }}
//               sx={{
//                 textTransform: "none",
//               }}
//             >
//               {isApplying === job.id ? (
//                 <CircularProgress size={16} color="inherit" />
//               ) : (
//                 "Apply"
//               )}
//             </Button>
//           )}
//           {!hideSaveButton && (
//             <IconButton
//               size="small"
//               disabled={isSaving === job.id}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleSaveJob(job.id);
//               }}
//               sx={{
//                 border: (theme) => `1px solid ${theme.palette.divider}`,
//                 color: job.saved ? "primary.main" : "text.secondary",
//               }}
//             >
//               {isSaving === job.id ? (
//                 <CircularProgress size={20} />
//               ) : job.saved ? (
//                 <Bookmark fontSize="small" />
//               ) : (
//                 <BookmarkBorder fontSize="small" />
//               )}
//             </IconButton>
//           )}
//         </Stack>
//       </Box>
//     </Stack>
//   );

//   // This is your original, excellent desktop layout.
//   const DesktopLayout = () => (
//     <>
//       <Box sx={{ display: "flex", flex: 1, gap: 2 }}>
//         <Avatar
//           src={job.logo}
//           sx={{ width: 48, height: 48, mt: 0.5 }}
//           alt={`${job.company} logo`}
//         />
//         <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               fontSize: "16px",
//               color: "text.primary",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {job.title}
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{ fontSize: "14px", color: "text.secondary", fontWeight: 500 }}
//           >
//             {job.company}
//           </Typography>
//           <Stack direction="row" spacing={2} alignItems="center">
//             <Typography
//               variant="body2"
//               sx={{ fontSize: "13px", color: "text.secondary" }}
//             >
//               <LocationOn
//                 sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
//               />
//               {job.location}
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ fontSize: "13px", color: "text.secondary" }}
//             >
//               <Work sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }} />
//               {job.experience}
//             </Typography>
//           </Stack>
//           <Typography
//             variant="body2"
//             sx={{ fontSize: "13px", color: "text.secondary" }}
//           >
//             <AttachMoney
//               sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
//             />
//             {job.salary}
//           </Typography>
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
//             {job.visaSponsorship && (
//               <Chip
//                 label="Visa Sponsored"
//                 size="small"
//                 color="primary"
//                 sx={{
//                   fontSize: "11px",
//                   height: "auto",
//                   p: "4px 8px",
//                 }}
//               />
//             )}
//             {job.requirements.slice(0, 5).map((skill, index) => (
//               <Chip
//                 key={index}
//                 label={skill}
//                 size="small"
//                 sx={{
//                   bgcolor: "action.selected",
//                   color: "primary.main",
//                   borderRadius: "6px",
//                   fontSize: "12px",
//                   height: "auto",
//                   p: "4px 8px",
//                 }}
//               />
//             ))}
//           </Box>
//           <Typography
//             variant="caption"
//             sx={{ color: "text.secondary", fontSize: "12px", mt: 1 }}
//           >
//             <CalendarToday
//               sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
//             />
//             Posted {job.posted}
//           </Typography>
//         </Stack>
//       </Box>
//       <Stack
//         spacing={2}
//         alignItems="center"
//         justifyContent="center"
//         sx={{ width: "120px", flexShrink: 0, pl: 2 }}
//       >
//         <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
//           <AnimatedMatchScore score={job.matchScore} />
//           <Chip
//             label="AI Match"
//             size="small"
//             color="primary"
//             icon={<TrendingUp />}
//             onClick={(e) => e.stopPropagation()}
//             sx={{
//               fontSize: "11px",
//               mt: 1,
//               height: "auto",
//               p: "4px 8px",
//               "& .MuiChip-icon": {
//                 color: "primary.contrastText",
//                 fontSize: "14px",
//               },
//             }}
//           />
//         </Box>
//         <Stack direction="row" spacing={1} alignItems="center">
//           {job.applied ? (
//             job.applicationStatus === "Withdrawn" && showReapplyButton ? (
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 startIcon={
//                   isApplying === job.id ? (
//                     <CircularProgress size={16} color="inherit" />
//                   ) : (
//                     <ReplayIcon />
//                   )
//                 }
//                 size="small"
//                 disabled={isApplying === job.id}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleReapplyJob(job.applicationId, job.id);
//                 }}
//                 sx={{
//                   fontSize: "0.75rem",
//                   borderRadius: 2,
//                   px: 2,
//                   py: 1,
//                   textTransform: "none",
//                 }}
//               >
//                 Re-apply
//               </Button>
//             ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
//               <Button
//                 variant="outlined"
//                 color="error"
//                 startIcon={
//                   isApplying === job.id ? (
//                     <CircularProgress size={16} color="inherit" />
//                   ) : (
//                     <UndoIcon />
//                   )
//                 }
//                 size="small"
//                 disabled={isApplying === job.id}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleUndoApplication(job.applicationId, job.id);
//                 }}
//                 sx={{
//                   fontSize: "0.75rem",
//                   borderRadius: 2,
//                   px: 2,
//                   py: 1,
//                   borderColor: alpha(theme.palette.error.main, 0.5),
//                   "&:hover": {
//                     backgroundColor: alpha(theme.palette.error.main, 0.08),
//                     borderColor: "error.main",
//                   },
//                 }}
//               >
//                 Withdraw
//               </Button>
//             ) : (
//               renderStatusDisplay(true)
//             )
//           ) : (
//             <Button
//               variant="contained"
//               color="primary"
//               size="small"
//               disabled={isApplying === job.id}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleApplyJob(job.id);
//               }}
//               sx={{
//                 width: "72px",
//                 height: "32px",
//                 fontSize: "13px",
//                 fontWeight: "600",
//                 borderRadius: "6px",
//                 textTransform: "none",
//                 boxShadow: "none",
//                 "&:hover": {
//                   boxShadow: "none",
//                 },
//               }}
//             >
//               {isApplying === job.id ? (
//                 <CircularProgress size={16} color="inherit" />
//               ) : (
//                 "Apply"
//               )}
//             </Button>
//           )}
//           {!hideSaveButton && (
//             <IconButton
//               size="small"
//               disabled={isSaving === job.id}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleSaveJob(job.id);
//               }}
//               sx={{
//                 border: (theme) => `1px solid ${theme.palette.divider}`,
//                 color: job.saved ? "primary.main" : "text.secondary",
//                 mr: isSavedTab ? 1 : 0,
//               }}
//             >
//               {isSaving === job.id ? (
//                 <CircularProgress size={20} />
//               ) : job.saved ? (
//                 <Bookmark fontSize="small" />
//               ) : (
//                 <BookmarkBorder fontSize="small" />
//               )}
//             </IconButton>
//           )}
//         </Stack>
//       </Stack>
//     </>
//   );

//   return (
//     <Card
//       ref={ref}
//       variant="outlined"
//       sx={{
//         borderRadius: "12px",
//         backgroundColor: "mint.main",
//         boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//         transition: "all 0.3s ease-in-out",
//         opacity: inView ? 1 : 0,
//         transform: inView ? "translateY(0)" : "translateY(20px)",
//         "&:hover": {
//           boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
//           transform: "translateY(-4px)",
//         },
//         cursor: "pointer",
//       }}
//       onClick={() => handleViewJob(job)}
//     >
//       {/* Conditionally render layouts based on screen size */}
//       <Box sx={{ display: { xs: "block", sm: "none" } }}>
//         <MobileLayout />
//       </Box>
//       <Box sx={{ display: { xs: "none", sm: "flex" }, p: 2, width: "100%" }}>
//         <DesktopLayout />
//       </Box>
//     </Card>
//   );
// };

// const JobCardSkeleton = () => {
//   return (
//     <Card variant="outlined" sx={{ backgroundColor: "background.paper", p: 3 }}>
//       <Box sx={{ display: "flex", height: "100%", gap: 3 }}>
//         <Box sx={{ flex: 1 }}>
//           <Stack spacing={2}>
//             <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
//               <Skeleton variant="circular" width={56} height={56} />
//               <Box sx={{ flex: 1 }}>
//                 <Skeleton
//                   variant="text"
//                   width="80%"
//                   height={28}
//                   sx={{ mb: 0.5 }}
//                 />
//                 <Skeleton variant="text" width="60%" height={24} />
//               </Box>
//             </Box>
//             <Skeleton variant="text" width="40%" height={20} sx={{ ml: 9 }} />
//             <Box sx={{ display: "flex", gap: 2, ml: 9 }}>
//               <Skeleton variant="text" width={80} height={20} />
//               <Skeleton variant="text" width={120} height={20} />
//             </Box>
//             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", ml: 9 }}>
//               {[...Array(4)].map((_, index) => (
//                 <Skeleton
//                   key={index}
//                   variant="rectangular"
//                   width={Math.random() * 40 + 50}
//                   height={24}
//                   sx={{ borderRadius: 1 }}
//                 />
//               ))}
//             </Box>
//             <Skeleton variant="text" width="30%" height={20} sx={{ ml: 9 }} />
//           </Stack>
//         </Box>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "120px",
//             flexShrink: 0,
//             py: 1,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }}
//           >
//             <Skeleton variant="circular" width={80} height={80} />
//             <Skeleton
//               variant="rectangular"
//               width={70}
//               height={24}
//               sx={{ mt: 1, borderRadius: 2 }}
//             />
//           </Box>
//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Skeleton
//               variant="rectangular"
//               width={60}
//               height={36}
//               sx={{ borderRadius: 2 }}
//             />
//             <Skeleton variant="circular" width={36} height={36} />
//           </Box>
//         </Box>
//       </Box>
//     </Card>
//   );
// };

// const FilterSkeleton = () => {
//   return (
//     <Paper
//       variant="outlined"
//       sx={{ p: 2, backgroundColor: "background.paper" }}
//     >
//       <Stack spacing={3}>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <Skeleton variant="text" width={80} height={28} />
//           <Skeleton variant="text" width={60} height={24} />
//         </Box>
//         <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 2 }} />
//         {[...Array(3)].map((_, index) => (
//           <Skeleton
//             key={index}
//             variant="rectangular"
//             height={40}
//             sx={{ borderRadius: 2 }}
//           />
//         ))}
//         <Box>
//           <Stack spacing={1}>
//             {[...Array(2)].map((_, index) => (
//               <Box
//                 key={index}
//                 sx={{ display: "flex", alignItems: "center", gap: 1 }}
//               >
//                 <Skeleton variant="rectangular" width={20} height={20} />
//                 <Skeleton variant="text" width={120} height={20} />
//               </Box>
//             ))}
//           </Stack>
//         </Box>
//       </Stack>
//     </Paper>
//   );
// };

// const TabsSkeleton = () => {
//   return (
//     <Paper
//       square
//       elevation={2}
//       sx={{ flexShrink: 0, bgcolor: "background.paper" }}
//     >
//       <Box sx={{ display: "flex", height: 48 }}>
//         {[...Array(3)].map((_, index) => (
//           <Box
//             key={index}
//             sx={{
//               flex: 1,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               p: 2,
//             }}
//           >
//             <Skeleton variant="text" width={80} height={24} />
//           </Box>
//         ))}
//       </Box>
//     </Paper>
//   );
// };

// const JobDialogSkeleton = () => {
//   return (
//     <>
//       <DialogTitle>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//           <Skeleton
//             variant="circular"
//             width={{ xs: 40, sm: 60 }}
//             height={{ xs: 40, sm: 60 }}
//           />
//           <Box sx={{ flexGrow: 1 }}>
//             <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
//             <Skeleton variant="text" width="40%" height={28} />
//           </Box>
//           <Skeleton variant="circular" width={40} height={40} />
//           <Skeleton variant="circular" width={40} height={40} />
//         </Box>
//       </DialogTitle>
//       <DialogContent dividers>
//         <Stack spacing={3}>
//           <Skeleton variant="rectangular" width="100%" height={120} />
//           <Skeleton variant="rectangular" width="100%" height={200} />
//           <Skeleton variant="rectangular" width="100%" height={150} />
//         </Stack>
//       </DialogContent>
//       <DialogActions
//         sx={{ p: { xs: 2, sm: 3 }, justifyContent: "flex-end", gap: 1 }}
//       >
//         <Skeleton
//           variant="rectangular"
//           width={80}
//           height={36}
//           sx={{ borderRadius: 1 }}
//         />
//         <Skeleton
//           variant="rectangular"
//           width={120}
//           height={36}
//           sx={{ borderRadius: 1 }}
//         />
//       </DialogActions>
//     </>
//   );
// };

// const TabLabel = ({ count, label, color }) => (
//   <Stack direction="row" spacing={1} alignItems="center">
//     <Box
//       component="span"
//       sx={{
//         bgcolor: `${color}.main`,
//         color: `${color}.contrastText`,
//         borderRadius: "10px",
//         px: 0.8,
//         py: 0.1,
//         minWidth: 20,
//         fontSize: "0.75rem",
//         fontWeight: "bold",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {count}
//     </Box>
//     <Typography
//       component="span"
//       sx={{ textTransform: "none", fontWeight: 500 }}
//     >
//       {label}
//     </Typography>
//   </Stack>
// );

// const SectionCard = ({ children, ...props }) => (
//   <Paper
//     variant="outlined"
//     sx={{
//       p: { xs: 2, md: 3 },
//       borderRadius: 3,
//       BoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//       borderColor: (theme) => alpha(theme.palette.divider, 0.5),
//       bgcolor: "background.paper",
//     }}
//     {...props}
//   >
//     {children}
//   </Paper>
// );

// const SectionHeader = ({ icon, title }) => (
//   <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
//     <Avatar
//       sx={{
//         bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
//         color: "primary.main",
//         width: 32,
//         height: 32,
//       }}
//     >
//       {icon}
//     </Avatar>
//     <Typography variant="h6" fontWeight="bold" color="text.primary">
//       {title}
//     </Typography>
//   </Box>
// );

// const KeyDetail = ({ icon, label, value }) => (
//   <Grid item xs={12} sm={6} md={4}>
//     <Stack direction="row" spacing={1.5} alignItems="center">
//       <Box color="text.secondary">{icon}</Box>
//       <Box>
//         <Typography
//           variant="caption"
//           color="text.secondary"
//           sx={{ display: "block", lineHeight: 1.2 }}
//         >
//           {label}
//         </Typography>
//         <Typography variant="body2" fontWeight="bold" color="text.primary">
//           {value}
//         </Typography>
//       </Box>
//     </Stack>
//   </Grid>
// );

// function JobBrowser() {
//   const { showNotification } = useNotification();
//   const theme = useTheme();
//   const [jobs, setJobs] = useState([]);
//   const [filteredJobs, setFilteredJobs] = useState([]);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [openJobDialog, setOpenJobDialog] = useState(false);
//   const [tabValue, setTabValue] = useState(0);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isSaving, setIsSaving] = useState(null);
//   const [isApplying, setIsApplying] = useState(null);
//   const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
//   const [jobDialogLoading, setJobDialogLoading] = useState(false);
//   const [filters, setFilters] = useState({
//     location: "",
//     experience: "",
//     education: "",
//   });
//   const hasFetchedRef = useRef(false);
//   const getErrorMessage = (err, fallback) => {
//     if (err && err.response && err.response.data) {
//       const d = err.response.data;
//       if (typeof d === "string") return d;
//       return d.detail || d.message || fallback;
//     }
//     if (
//       typeof err?.message === "string" &&
//       err.message.toLowerCase().includes("network")
//     ) {
//       return "Network error. Please check your connection.";
//     }
//     return fallback;
//   };
//   const transformJobData = (apiJob) => ({
//     id: apiJob.id,
//     title: apiJob.title,
//     company: apiJob.company_details?.company_name || "Unknown Company",
//     location: apiJob.location,
//     salary:
//       apiJob.salary_min && apiJob.salary_max
//         ? `${apiJob.salary_currency} ${Number.parseFloat(
//             apiJob.salary_min
//           ).toLocaleString()} - ${Number.parseFloat(
//             apiJob.salary_max
//           ).toLocaleString()}`
//         : "Not Disclosed",
//     type: apiJob.job_type_display || apiJob.job_type,
//     experience: apiJob.experience_level_display || apiJob.experience_level,
//     posted: new Date(apiJob.created_at).toLocaleDateString(),
//     logo: apiJob.company_details?.logo || "/placeholder.svg?height=60&width=60",
//     description: apiJob.description,
//     requirements: apiJob.required_skills || [],
//     benefits: apiJob.benefits || [],
//     matchScore: 0,
//     saved: false,
//     applied: false,
//     applicationId: null,
//     applicationStatus: null,
//     urgent: apiJob.status === "URGENT",
//     remote: apiJob.remote_work,
//     visaSponsorship: apiJob.visa_sponsorship,
//     responsibilities: apiJob.responsibilities,
//     applicationDeadline: apiJob.application_deadline,
//   });
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     const loadData = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const [
//           jobsResponse,
//           aiScoresResponse,
//           savedJobsResponse,
//           applicationsResponse,
//         ] = await Promise.all([
//           apiClient.get("/job-postings/"),
//           apiClient.get("/job-postings/ai-score/"),
//           apiClient.get("/saved-jobs/"),
//           apiClient.get("/applications/"),
//         ]);
//         const jobsData = jobsResponse.data
//           .filter((j) => j.status === "PUBLISHED")
//           .map(transformJobData);
//         const aiScoresData = aiScoresResponse.data;
//         const savedJobIds = new Set(
//           savedJobsResponse.data.map((sj) => sj.job_posting.id)
//         );
//         const applicationsData = applicationsResponse.data;
//         const applicationsMap = new Map(
//           applicationsData.map((app) => {
//             const appStatus = app.status_display || app.status;
//             return [
//               app.job_posting,
//               {
//                 id: app.id,
//                 status: appStatus === "Deleted" ? "Withdrawn" : appStatus,
//               },
//             ];
//           })
//         );
//         const finalJobs = jobsData.map((job) => {
//           const aiScore = aiScoresData.find((score) => score.id === job.id);
//           const applicationDetails = applicationsMap.get(job.id);
//           return {
//             ...job,
//             matchScore: aiScore ? Math.round(aiScore.matching_percentage) : 0,
//             saved: savedJobIds.has(job.id),
//             applied: !!applicationDetails,
//             applicationId: applicationDetails?.id || null,
//             applicationStatus: applicationDetails?.status || null,
//           };
//         });
//         finalJobs.sort((a, b) => b.matchScore - a.matchScore);
//         setJobs(finalJobs);
//         setFilteredJobs(finalJobs);
//       } catch (err) {
//         const errorMessage = getErrorMessage(
//           err,
//           "Failed to load data. Please try again."
//         );
//         setError(errorMessage);
//         showNotification(errorMessage, "error");
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadData();
//   }, [showNotification]);
//   const filterJobs = (search, currentFilters, currentTab, baseJobs = jobs) => {
//     let sourceJobs = [...baseJobs];
//     if (currentTab === 1) {
//       sourceJobs = baseJobs.filter((job) => job.saved);
//     } else if (currentTab === 2) {
//       sourceJobs = baseJobs.filter(
//         (job) => job.applied && job.applicationStatus !== "Withdrawn"
//       );
//     } else if (currentTab === 3) {
//       sourceJobs = baseJobs.filter(
//         (job) => job.applied && job.applicationStatus === "Withdrawn"
//       );
//     }
//     const filtered = sourceJobs.filter((job) => {
//       const searchTermLower = search.toLowerCase();
//       const matchesSearch =
//         search === "" ||
//         job.title.toLowerCase().includes(searchTermLower) ||
//         job.company.toLowerCase().includes(searchTermLower);
//       const matchesLocation =
//         !currentFilters.location ||
//         job.location
//           .toLowerCase()
//           .includes(currentFilters.location.toLowerCase());
//       const matchesExperience =
//         !currentFilters.experience ||
//         job.experience === currentFilters.experience;
//       const matchesEducation =
//         !currentFilters.education || job.education === currentFilters.education;
//       return (
//         matchesSearch &&
//         matchesLocation &&
//         matchesExperience &&
//         matchesEducation
//       );
//     });
//     setFilteredJobs(filtered);
//   };
//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//     filterJobs(searchTerm, filters, newValue);
//   };
//   const handleSearch = (event) => {
//     const term = event.target.value;
//     setSearchTerm(term);
//     filterJobs(term, filters, tabValue);
//   };
//   const handleFilterChange = (event) => {
//     const { name, value } = event.target;
//     const newFilters = { ...filters, [name]: value };
//     setFilters(newFilters);
//     filterJobs(searchTerm, newFilters, tabValue);
//   };
//   const clearAllFilters = () => {
//     const newFilters = {
//       location: "",
//       experience: "",
//       education: "",
//     };
//     setFilters(newFilters);
//     setSearchTerm("");
//     filterJobs("", newFilters, tabValue);
//   };
//   const handleSaveJob = async (jobId) => {
//     setIsSaving(jobId);
//     const jobToUpdate = jobs.find((j) => j.id === jobId);
//     const isCurrentlySaved = jobToUpdate.saved;
//     try {
//       if (isCurrentlySaved) {
//         await apiClient.delete(`/saved-jobs/unsave/`, {
//           data: { job_posting_id: jobId },
//         });
//       } else {
//         await apiClient.post(`/saved-jobs/save/`, { job_posting_id: jobId });
//       }
//       const updatedJobs = jobs.map((j) =>
//         j.id === jobId ? { ...j, saved: !isCurrentlySaved } : j
//       );
//       setJobs(updatedJobs);
//       showNotification(
//         isCurrentlySaved
//           ? "Job removed from saved list"
//           : "Job saved successfully!",
//         "success"
//       );
//       filterJobs(searchTerm, filters, tabValue, updatedJobs);
//     } catch (error) {
//       showNotification(
//         getErrorMessage(error, "Failed to update job status."),
//         "error"
//       );
//     } finally {
//       setIsSaving(null);
//     }
//   };
//   const handleApplyJob = async (jobId) => {
//     setIsApplying(jobId);
//     try {
//       const response = await apiClient.post("/applications/", {
//         job_posting: jobId,
//       });
//       const newApplication = response.data;
//       const updatedJobs = jobs.map((job) =>
//         job.id === jobId
//           ? {
//               ...job,
//               applied: true,
//               applicationId: newApplication.id,
//               applicationStatus:
//                 newApplication.status_display || newApplication.status,
//             }
//           : job
//       );
//       setJobs(updatedJobs);
//       showNotification("Application submitted successfully!", "success");
//       filterJobs(searchTerm, filters, tabValue, updatedJobs);
//       if (openJobDialog) {
//         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
//       }
//     } catch (error) {
//       showNotification(
//         getErrorMessage(error, "Failed to submit application."),
//         "error"
//       );
//     } finally {
//       setIsApplying(null);
//     }
//   };
//   const handleReapplyJob = async (applicationId, jobId) => {
//     setIsApplying(jobId);
//     try {
//       const response = await apiClient.patch(
//         `/applications/${applicationId}/`,
//         {
//           status: "SUBMITTED",
//         }
//       );
//       const updatedApplication = response.data;
//       const updatedJobs = jobs.map((job) =>
//         job.id === jobId
//           ? {
//               ...job,
//               applicationStatus:
//                 updatedApplication.status_display || updatedApplication.status,
//             }
//           : job
//       );
//       setJobs(updatedJobs);
//       showNotification("Re-applied to job successfully!", "success");
//       setTabValue(0);
//       filterJobs(searchTerm, filters, 0, updatedJobs);
//       if (openJobDialog) {
//         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
//       }
//     } catch (error) {
//       showNotification(getErrorMessage(error, "Failed to re-apply."), "error");
//     } finally {
//       setIsApplying(null);
//     }
//   };

//   // =================================================================
//   // ===== FIXED CODE IS HERE =====
//   // =================================================================
//   const handleUndoApplication = async (applicationId, jobId) => {
//     setIsApplying(jobId);
//     try {
//       await apiClient.delete(`/applications/${applicationId}/delete/`);
//       const updatedJobs = jobs.map((job) =>
//         job.id === jobId
//           ? {
//               ...job,
//               applied: true, // It's still an application, just withdrawn
//               applicationStatus: "Withdrawn",
//             }
//           : job
//       );
//       setJobs(updatedJobs);
//       showNotification("Application successfully withdrawn!", "success");

//       // **THE FIX:**
//       // 1. DO NOT change the tab value.
//       // 2. Re-filter the list for the CURRENT tab (`tabValue`) with the updated `jobs` data.
//       // The withdrawn job will now be correctly removed from the "Applied" view.
//       filterJobs(searchTerm, filters, tabValue, updatedJobs);

//       if (openJobDialog) {
//         setSelectedJob(updatedJobs.find((j) => j.id === jobId));
//       }
//     } catch (error) {
//       showNotification(
//         getErrorMessage(error, "Failed to withdraw application."),
//         "error"
//       );
//     } finally {
//       setIsApplying(null);
//     }
//   };
//   // =================================================================
//   // =================================================================

//   const handleViewJob = (job) => {
//     setSelectedJob(job);
//     setOpenJobDialog(true);
//     setJobDialogLoading(true);
//     setTimeout(() => {
//       setJobDialogLoading(false);
//     }, 800);
//   };
//   if (loading) {
//     return (
//       <Layout title="Global Job Opportunities">
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
//             p: { xs: 1, sm: 2, md: 3 },
//             bgcolor: "background.default",
//           }}
//         >
//           <Box sx={{ flexShrink: 0, mb: 2 }}>
//             <TabsSkeleton />
//           </Box>
//           <Box sx={{ mb: 3 }}>
//             <FilterSkeleton />
//           </Box>
//           <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
//             <Stack spacing={2.5}>
//               {[...Array(4)].map((_, index) => (
//                 <JobCardSkeleton key={index} />
//               ))}
//             </Stack>
//           </Box>
//         </Box>
//       </Layout>
//     );
//   }
//   if (error) {
//     return (
//       <Layout title="Global Job Opportunities">
//         <Box sx={{ p: 3 }}>
//           <Alert severity="error">{error}</Alert>
//         </Box>
//       </Layout>
//     );
//   }
//   const allJobsCount = jobs.length;
//   const savedJobsCount = jobs.filter((j) => j.saved).length;
//   const appliedJobsCount = jobs.filter(
//     (j) => j.applied && j.applicationStatus !== "Withdrawn"
//   ).length;
//   const withdrawnJobsCount = jobs.filter(
//     (j) => j.applied && j.applicationStatus === "Withdrawn"
//   ).length;
//   const renderFilterBar = () => (
//     <Paper
//       elevation={0}
//       variant="outlined"
//       sx={{
//         p: "12px",
//         borderRadius: "12px",
//         bgcolor: "mint.main",
//         BoxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//         mb: 3,
//       }}
//     >
//       <Grid container spacing={2} alignItems="center">
//         <Grid item xs={12} md={4} lg={5}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search Jobs, Companies"
//             value={searchTerm}
//             onChange={handleSearch}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Search />
//                 </InputAdornment>
//               ),
//               sx: { borderRadius: "8px", fontSize: "14px" },
//             }}
//           />
//         </Grid>
//         <Grid item xs={12} sm={4} md={2} lg={2}>
//           <FormControl fullWidth>
//             <Select
//               displayEmpty
//               value={filters.location}
//               name="location"
//               onChange={handleFilterChange}
//               sx={{
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 color: filters.location ? "inherit" : "text.secondary",
//               }}
//             >
//               <MenuItem value="">Location</MenuItem>
//               {[...new Set(jobs.map((job) => job.location))]
//                 .sort()
//                 .map((loc) => (
//                   <MenuItem key={loc} value={loc}>
//                     {loc}
//                   </MenuItem>
//                 ))}
//             </Select>
//           </FormControl>
//         </Grid>
//         <Grid item xs={12} sm={4} md={2} lg={2}>
//           <FormControl fullWidth>
//             <Select
//               displayEmpty
//               value={filters.education}
//               name="education"
//               onChange={handleFilterChange}
//               sx={{
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 color: filters.education ? "inherit" : "text.secondary",
//               }}
//             >
//               <MenuItem value="">Education</MenuItem>
//               <MenuItem value="bachelor">Bachelor's</MenuItem>
//               <MenuItem value="master">Master's</MenuItem>
//               <MenuItem value="phd">PhD</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//         <Grid item xs={12} sm={4} md={2} lg={2}>
//           <FormControl fullWidth>
//             <Select
//               displayEmpty
//               value={filters.experience}
//               name="experience"
//               onChange={handleFilterChange}
//               sx={{
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 color: filters.experience ? "inherit" : "text.secondary",
//               }}
//             >
//               <MenuItem value="">Experience</MenuItem>
//               {[...new Set(jobs.map((job) => job.experience))]
//                 .sort()
//                 .map((exp) => (
//                   <MenuItem key={exp} value={exp}>
//                     {exp}
//                   </MenuItem>
//                 ))}
//             </Select>
//           </FormControl>
//         </Grid>
//         <Grid item xs={12} md="auto">
//           <Button
//             onClick={clearAllFilters}
//             sx={{
//               textTransform: "none",
//               color: "primary.main",
//               fontWeight: "bold",
//             }}
//           >
//             Clear Filter
//           </Button>
//         </Grid>
//       </Grid>
//     </Paper>
//   );
//   return (
//     <Layout title="Global Job Opportunities">
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
//           p: { xs: 1, sm: 2, md: 3 },
//           bgcolor: "background.default",
//         }}
//       >
//         <Paper
//           square
//           elevation={0}
//           sx={{
//             flexShrink: 0,
//             mb: 2,
//             backgroundColor: "transparent",
//           }}
//         >
//           <Tabs
//             value={tabValue}
//             onChange={handleTabChange}
//             centered
//             sx={{ "& .MuiTab-root": { fontSize: "1rem" } }}
//           >
//             <Tab
//               label={
//                 <TabLabel
//                   count={allJobsCount}
//                   label="All Jobs"
//                   color="primary"
//                 />
//               }
//             />
//             <Tab
//               label={
//                 <TabLabel
//                   count={savedJobsCount}
//                   label="Saved"
//                   color="secondary"
//                 />
//               }
//             />
//             <Tab
//               label={
//                 <TabLabel
//                   count={appliedJobsCount}
//                   label="Applied"
//                   color="success"
//                 />
//               }
//             />
//           </Tabs>
//         </Paper>
//         {renderFilterBar()}
//         <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
//           <Stack spacing={2.5}>
//             {filteredJobs.length > 0 ? (
//               filteredJobs.map((job) => (
//                 <AnimatedJobCard
//                   key={job.id}
//                   job={job}
//                   handleViewJob={handleViewJob}
//                   handleSaveJob={handleSaveJob}
//                   handleApplyJob={handleApplyJob}
//                   handleUndoApplication={handleUndoApplication}
//                   handleReapplyJob={handleReapplyJob}
//                   isSaving={isSaving}
//                   isApplying={isApplying}
//                   showUndoButton={tabValue === 2}
//                   showReapplyButton={tabValue === 3}
//                   hideSaveButton={tabValue === 2}
//                   isSavedTab={tabValue === 1}
//                 />
//               ))
//             ) : (
//               <Paper
//                 sx={{
//                   p: 6,
//                   textAlign: "center",
//                   backgroundColor: "background.paper",
//                 }}
//               >
//                 <Work sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
//                 <Typography
//                   variant="h5"
//                   color="text.primary"
//                   gutterBottom
//                   fontWeight={600}
//                 >
//                   No jobs found
//                 </Typography>
//                 <Typography variant="body1" color="text.secondary">
//                   Try adjusting your filters or search terms
//                 </Typography>
//               </Paper>
//             )}
//           </Stack>
//         </Box>
//       </Box>
//       <Dialog
//         open={openJobDialog}
//         onClose={() => setOpenJobDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { maxHeight: "90vh", borderRadius: 4 } }}
//       >
//         {jobDialogLoading ? (
//           <JobDialogSkeleton />
//         ) : (
//           selectedJob &&
//           (() => {
//             const currentJobState =
//               jobs.find((j) => j.id === selectedJob.id) || selectedJob;
//             return (
//               <>
//                 <DialogTitle
//                   sx={{
//                     bgcolor: "background.paper",
//                     borderBottom: `1px solid ${theme.palette.divider}`,
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                     <Avatar
//                       src={currentJobState.logo}
//                       sx={{
//                         width: 60,
//                         height: 60,
//                         border: `2px solid ${theme.palette.divider}`,
//                         boxShadow: 1,
//                       }}
//                     />
//                     <Box sx={{ flexGrow: 1 }}>
//                       <Typography
//                         variant="h5"
//                         fontWeight="bold"
//                         color="text.primary"
//                       >
//                         {currentJobState.title}
//                       </Typography>
//                       <Typography variant="body1" color="text.secondary">
//                         {currentJobState.company}
//                       </Typography>
//                     </Box>
//                     <Box sx={{ display: { xs: "none", sm: "flex" } }}>
//                       <IconButton
//                         disabled={isSaving === currentJobState.id}
//                         onClick={() => handleSaveJob(currentJobState.id)}
//                       >
//                         {isSaving === currentJobState.id ? (
//                           <CircularProgress size={24} />
//                         ) : currentJobState.saved ? (
//                           <Bookmark color="primary" />
//                         ) : (
//                           <BookmarkBorder />
//                         )}
//                       </IconButton>
//                       <IconButton>
//                         <Share />
//                       </IconButton>
//                     </Box>
//                   </Box>
//                 </DialogTitle>
//                 <DialogContent
//                   sx={{ bgcolor: "background.default", p: { xs: 2, md: 3 } }}
//                 >
//                   <Stack spacing={3}>
//                     <SectionCard>
//                       <Grid container spacing={2} rowSpacing={3}>
//                         <Grid item xs={12} sm={6} md={8}>
//                           <Stack spacing={2}>
//                             <KeyDetail
//                               icon={<AttachMoney />}
//                               label="Salary"
//                               value={currentJobState.salary}
//                             />
//                             <KeyDetail
//                               icon={<LocationOn />}
//                               label="Location"
//                               value={currentJobState.location}
//                             />
//                             <KeyDetail
//                               icon={<Business />}
//                               label="Experience"
//                               value={currentJobState.experience}
//                             />
//                             <KeyDetail
//                               icon={<Work />}
//                               label="Job Type"
//                               value={currentJobState.type}
//                             />
//                           </Stack>
//                         </Grid>
//                         <Grid
//                           item
//                           xs={12}
//                           sm={6}
//                           md={4}
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <Box sx={{ textAlign: "center" }}>
//                             <AnimatedMatchScore
//                               score={currentJobState.matchScore}
//                             />
//                             <Typography
//                               variant="caption"
//                               fontWeight="bold"
//                               color="primary.main"
//                               sx={{ mt: 1, display: "block" }}
//                             >
//                               AI MATCH SCORE
//                             </Typography>
//                           </Box>
//                         </Grid>
//                       </Grid>
//                     </SectionCard>
//                     <SectionCard>
//                       <SectionHeader
//                         icon={<Description fontSize="small" />}
//                         title="Job Description"
//                       />
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           whiteSpace: "pre-wrap",
//                           lineHeight: 1.7,
//                           color: "text.secondary",
//                         }}
//                       >
//                         {currentJobState.description}
//                       </Typography>
//                     </SectionCard>
//                     {currentJobState.responsibilities && (
//                       <SectionCard>
//                         <SectionHeader
//                           icon={<PlaylistAddCheck fontSize="small" />}
//                           title="Responsibilities"
//                         />
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             whiteSpace: "pre-wrap",
//                             lineHeight: 1.7,
//                             color: "text.secondary",
//                           }}
//                         >
//                           {currentJobState.responsibilities}
//                         </Typography>
//                       </SectionCard>
//                     )}
//                     <SectionCard>
//                       <SectionHeader
//                         icon={<Category fontSize="small" />}
//                         title="Required Skills"
//                       />
//                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                         {currentJobState.requirements.map((skill, index) => (
//                           <Chip
//                             key={index}
//                             label={skill}
//                             variant="outlined"
//                             color="primary"
//                           />
//                         ))}
//                       </Box>
//                     </SectionCard>
//                     <SectionCard>
//                       <SectionHeader
//                         icon={<Stars fontSize="small" />}
//                         title="Benefits & Perks"
//                       />
//                       <List
//                         dense
//                         sx={{ p: 0, "&& .Mui-ListItem-root": { py: 0.5 } }}
//                       >
//                         {currentJobState.benefits.map((benefit, index) => (
//                           <ListItem key={index} disableGutters>
//                             <ListItemIcon sx={{ minWidth: 32 }}>
//                               <CheckCircle
//                                 color="success"
//                                 sx={{ fontSize: 20 }}
//                               />
//                             </ListItemIcon>
//                             <ListItemText
//                               primary={benefit}
//                               primaryTypographyProps={{
//                                 color: "text.secondary",
//                                 fontWeight: 500,
//                               }}
//                             />
//                           </ListItem>
//                         ))}
//                       </List>
//                     </SectionCard>
//                   </Stack>
//                 </DialogContent>
//                 <DialogActions
//                   sx={{
//                     p: { xs: 2, sm: 3 },
//                     justifyContent: "flex-end",
//                     gap: 2,
//                     bgcolor: "background.paper",
//                     borderTop: `1px solid ${theme.palette.divider}`,
//                   }}
//                 >
//                   <Button
//                     onClick={() => setOpenJobDialog(false)}
//                     variant="outlined"
//                     color="secondary"
//                   >
//                     Close
//                   </Button>
//                   {tabValue === 3 &&
//                   currentJobState.applied &&
//                   currentJobState.applicationStatus === "Withdrawn" ? (
//                     <Button
//                       variant="contained"
//                       color="secondary"
//                       startIcon={
//                         isApplying === currentJobState.id ? (
//                           <CircularProgress size={16} color="inherit" />
//                         ) : (
//                           <ReplayIcon />
//                         )
//                       }
//                       size="small"
//                       disabled={isApplying === currentJobState.id}
//                       onClick={() =>
//                         handleReapplyJob(
//                           currentJobState.applicationId,
//                           currentJobState.id
//                         )
//                       }
//                       sx={{
//                         px: 4,
//                         background: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
//                         "&:hover": {
//                           background: `linear-gradient(45deg, ${theme.palette.secondary.dark}, ${theme.palette.primary.dark})`,
//                           transform: "translateY(-1px)",
//                           boxShadow: `0 6px 20px ${alpha(
//                             theme.palette.secondary.main,
//                             0.3
//                           )}`,
//                         },
//                       }}
//                     >
//                       {isApplying === currentJobState.id ? (
//                         <CircularProgress size={24} color="inherit" />
//                       ) : (
//                         "Re-apply Now"
//                       )}
//                     </Button>
//                   ) : tabValue === 2 &&
//                     currentJobState.applied &&
//                     currentJobState.applicationStatus !== "Withdrawn" ? (
//                     <Button
//                       variant="outlined"
//                       color="error"
//                       startIcon={
//                         isApplying === currentJobState.id ? (
//                           <CircularProgress size={10} color="inherit" />
//                         ) : (
//                           <UndoIcon />
//                         )
//                       }
//                       size="small"
//                       disabled={isApplying === currentJobState.id}
//                       onClick={() =>
//                         handleUndoApplication(
//                           currentJobState.applicationId,
//                           currentJobState.id
//                         )
//                       }
//                       sx={{
//                         fontSize: "0.65rem",
//                         borderRadius: 1,
//                         borderColor: alpha(theme.palette.error.main, 0.2),
//                         "&:hover": {
//                           backgroundColor: alpha(
//                             theme.palette.error.main,
//                             0.08
//                           ),
//                           borderColor: "error.main",
//                         },
//                       }}
//                     >
//                       Withdraw
//                     </Button>
//                   ) : currentJobState.applied ? (
//                     (() => {
//                       const status = currentJobState.applicationStatus;
//                       const commonProps = {
//                         disabled: true,
//                         variant: "contained",
//                       };

//                       switch (status) {
//                         case "Hired":
//                           return (
//                             <Button
//                               {...commonProps}
//                               startIcon={<CheckCircle />}
//                               color="success"
//                               sx={{
//                                 "&.Mui-disabled": {
//                                   backgroundColor: theme.palette.success.main,
//                                   color: theme.palette.success.contrastText,
//                                   opacity: 0.9,
//                                 },
//                               }}
//                             >
//                               Status: Hired
//                             </Button>
//                           );
//                         case "Offer Rejected":
//                           return (
//                             <Button
//                               {...commonProps}
//                               variant="outlined"
//                               startIcon={<HighlightOff />}
//                               color="error"
//                               sx={{
//                                 "&.Mui-disabled": {
//                                   backgroundColor: alpha(
//                                     theme.palette.error.main,
//                                     0.1
//                                   ),
//                                   borderColor: theme.palette.error.main,
//                                   color: theme.palette.error.main,
//                                 },
//                               }}
//                             >
//                               Status: Offer Rejected
//                             </Button>
//                           );
//                         case "Offer Extended":
//                           return (
//                             <Button
//                               {...commonProps}
//                               variant="outlined"
//                               startIcon={<PriorityHigh />}
//                               sx={{
//                                 "&.Mui-disabled": {
//                                   backgroundColor: alpha(
//                                     theme.palette.warning.main,
//                                     0.2
//                                   ),
//                                   borderColor: theme.palette.warning.main,
//                                   color:
//                                     theme.palette.mode === "light"
//                                       ? "#997400"
//                                       : theme.palette.warning.main,
//                                 },
//                               }}
//                             >
//                               Status: Offer Extended
//                             </Button>
//                           );
//                         default:
//                           return (
//                             <Button
//                               {...commonProps}
//                               startIcon={<CheckCircle />}
//                               sx={{
//                                 "&.Mui-disabled": {
//                                   backgroundColor: alpha(
//                                     theme.palette.success.main,
//                                     0.2
//                                   ),
//                                   color: "success.dark",
//                                 },
//                               }}
//                             >
//                               Status: {status || "Applied"}
//                             </Button>
//                           );
//                       }
//                     })()
//                   ) : (
//                     <Button
//                       variant="contained"
//                       disabled={isApplying === currentJobState.id}
//                       onClick={() => handleApplyJob(currentJobState.id)}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                         "&:hover": {
//                           background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
//                           transform: "translateY(-1px)",
//                           boxShadow: `0 6px 20px ${alpha(
//                             theme.palette.primary.main,
//                             0.3
//                           )}`,
//                         },
//                       }}
//                     >
//                       {isApplying === currentJobState.id ? (
//                         <CircularProgress size={24} color="inherit" />
//                       ) : (
//                         "Apply Now"
//                       )}
//                     </Button>
//                   )}
//                 </DialogActions>
//               </>
//             );
//           })()
//         )}
//       </Dialog>
//     </Layout>
//   );
// }

// export default JobBrowser;

"use client";

import { useState, useEffect, useRef, useCallback } from "react"; // Added useCallback
import {
  Grid,
  Card,
  Typography,
  Button,
  Box,
  Chip,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Tabs,
  Tab,
  Alert,
  CircularProgress,
  Stack,
  Skeleton,
  alpha,
  InputAdornment,
  Divider,
  useMediaQuery, // Added useMediaQuery
} from "@mui/material";
import {
  Work,
  LocationOn,
  AttachMoney,
  Bookmark,
  BookmarkBorder,
  Share,
  Search,
  Business,
  CheckCircle,
  CalendarToday,
  TrendingUp,
  Undo as UndoIcon,
  Description,
  PlaylistAddCheck,
  Category,
  Stars,
  Replay as ReplayIcon,
  HighlightOff,
  PriorityHigh,
} from "@mui/icons-material";
import Layout from "../common/Layout";
import { useNotification } from "../../context/NotificationContext";
import apiClient from "../../context/apiClient";
import { useTheme } from "@mui/material/styles";
import { useInView } from "react-intersection-observer";

const AnimatedMatchScore = ({ score }) => {
  const theme = useTheme();
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setProgress(score);
    }, 500);
    return () => clearTimeout(timer);
  }, [score]);
  const getScoreColor = () => {
    if (score >= 70) return theme.palette.primary.main;
    if (score >= 40) return theme.palette.warning.main;
    return theme.palette.error.main;
  };

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        sx={{ color: (theme) => theme.palette.divider }}
        size={56}
        thickness={4}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        value={progress}
        size={56}
        thickness={4}
        sx={{
          color: getScoreColor(),
          position: "absolute",
          left: 0,
          transition: "transform 1s ease-out",
          transform: "rotate(-90deg) !important",
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="subtitle1"
          component="div"
          color="text.primary"
          fontWeight="bold"
          sx={{ fontSize: "14px" }}
        >{`${Math.round(score)}%`}</Typography>
      </Box>
    </Box>
  );
};

const AnimatedJobCard = ({
  job,
  handleViewJob,
  handleSaveJob,
  handleApplyJob,
  handleUndoApplication,
  handleReapplyJob,
  isSaving,
  isApplying,
  showUndoButton,
  showReapplyButton,
  hideSaveButton,
  isSavedTab,
}) => {
  const theme = useTheme();
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  });

  // =================================================================
  // ===== 4.2: USE useMediaQuery FOR RESPONSIVE RENDERING =====
  // =================================================================
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const renderStatusDisplay = (forDesktop) => {
    const commonButtonProps = {
      disabled: true,
      size: "small",
      sx: forDesktop
        ? {
            fontSize: "0.75rem",
            borderRadius: 2,
            px: 2,
            py: 1,
            textTransform: "none",
          }
        : {
            textTransform: "none",
          },
    };

    switch (job.applicationStatus) {
      case "Hired":
        return (
          <Button
            {...commonButtonProps}
            variant="contained"
            startIcon={<CheckCircle />}
            color="success"
            sx={{
              ...commonButtonProps.sx,
              "&.Mui-disabled": {
                backgroundColor: theme.palette.success.main,
                color: theme.palette.success.contrastText,
                opacity: 0.9,
              },
            }}
          >
            Hired
          </Button>
        );

      case "Offer Rejected":
        return (
          <Button
            {...commonButtonProps}
            variant="outlined"
            startIcon={<HighlightOff />}
            color="error"
            sx={{
              ...commonButtonProps.sx,
              "&.Mui-disabled": {
                backgroundColor: alpha(theme.palette.error.main, 0.1),
                borderColor: theme.palette.error.main,
                color: theme.palette.error.main,
              },
            }}
          >
            Offer Rejected
          </Button>
        );

      case "Offer Extended":
        return (
          <Button
            {...commonButtonProps}
            variant="outlined"
            startIcon={<PriorityHigh />}
            sx={{
              ...commonButtonProps.sx,
              "&.Mui-disabled": {
                backgroundColor: alpha(theme.palette.warning.main, 0.2),
                borderColor: theme.palette.warning.main,
                color:
                  theme.palette.mode === "light"
                    ? "#997400"
                    : theme.palette.warning.main,
              },
            }}
          >
            Offer Extended
          </Button>
        );

      default: // Default applied button for "Applied", "Under Review", etc.
        return (
          <Button
            {...commonButtonProps}
            variant="contained"
            startIcon={<CheckCircle />}
            sx={{
              ...commonButtonProps.sx,
              "&.Mui-disabled": {
                backgroundColor: alpha(theme.palette.success.main, 0.2),
                color: "success.dark",
              },
            }}
          >
            {job.applicationStatus || "Applied"}
          </Button>
        );
    }
  };

  const MobileLayout = () => (
    <Stack sx={{ p: 2, gap: 2 }}>
      {/* SECTION 1: HEADER (Logo, Title, Company) */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar
          src={job.logo}
          sx={{ width: 48, height: 48 }}
          alt={`${job.company} logo`}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "1rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {job.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {job.company}
          </Typography>
        </Box>
      </Stack>

      {/* SECTION 2: BODY (Key Details as Chips) */}
      <Stack direction="row" flexWrap="wrap" gap={1}>
        <Chip
          icon={<LocationOn />}
          label={job.location}
          size="small"
          variant="outlined"
        />
        <Chip
          icon={<Work />}
          label={job.experience}
          size="small"
          variant="outlined"
        />
        <Chip
          icon={<AttachMoney />}
          label={job.salary}
          size="small"
          variant="outlined"
        />
        {job.visaSponsorship && (
          <Chip label="Visa Sponsored" size="small" color="primary" />
        )}
      </Stack>

      <Typography variant="caption" color="text.secondary">
        <CalendarToday
          sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
        />
        Posted {job.posted}
      </Typography>

      {/* SEPARATOR */}
      <Divider sx={{ my: 1 }} />

      {/* SECTION 3: FOOTER (AI Score and Actions) */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
          <AnimatedMatchScore score={job.matchScore} />
          <Typography
            variant="caption"
            sx={{
              fontWeight: "bold",
              display: "block",
              mt: 0.5,
              color: "primary.main",
            }}
          >
            AI Match
          </Typography>
        </Box>

        {/* Re-using the same button logic */}
        <Stack direction="row" spacing={1} alignItems="center">
          {job.applied ? (
            job.applicationStatus === "Withdrawn" && showReapplyButton ? (
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleReapplyJob(job.applicationId, job.id);
                }}
                disabled={isApplying === job.id}
                sx={{ textTransform: "none" }}
              >
                Re-apply
              </Button>
            ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleUndoApplication(job.applicationId, job.id);
                }}
                disabled={isApplying === job.id}
                sx={{ textTransform: "none" }}
              >
                Withdraw
              </Button>
            ) : (
              renderStatusDisplay(false)
            )
          ) : (
            <Button
              variant="contained"
              size="small"
              color="primary"
              disabled={isApplying === job.id}
              onClick={(e) => {
                e.stopPropagation();
                handleApplyJob(job.id);
              }}
              sx={{
                textTransform: "none",
              }}
            >
              {isApplying === job.id ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                "Apply"
              )}
            </Button>
          )}
          {!hideSaveButton && (
            <IconButton
              size="small"
              disabled={isSaving === job.id}
              onClick={(e) => {
                e.stopPropagation();
                handleSaveJob(job.id);
              }}
              sx={{
                border: (theme) => `1px solid ${theme.palette.divider}`,
                color: job.saved ? "primary.main" : "text.secondary",
              }}
            >
              {isSaving === job.id ? (
                <CircularProgress size={20} />
              ) : job.saved ? (
                <Bookmark fontSize="small" />
              ) : (
                <BookmarkBorder fontSize="small" />
              )}
            </IconButton>
          )}
        </Stack>
      </Box>
    </Stack>
  );

  const DesktopLayout = () => (
    <Box sx={{ display: "flex", p: 2, width: "100%" }}>
      <Box sx={{ display: "flex", flex: 1, gap: 2 }}>
        <Avatar
          src={job.logo}
          sx={{ width: 48, height: 48, mt: 0.5 }}
          alt={`${job.company} logo`}
        />
        <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "text.primary",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {job.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: "14px", color: "text.secondary", fontWeight: 500 }}
          >
            {job.company}
          </Typography>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography
              variant="body2"
              sx={{ fontSize: "13px", color: "text.secondary" }}
            >
              <LocationOn
                sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
              />
              {job.location}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontSize: "13px", color: "text.secondary" }}
            >
              <Work sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }} />
              {job.experience}
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{ fontSize: "13px", color: "text.secondary" }}
          >
            <AttachMoney
              sx={{ fontSize: 14, verticalAlign: "middle", mr: 0.5 }}
            />
            {job.salary}
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            {job.visaSponsorship && (
              <Chip
                label="Visa Sponsored"
                size="small"
                color="primary"
                sx={{
                  fontSize: "11px",
                  height: "auto",
                  p: "4px 8px",
                }}
              />
            )}
            {job.requirements.slice(0, 5).map((skill, index) => (
              <Chip
                key={index}
                label={skill}
                size="small"
                sx={{
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                  color: "primary.main",
                  border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                  borderRadius: "6px",
                  fontSize: "12px",
                  height: "auto",
                  p: "4px 8px",
                  fontWeight: 600,
                }}
              />
            ))}
          </Box>
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", fontSize: "12px", mt: 1 }}
          >
            <CalendarToday
              sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }}
            />
            Posted {job.posted}
          </Typography>
        </Stack>
      </Box>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ width: "120px", flexShrink: 0, pl: 2 }}
      >
        <Box sx={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
          <AnimatedMatchScore score={job.matchScore} />
          <Chip
            label="AI Match"
            size="small"
            color="primary"
            icon={<TrendingUp />}
            onClick={(e) => e.stopPropagation()}
            sx={{
              fontSize: "11px",
              mt: 1,
              height: "auto",
              p: "4px 8px",
              "& .MuiChip-icon": {
                color: "primary.contrastText",
                fontSize: "14px",
              },
            }}
          />
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          {job.applied ? (
            job.applicationStatus === "Withdrawn" && showReapplyButton ? (
              <Button
                variant="contained"
                color="secondary"
                startIcon={
                  isApplying === job.id ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <ReplayIcon />
                  )
                }
                size="small"
                disabled={isApplying === job.id}
                onClick={(e) => {
                  e.stopPropagation();
                  handleReapplyJob(job.applicationId, job.id);
                }}
                sx={{
                  fontSize: "0.75rem",
                  borderRadius: 2,
                  px: 2,
                  py: 1,
                  textTransform: "none",
                }}
              >
                Re-apply
              </Button>
            ) : showUndoButton && job.applicationStatus !== "Withdrawn" ? (
              <Button
                variant="outlined"
                color="error"
                startIcon={
                  isApplying === job.id ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <UndoIcon />
                  )
                }
                size="small"
                disabled={isApplying === job.id}
                onClick={(e) => {
                  e.stopPropagation();
                  handleUndoApplication(job.applicationId, job.id);
                }}
                sx={{
                  fontSize: "0.75rem",
                  borderRadius: 2,
                  px: 2,
                  py: 1,
                  borderColor: alpha(theme.palette.error.main, 0.5),
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.error.main, 0.08),
                    borderColor: "error.main",
                  },
                }}
              >
                Withdraw
              </Button>
            ) : (
              renderStatusDisplay(true)
            )
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={isApplying === job.id}
              onClick={(e) => {
                e.stopPropagation();
                handleApplyJob(job.id);
              }}
              sx={{
                width: "80px",
                height: "36px",
                fontSize: "13px",
                fontWeight: "bold",
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: theme => `0 4px 12px ${alpha(theme.palette.primary.main, 0.2)}`,
                "&:hover": {
                  boxShadow: theme => `0 6px 16px ${alpha(theme.palette.primary.main, 0.3)}`,
                },
              }}

            >
              {isApplying === job.id ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                "Apply"
              )}
            </Button>
          )}
          {!hideSaveButton && (
            <IconButton
              size="small"
              disabled={isSaving === job.id}
              onClick={(e) => {
                e.stopPropagation();
                handleSaveJob(job.id);
              }}
              sx={{
                border: (theme) => `1px solid ${theme.palette.divider}`,
                color: job.saved ? "primary.main" : "text.secondary",
                mr: isSavedTab ? 1 : 0,
              }}
            >
              {isSaving === job.id ? (
                <CircularProgress size={20} />
              ) : job.saved ? (
                <Bookmark fontSize="small" />
              ) : (
                <BookmarkBorder fontSize="small" />
              )}
            </IconButton>
          )}
        </Stack>
      </Stack>
    </Box>
  );

  return (
    <Card
      ref={ref}
      elevation={0}
      sx={{
        borderRadius: "24px",
        backgroundColor: "background.paper",
        border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        boxShadow: theme => `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(20px)",
        "&:hover": {
          boxShadow: theme => `0 12px 28px ${alpha(theme.palette.primary.main, 0.15)}`,
          transform: "translateY(-4px)",
          borderColor: theme => alpha(theme.palette.primary.main, 0.3),
        },
        cursor: "pointer",
        overflow: "hidden",
      }}
      onClick={() => handleViewJob(job)}
    >
      {/* Conditionally render layouts based on screen size */}
      {isMobile ? <MobileLayout /> : <DesktopLayout />}
    </Card>
  );

};

const JobCardSkeleton = () => {
  return (
    <Card
      elevation={0}
      sx={{
        bgcolor: "background.paper",
        p: 3,
        borderRadius: "24px",
        border: theme => `1px solid ${alpha(theme.palette.divider, 0.1)}`,
      }}
    >
      <Box sx={{ display: "flex", height: "100%", gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <Stack spacing={2}>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Skeleton variant="circular" width={56} height={56} sx={{ bgcolor: theme => alpha(theme.palette.primary.main, 0.05) }} />
              <Box sx={{ flex: 1 }}>
                <Skeleton
                  variant="text"
                  width="80%"
                  height={28}
                  sx={{ mb: 0.5, bgcolor: theme => alpha(theme.palette.primary.main, 0.05) }}
                />
                <Skeleton variant="text" width="60%" height={24} sx={{ bgcolor: theme => alpha(theme.palette.divider, 0.05) }} />
              </Box>
            </Box>

            <Skeleton variant="text" width="40%" height={20} sx={{ ml: 9 }} />
            <Box sx={{ display: "flex", gap: 2, ml: 9 }}>
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={120} height={20} />
            </Box>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", ml: 9 }}>
              {[...Array(4)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width={Math.random() * 40 + 50}
                  height={24}
                  sx={{ borderRadius: 1 }}
                />
              ))}
            </Box>
            <Skeleton variant="text" width="30%" height={20} sx={{ ml: 9 }} />
          </Stack>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            width: "120px",
            flexShrink: 0,
            py: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Skeleton variant="circular" width={80} height={80} />
            <Skeleton
              variant="rectangular"
              width={70}
              height={24}
              sx={{ mt: 1, borderRadius: 2 }}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Skeleton
              variant="rectangular"
              width={60}
              height={36}
              sx={{ borderRadius: 2 }}
            />
            <Skeleton variant="circular" width={36} height={36} />
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

const FilterSkeleton = () => {
  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, backgroundColor: "background.paper" }}
    >
      <Stack spacing={3}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeleton variant="text" width={80} height={28} />
          <Skeleton variant="text" width={60} height={24} />
        </Box>
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 2 }} />
        {[...Array(3)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            height={40}
            sx={{ borderRadius: 2 }}
          />
        ))}
        <Box>
          <Stack spacing={1}>
            {[...Array(2)].map((_, index) => (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Skeleton variant="rectangular" width={20} height={20} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

const TabsSkeleton = () => {
  return (
    <Paper
      square
      elevation={2}
      sx={{ flexShrink: 0, bgcolor: "background.paper" }}
    >
      <Box sx={{ display: "flex", height: 48 }}>
        {[...Array(3)].map((_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
            }}
          >
            <Skeleton variant="text" width={80} height={24} />
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

const JobDialogSkeleton = () => {
  return (
    <>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Skeleton
            variant="circular"
            width={{ xs: 40, sm: 60 }}
            height={{ xs: 40, sm: 60 }}
          />
          <Box sx={{ flexGrow: 1 }}>
            <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="40%" height={28} />
          </Box>
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="circular" width={40} height={40} />
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={3}>
          <Skeleton variant="rectangular" width="100%" height={120} />
          <Skeleton variant="rectangular" width="100%" height={200} />
          <Skeleton variant="rectangular" width="100%" height={150} />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{ p: { xs: 2, sm: 3 }, justifyContent: "flex-end", gap: 1 }}
      >
        <Skeleton
          variant="rectangular"
          width={80}
          height={36}
          sx={{ borderRadius: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={120}
          height={36}
          sx={{ borderRadius: 1 }}
        />
      </DialogActions>
    </>
  );
};

const TabLabel = ({ count, label, color }) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Box
      component="span"
      sx={{
        bgcolor: `${color}.main`,
        color: `${color}.contrastText`,
        borderRadius: "10px",
        px: 0.8,
        py: 0.1,
        minWidth: 20,
        fontSize: "0.75rem",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {count}
    </Box>
    <Typography
      component="span"
      sx={{ textTransform: "none", fontWeight: 500 }}
    >
      {label}
    </Typography>
  </Stack>
);

const SectionCard = ({ children, ...props }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2.5, md: 3 },
      borderRadius: "24px",
      border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
      boxShadow: theme => `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
      bgcolor: "background.paper",
      transition: "transform 0.2s ease",
      "&:hover": {
        borderColor: theme => alpha(theme.palette.primary.main, 0.2),
      }
    }}
    {...props}
  >
    {children}
  </Paper>
);


const SectionHeader = ({ icon, title }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
    <Avatar
      sx={{
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        color: "primary.main",
        width: 32,
        height: 32,
      }}
    >
      {icon}
    </Avatar>
    <Typography variant="h6" fontWeight="bold" color="text.primary">
      {title}
    </Typography>
  </Box>
);

const KeyDetail = ({ icon, label, value }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box color="text.secondary">{icon}</Box>
      <Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", lineHeight: 1.2 }}
        >
          {label}
        </Typography>
        <Typography variant="body2" fontWeight="bold" color="text.primary">
          {value}
        </Typography>
      </Box>
    </Stack>
  </Grid>
);

function JobBrowser() {
  const { showNotification } = useNotification();
  const theme = useTheme();
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openJobDialog, setOpenJobDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(null);
  const [isApplying, setIsApplying] = useState(null);

  const [jobDialogLoading, setJobDialogLoading] = useState(false);
  const [filters, setFilters] = useState({
    location: "",
    experience: "",
    education: "",
  });
  const hasFetchedRef = useRef(false);

  // =================================================================
  // ===== 4.1: USE useCallback FOR HANDLER FUNCTIONS =====
  // =================================================================
  const getErrorMessage = (err, fallback) => {
    if (err && err.response && err.response.data) {
      const d = err.response.data;
      if (typeof d === "string") return d;
      return d.detail || d.message || fallback;
    }
    if (
      typeof err?.message === "string" &&
      err.message.toLowerCase().includes("network")
    ) {
      return "Network error. Please check your connection.";
    }
    return fallback;
  };

  const transformJobData = (apiJob) => ({
    id: apiJob.id,
    title: apiJob.title,
    company: apiJob.company_details?.company_name || "Unknown Company",
    location: apiJob.location,
    salary:
      apiJob.salary_min && apiJob.salary_max
        ? `${apiJob.salary_currency} ${Number.parseFloat(
            apiJob.salary_min
          ).toLocaleString()} - ${Number.parseFloat(
            apiJob.salary_max
          ).toLocaleString()}`
        : "Not Disclosed",
    type: apiJob.job_type_display || apiJob.job_type,
    experience: apiJob.experience_level_display || apiJob.experience_level,
    posted: new Date(apiJob.created_at).toLocaleDateString(),
    logo: apiJob.company_details?.logo || "/placeholder.svg?height=60&width=60",
    description: apiJob.description,
    requirements: apiJob.required_skills || [],
    benefits: apiJob.benefits || [],
    matchScore: 0,
    saved: false,
    applied: false,
    applicationId: null,
    applicationStatus: null,
    urgent: apiJob.status === "URGENT",
    remote: apiJob.remote_work,
    visaSponsorship: apiJob.visa_sponsorship,
    responsibilities: apiJob.responsibilities,
    applicationDeadline: apiJob.application_deadline,
  });

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [
          jobsResponse,
          aiScoresResponse,
          savedJobsResponse,
          applicationsResponse,
        ] = await Promise.all([
          apiClient.get("/job-postings/"),
          apiClient.get("/job-postings/ai-score/"),
          apiClient.get("/saved-jobs/"),
          apiClient.get("/applications/"),
        ]);
        const jobsData = jobsResponse.data
          .filter((j) => j.status === "PUBLISHED")
          .map(transformJobData);
        const aiScoresData = aiScoresResponse.data;
        const savedJobIds = new Set(
          savedJobsResponse.data.map((sj) => sj.job_posting.id)
        );
        const applicationsData = applicationsResponse.data;
        const applicationsMap = new Map(
          applicationsData.map((app) => {
            const appStatus = app.status_display || app.status;
            return [
              app.job_posting,
              {
                id: app.id,
                status: appStatus === "Deleted" ? "Withdrawn" : appStatus,
              },
            ];
          })
        );
        const finalJobs = jobsData.map((job) => {
          const aiScore = aiScoresData.find((score) => score.id === job.id);
          const applicationDetails = applicationsMap.get(job.id);
          return {
            ...job,
            matchScore: aiScore ? Math.round(aiScore.matching_percentage) : 0,
            saved: savedJobIds.has(job.id),
            applied: !!applicationDetails,
            applicationId: applicationDetails?.id || null,
            applicationStatus: applicationDetails?.status || null,
          };
        });
        finalJobs.sort((a, b) => b.matchScore - a.matchScore);
        setJobs(finalJobs);
        setFilteredJobs(finalJobs);
      } catch (err) {
        const errorMessage = getErrorMessage(
          err,
          "Failed to load data. Please try again."
        );
        setError(errorMessage);
        showNotification(errorMessage, "error");
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [showNotification]);

  const filterJobs = useCallback(
    (search, currentFilters, currentTab, baseJobs = jobs) => {
      let sourceJobs = [...baseJobs];
      if (currentTab === 1) {
        sourceJobs = baseJobs.filter((job) => job.saved);
      } else if (currentTab === 2) {
        sourceJobs = baseJobs.filter(
          (job) => job.applied && job.applicationStatus !== "Withdrawn"
        );
      } else if (currentTab === 3) {
        sourceJobs = baseJobs.filter(
          (job) => job.applied && job.applicationStatus === "Withdrawn"
        );
      }
      const filtered = sourceJobs.filter((job) => {
        const searchTermLower = search.toLowerCase();
        const matchesSearch =
          search === "" ||
          job.title.toLowerCase().includes(searchTermLower) ||
          job.company.toLowerCase().includes(searchTermLower);
        const matchesLocation =
          !currentFilters.location ||
          job.location
            .toLowerCase()
            .includes(currentFilters.location.toLowerCase());
        const matchesExperience =
          !currentFilters.experience ||
          job.experience === currentFilters.experience;
        const matchesEducation =
          !currentFilters.education ||
          job.education === currentFilters.education;
        return (
          matchesSearch &&
          matchesLocation &&
          matchesExperience &&
          matchesEducation
        );
      });
      setFilteredJobs(filtered);
    },
    [jobs]
  );

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    filterJobs(searchTerm, filters, newValue);
  };
  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    filterJobs(term, filters, tabValue);
  };
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    filterJobs(searchTerm, newFilters, tabValue);
  };
  const clearAllFilters = () => {
    const newFilters = {
      location: "",
      experience: "",
      education: "",
    };
    setFilters(newFilters);
    setSearchTerm("");
    filterJobs("", newFilters, tabValue);
  };

  const handleSaveJob = useCallback(
    async (jobId) => {
      setIsSaving(jobId);
      const jobToUpdate = jobs.find((j) => j.id === jobId);
      const isCurrentlySaved = jobToUpdate.saved;
      try {
        if (isCurrentlySaved) {
          await apiClient.delete(`/saved-jobs/unsave/`, {
            data: { job_posting_id: jobId },
          });
        } else {
          await apiClient.post(`/saved-jobs/save/`, { job_posting_id: jobId });
        }
        const updatedJobs = jobs.map((j) =>
          j.id === jobId ? { ...j, saved: !isCurrentlySaved } : j
        );
        setJobs(updatedJobs);
        showNotification(
          isCurrentlySaved
            ? "Job removed from saved list"
            : "Job saved successfully!",
          "success"
        );
        filterJobs(searchTerm, filters, tabValue, updatedJobs);
      } catch (error) {
        showNotification(
          getErrorMessage(error, "Failed to update job status."),
          "error"
        );
      } finally {
        setIsSaving(null);
      }
    },
    [jobs, searchTerm, filters, tabValue, showNotification, filterJobs]
  );

  const handleApplyJob = useCallback(
    async (jobId) => {
      setIsApplying(jobId);
      try {
        const response = await apiClient.post("/applications/", {
          job_posting: jobId,
        });
        const newApplication = response.data;
        const updatedJobs = jobs.map((job) =>
          job.id === jobId
            ? {
                ...job,
                applied: true,
                applicationId: newApplication.id,
                applicationStatus:
                  newApplication.status_display || newApplication.status,
              }
            : job
        );
        setJobs(updatedJobs);
        showNotification("Application submitted successfully!", "success");
        filterJobs(searchTerm, filters, tabValue, updatedJobs);
        if (openJobDialog) {
          setSelectedJob(updatedJobs.find((j) => j.id === jobId));
        }
      } catch (error) {
        showNotification(
          getErrorMessage(error, "Failed to submit application."),
          "error"
        );
      } finally {
        setIsApplying(null);
      }
    },
    [
      jobs,
      searchTerm,
      filters,
      tabValue,
      showNotification,
      filterJobs,
      openJobDialog,
    ]
  );

  const handleReapplyJob = useCallback(
    async (applicationId, jobId) => {
      setIsApplying(jobId);
      try {
        const response = await apiClient.patch(
          `/applications/${applicationId}/`,
          {
            status: "SUBMITTED",
          }
        );
        const updatedApplication = response.data;
        const updatedJobs = jobs.map((job) =>
          job.id === jobId
            ? {
                ...job,
                applicationStatus:
                  updatedApplication.status_display ||
                  updatedApplication.status,
              }
            : job
        );
        setJobs(updatedJobs);
        showNotification("Re-applied to job successfully!", "success");
        setTabValue(0);
        filterJobs(searchTerm, filters, 0, updatedJobs);
        if (openJobDialog) {
          setSelectedJob(updatedJobs.find((j) => j.id === jobId));
        }
      } catch (error) {
        showNotification(
          getErrorMessage(error, "Failed to re-apply."),
          "error"
        );
      } finally {
        setIsApplying(null);
      }
    },
    [jobs, searchTerm, filters, showNotification, filterJobs, openJobDialog]
  );

  const handleUndoApplication = useCallback(
    async (applicationId, jobId) => {
      setIsApplying(jobId);
      try {
        await apiClient.delete(`/applications/${applicationId}/delete/`);
        const updatedJobs = jobs.map((job) =>
          job.id === jobId
            ? {
                ...job,
                applied: true, // It's still an application, just withdrawn
                applicationStatus: "Withdrawn",
              }
            : job
        );
        setJobs(updatedJobs);
        showNotification("Application successfully withdrawn!", "success");

        filterJobs(searchTerm, filters, tabValue, updatedJobs);

        if (openJobDialog) {
          setSelectedJob(updatedJobs.find((j) => j.id === jobId));
        }
      } catch (error) {
        showNotification(
          getErrorMessage(error, "Failed to withdraw application."),
          "error"
        );
      } finally {
        setIsApplying(null);
      }
    },
    [
      jobs,
      searchTerm,
      filters,
      tabValue,
      showNotification,
      filterJobs,
      openJobDialog,
    ]
  );

  const handleViewJob = useCallback((job) => {
    setSelectedJob(job);
    setOpenJobDialog(true);
    setJobDialogLoading(true);
    setTimeout(() => {
      setJobDialogLoading(false);
    }, 800);
  }, []); // State setters are stable and don't need to be in the dependency array

  if (loading) {
    return (
      <Layout title="Global Job Opportunities">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
            p: { xs: 1, sm: 2, md: 3 },
            bgcolor: "background.default",
          }}
        >
          <Box sx={{ flexShrink: 0, mb: 2 }}>
            <TabsSkeleton />
          </Box>
          <Box sx={{ mb: 3 }}>
            <FilterSkeleton />
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
            <Stack spacing={2.5}>
              {[...Array(4)].map((_, index) => (
                <JobCardSkeleton key={index} />
              ))}
            </Stack>
          </Box>
        </Box>
      </Layout>
    );
  }
  if (error) {
    return (
      <Layout title="Global Job Opportunities">
        <Box sx={{ p: 3 }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </Layout>
    );
  }
  const allJobsCount = jobs.length;
  const savedJobsCount = jobs.filter((j) => j.saved).length;
  const appliedJobsCount = jobs.filter(
    (j) => j.applied && j.applicationStatus !== "Withdrawn"
  ).length;

  const renderFilterBar = () => (
    <Paper
      elevation={0}
      sx={{
        p: "16px",
        borderRadius: "24px",
        bgcolor: "background.paper",
        border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
        boxShadow: theme => `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
        mb: 4,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "4px",
          height: "100%",
          bgcolor: "primary.main",
        }
      }}
    >

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4} lg={5}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search Jobs, Companies"
            value={searchTerm}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              sx: { borderRadius: "8px", fontSize: "14px" },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={2}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              value={filters.location}
              name="location"
              onChange={handleFilterChange}
              sx={{
                borderRadius: "8px",
                fontSize: "13px",
                color: filters.location ? "inherit" : "text.secondary",
              }}
            >
              <MenuItem value="">Location</MenuItem>
              {[...new Set(jobs.map((job) => job.location))]
                .sort()
                .map((loc) => (
                  <MenuItem key={loc} value={loc}>
                    {loc}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={2}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              value={filters.education}
              name="education"
              onChange={handleFilterChange}
              sx={{
                borderRadius: "8px",
                fontSize: "13px",
                color: filters.education ? "inherit" : "text.secondary",
              }}
            >
              <MenuItem value="">Education</MenuItem>
              <MenuItem value="bachelor">Bachelor's</MenuItem>
              <MenuItem value="master">Master's</MenuItem>
              <MenuItem value="phd">PhD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={2}>
          <FormControl fullWidth>
            <Select
              displayEmpty
              value={filters.experience}
              name="experience"
              onChange={handleFilterChange}
              sx={{
                borderRadius: "8px",
                fontSize: "13px",
                color: filters.experience ? "inherit" : "text.secondary",
              }}
            >
              <MenuItem value="">Experience</MenuItem>
              {[...new Set(jobs.map((job) => job.experience))]
                .sort()
                .map((exp) => (
                  <MenuItem key={exp} value={exp}>
                    {exp}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md="auto">
          <Button
            onClick={clearAllFilters}
            sx={{
              textTransform: "none",
              color: "primary.main",
              fontWeight: "bold",
            }}
          >
            Clear Filter
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
  return (
    <Layout title="Global Job Opportunities">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - 1px)`,
          p: { xs: 1, sm: 2, md: 3 },
          bgcolor: "background.default",
        }}
      >
        <Paper
          square
          elevation={0}
          sx={{
            flexShrink: 0,
            mb: 2,
            backgroundColor: "transparent",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            centered
            sx={{
              "& .MuiTab-root": {
                fontSize: "0.95rem",
                fontWeight: "bold",
                minHeight: "64px",
                transition: "all 0.3s ease",
                opacity: 0.7,
                "&.Mui-selected": {
                  opacity: 1,
                  color: "primary.main",
                }
              },
              "& .MuiTabs-indicator": {
                height: "3px",
                borderRadius: "3px",
                bgcolor: "primary.main",
              }
            }}
          >

            <Tab
              label={
                <TabLabel
                  count={allJobsCount}
                  label="All Jobs"
                  color="primary"
                />
              }
            />
            <Tab
              label={
                <TabLabel
                  count={savedJobsCount}
                  label="Saved"
                  color="secondary"
                />
              }
            />
            <Tab
              label={
                <TabLabel
                  count={appliedJobsCount}
                  label="Applied"
                  color="success"
                />
              }
            />
          </Tabs>
        </Paper>
        {renderFilterBar()}
        <Box sx={{ flex: 1, overflowY: "auto", pr: 0.5 }}>
          <Stack spacing={2.5}>
            {filteredJobs.length > 0 ? (
              filteredJobs.map((job) => (
                <AnimatedJobCard
                  key={job.id}
                  job={job}
                  handleViewJob={handleViewJob}
                  handleSaveJob={handleSaveJob}
                  handleApplyJob={handleApplyJob}
                  handleUndoApplication={handleUndoApplication}
                  handleReapplyJob={handleReapplyJob}
                  isSaving={isSaving}
                  isApplying={isApplying}
                  showUndoButton={tabValue === 2}
                  showReapplyButton={tabValue === 3}
                  hideSaveButton={tabValue === 2}
                  isSavedTab={tabValue === 1}
                />
              ))
            ) : (
              <Box
                sx={{
                  p: 6,
                  textAlign: "center",
                  borderRadius: "24px",
                  border: (theme) => `1px dashed ${alpha(theme.palette.primary.main, 0.25)}`,
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
                }}
              >
                <Work sx={{ fontSize: 64, color: (theme) => alpha(theme.palette.primary.main, 0.4), mb: 2 }} />
                <Typography
                  variant="h5"
                  color="text.primary"
                  gutterBottom
                  fontWeight={800}
                >
                  No jobs found
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Try adjusting your filters or search terms
                </Typography>
              </Box>
            )}
          </Stack>
        </Box>
      </Box>
      <Dialog
        open={openJobDialog}
        onClose={() => setOpenJobDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
            borderRadius: "28px",
            bgcolor: "background.paper",
            border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            boxShadow: theme => `0 24px 80px ${alpha(theme.palette.common.black, 0.3)}`,
            backgroundImage: "none",
          }
        }}
      >

        {jobDialogLoading ? (
          <JobDialogSkeleton />
        ) : (
          selectedJob &&
          (() => {
            const currentJobState =
              jobs.find((j) => j.id === selectedJob.id) || selectedJob;
            return (
              <>
                <DialogTitle
                  sx={{
                    bgcolor: "background.paper",
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar
                      src={currentJobState.logo}
                      sx={{
                        width: 60,
                        height: 60,
                        border: `2px solid ${theme.palette.divider}`,
                        boxShadow: 1,
                      }}
                    />
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        color="text.primary"
                      >
                        {currentJobState.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {currentJobState.company}
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "flex" } }}>
                      <IconButton
                        disabled={isSaving === currentJobState.id}
                        onClick={() => handleSaveJob(currentJobState.id)}
                      >
                        {isSaving === currentJobState.id ? (
                          <CircularProgress size={24} />
                        ) : currentJobState.saved ? (
                          <Bookmark color="primary" />
                        ) : (
                          <BookmarkBorder />
                        )}
                      </IconButton>
                      <IconButton>
                        <Share />
                      </IconButton>
                    </Box>
                  </Box>
                </DialogTitle>
                <DialogContent
                  sx={{ bgcolor: "background.default", p: { xs: 2, md: 3 } }}
                >
                  <Stack spacing={3}>
                    <SectionCard>
                      <Grid container spacing={2} rowSpacing={3}>
                        <Grid item xs={12} sm={6} md={8}>
                          <Stack spacing={2}>
                            <KeyDetail
                              icon={<AttachMoney />}
                              label="Salary"
                              value={currentJobState.salary}
                            />
                            <KeyDetail
                              icon={<LocationOn />}
                              label="Location"
                              value={currentJobState.location}
                            />
                            <KeyDetail
                              icon={<Business />}
                              label="Experience"
                              value={currentJobState.experience}
                            />
                            <KeyDetail
                              icon={<Work />}
                              label="Job Type"
                              value={currentJobState.type}
                            />
                          </Stack>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Box sx={{ textAlign: "center" }}>
                            <AnimatedMatchScore
                              score={currentJobState.matchScore}
                            />
                            <Typography
                              variant="caption"
                              fontWeight="bold"
                              color="primary.main"
                              sx={{ mt: 1, display: "block" }}
                            >
                              AI MATCH SCORE
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </SectionCard>
                    <SectionCard>
                      <SectionHeader
                        icon={<Description fontSize="small" />}
                        title="Job Description"
                      />
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: "pre-wrap",
                          lineHeight: 1.7,
                          color: "text.secondary",
                        }}
                      >
                        {currentJobState.description}
                      </Typography>
                    </SectionCard>
                    {currentJobState.responsibilities && (
                      <SectionCard>
                        <SectionHeader
                          icon={<PlaylistAddCheck fontSize="small" />}
                          title="Responsibilities"
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "pre-wrap",
                            lineHeight: 1.7,
                            color: "text.secondary",
                          }}
                        >
                          {currentJobState.responsibilities}
                        </Typography>
                      </SectionCard>
                    )}
                    <SectionCard>
                      <SectionHeader
                        icon={<Category fontSize="small" />}
                        title="Required Skills"
                      />
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {currentJobState.requirements.map((skill, index) => (
                          <Chip
                            key={index}
                            label={skill}
                            variant="outlined"
                            color="primary"
                          />
                        ))}
                      </Box>
                    </SectionCard>
                    <SectionCard>
                      <SectionHeader
                        icon={<Stars fontSize="small" />}
                        title="Benefits & Perks"
                      />
                      <List
                        dense
                        sx={{ p: 0, "&& .Mui-ListItem-root": { py: 0.5 } }}
                      >
                        {currentJobState.benefits.map((benefit, index) => (
                          <ListItem key={index} disableGutters>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <CheckCircle
                                color="success"
                                sx={{ fontSize: 20 }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={benefit}
                              primaryTypographyProps={{
                                color: "text.secondary",
                                fontWeight: 500,
                              }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </SectionCard>
                  </Stack>
                </DialogContent>
                <DialogActions
                  sx={{
                    p: { xs: 2, sm: 3 },
                    justifyContent: "flex-end",
                    gap: 2,
                    bgcolor: "background.paper",
                    borderTop: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Button
                    onClick={() => setOpenJobDialog(false)}
                    variant="outlined"
                    color="secondary"
                  >
                    Close
                  </Button>
                  {tabValue === 3 &&
                  currentJobState.applied &&
                  currentJobState.applicationStatus === "Withdrawn" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={
                        isApplying === currentJobState.id ? (
                          <CircularProgress size={16} color="inherit" />
                        ) : (
                          <ReplayIcon />
                        )
                      }
                      size="medium"
                      disabled={isApplying === currentJobState.id}
                      onClick={() =>
                        handleReapplyJob(
                          currentJobState.applicationId,
                          currentJobState.id
                        )
                      }
                      sx={{
                        px: 4,
                        borderRadius: "12px",
                        fontWeight: "bold",
                        boxShadow: theme => `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
                      }}
                    >

                      {isApplying === currentJobState.id ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Re-apply Now"
                      )}
                    </Button>
                  ) : tabValue === 2 &&
                    currentJobState.applied &&
                    currentJobState.applicationStatus !== "Withdrawn" ? (
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={
                        isApplying === currentJobState.id ? (
                          <CircularProgress size={10} color="inherit" />
                        ) : (
                          <UndoIcon />
                        )
                      }
                      size="small"
                      disabled={isApplying === currentJobState.id}
                      onClick={() =>
                        handleUndoApplication(
                          currentJobState.applicationId,
                          currentJobState.id
                        )
                      }
                      sx={{
                        fontSize: "0.65rem",
                        borderRadius: 1,
                        borderColor: alpha(theme.palette.error.main, 0.2),
                        "&:hover": {
                          backgroundColor: alpha(
                            theme.palette.error.main,
                            0.08
                          ),
                          borderColor: "error.main",
                        },
                      }}
                    >
                      Withdraw
                    </Button>
                  ) : currentJobState.applied ? (
                    (() => {
                      const status = currentJobState.applicationStatus;
                      const commonProps = {
                        disabled: true,
                        variant: "contained",
                      };

                      switch (status) {
                        case "Hired":
                          return (
                            <Button
                              {...commonProps}
                              startIcon={<CheckCircle />}
                              color="success"
                              sx={{
                                "&.Mui-disabled": {
                                  backgroundColor: theme.palette.success.main,
                                  color: theme.palette.success.contrastText,
                                  opacity: 0.9,
                                },
                              }}
                            >
                              Status: Hired
                            </Button>
                          );
                        case "Offer Rejected":
                          return (
                            <Button
                              {...commonProps}
                              variant="outlined"
                              startIcon={<HighlightOff />}
                              color="error"
                              sx={{
                                "&.Mui-disabled": {
                                  backgroundColor: alpha(
                                    theme.palette.error.main,
                                    0.1
                                  ),
                                  borderColor: theme.palette.error.main,
                                  color: theme.palette.error.main,
                                },
                              }}
                            >
                              Status: Offer Rejected
                            </Button>
                          );
                        case "Offer Extended":
                          return (
                            <Button
                              {...commonProps}
                              variant="outlined"
                              startIcon={<PriorityHigh />}
                              sx={{
                                "&.Mui-disabled": {
                                  backgroundColor: alpha(
                                    theme.palette.warning.main,
                                    0.2
                                  ),
                                  borderColor: theme.palette.warning.main,
                                  color:
                                    theme.palette.mode === "light"
                                      ? "#997400"
                                      : theme.palette.warning.main,
                                },
                              }}
                            >
                              Status: Offer Extended
                            </Button>
                          );
                        default:
                          return (
                            <Button
                              {...commonProps}
                              startIcon={<CheckCircle />}
                              sx={{
                                "&.Mui-disabled": {
                                  backgroundColor: alpha(
                                    theme.palette.success.main,
                                    0.2
                                  ),
                                  color: "success.dark",
                                },
                              }}
                            >
                              Status: {status || "Applied"}
                            </Button>
                          );
                      }
                    })()
                  ) : (
                    <Button
                      variant="contained"
                      disabled={isApplying === currentJobState.id}
                      onClick={() => handleApplyJob(currentJobState.id)}
                      sx={{
                        px: 6,
                        py: 1.5,
                        borderRadius: "12px",
                        fontWeight: "bold",
                        boxShadow: theme => `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
                      }}
                    >
                      {isApplying === currentJobState.id ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Apply Now"
                      )}
                    </Button>

                  )}
                </DialogActions>
              </>
            );
          })()
        )}
      </Dialog>
    </Layout>
  );
}

export default JobBrowser;
